/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useMemo, useRef, useState } from 'react';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import Forward5RoundedIcon from '@mui/icons-material/Forward5Rounded';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import MoreHorizOutlinedIcon from '@mui/icons-material/MoreHorizOutlined';
import Replay5RoundedIcon from '@mui/icons-material/Replay5Rounded';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import WestRoundedIcon from '@mui/icons-material/WestRounded';
import { Avatar } from '@mui/material';
import { Field, Formik, Form as FormikForm } from 'formik';
import Hls from 'hls.js';
import Cookies from 'js-cookie';
import moment from 'moment';
import {
  Button,
  Col,
  Collapse,
  Container,
  Dropdown,
  Form,
  Modal,
  NavItem,
  NavLink,
  Row,
  Spinner,
} from 'react-bootstrap';
import ReactDOMServer from 'react-dom/server';
import toast from 'react-hot-toast';
import { FaPlus } from 'react-icons/fa6';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';
import * as Yup from 'yup';
import { usePageTitle } from '../../../../App';
import alert_icon from '../../../../assets/images/alert-img.svg';
import bookmark_icon from '../../../../assets/images/bookmark.svg';
import chat_icon from '../../../../assets/images/chat-dots-icon.svg';
import command_icon from '../../../../assets/images/command-icon.svg';
import document_icon from '../../../../assets/images/document-icon.svg';
import half_timer_icon from '../../../../assets/images/half-timer.svg';
import headphone_icon from '../../../../assets/images/headphone-icon.svg';
import no_data_img from '../../../../assets/images/no-data-img.svg';
import rounded_icon from '../../../../assets/images/rounded-icon.svg';
import saveCloud from '../../../../assets/images/saveCloud.svg';
import translate_icon from '../../../../assets/images/translate-icon.svg';
import Datagain_Style_Guide from '../../../../assets/pdf/Datagain_Style_Guide.pdf';
import { CustomTooltips } from '../../../../components';
import CustomAlert from '../../../../components/CustomAlert';
import {
  PROOFREADER_CHECK_FORCE_UNCLAIM_API_URL,
  PROOFREADER_NEXT_TRANSCRIPT_SUBMIT_URL,
  PROOFREADER_SAVE_TRANSCRIPT_PARAGRAPH_FILE_URL,
  SAVE_TRANSCRIPTION_CONFIGURATION_API_URL,
  TRANSCRIPT_COMPLETE_PARAGRAPH_API_URL,
} from '../../../../constants/ApiUrlConstants';
import { AUTO_SAVE_TIME, BASE_URL, IMAGE_URL, UNDO_REDO_STACK_LIMIT } from '../../../../constants/Config';
import { formatDateWithMilliseconds } from '../../../../constants/CurrentTimeFormet';
import { DASHBOARD_ROUTE } from '../../../../constants/RouteNameConstants';
import { fontSizeOptions, rewindPushTimeOptions, videoExtensions } from '../../../../constants/SlectOptionConstants';
import { postApiRequest } from '../../../../features/axiosClient';
import { truncateString } from '../../../../utils/TruncateStringUtils';
import { getUserInfo } from '../../../../utils/UserInfoUtils';
import { UserLogout } from '../../../../utils/UserLogout';
import { resetDdashboardProofreader } from '../../Dashboard/actions';
import { resetProofreaderAllFiles } from '../../Files/AllFiles/actions';
import {
  addSpeakersRequest,
  checkForceUnclaimRequest,
  deleteSpeakersRequest,
  editorDocumentRequest,
  editorRequest,
  getAllSpeakersRequest,
  proofreaderUnClaimRequest,
  removeUnusedSpeakersRequest,
  resetAllSpeakrsData,
  resetEditorData,
  resetEditorDocumentData,
  resetVendorNextTranscript,
  updateSpeakersRequest,
  vendorDetailsRequest,
  vendorNextTranscriptRequest,
  vendorProofreaderCommentRequest,
  vendorResolveProofreaderRequest,
  VendorRoleEditorSubmitRequest,
} from '../actions';
import playIcon from './images/play.svg';
import ProofreaderSubmitModal from './ProofreaderSubmitModal';
import Timer from './Timer';

const createWorker = () => {
  const workerCode = `
    self.onmessage = async function (event) {
      const { url, options } = event.data;
      try {
        const response = await fetch(url, options);
        const data = await response.json();

        if (response.status === 401) {
          self.postMessage({ type: "SESSION_EXPIRED" });
        } else {
          self.postMessage({ success: true, data });
        }
      } catch (error) {
        self.postMessage({ success: false, error: error.message });
      }
    };
  `;

  const blob = new Blob([workerCode], { type: 'application/javascript' });
  return new Worker(URL.createObjectURL(blob));
};

const createWorkerPlayer = () => {
  const workerCode = `
    self.onmessage = function (event) {
      const { currentTime, words } = event.data;
      let highlightedIndex = -1;

      for (let i = 0; i < words.length; i++) {
        const startTime = words[i].start;
        const nextStartTime = i + 1 < words.length ? words[i + 1].start : Infinity;

        if (currentTime >= startTime && currentTime < nextStartTime) {
          highlightedIndex = words[i].index;
          break;
        }
      }

      self.postMessage({ highlightedIndex });
    };
  `;

  const blob = new Blob([workerCode], { type: 'application/javascript' });
  return new Worker(URL.createObjectURL(blob));
};

const EditorPage = ({
  usePreviousPath,
  todayWorkClick,
  setTodayWorkClick,
  isSaveTranscriptInProgressRef,
  isTempSaveTranscript,
  handleFilterClear,
  setFullQcClick,
  setQcClick,
  setDueInDayClick,
  setDueInHalfDayClick,
  setLegalClick,
  setDashboardClick,
  claimFile,
  allSpeakersRef,
}) => {
  usePageTitle('Datagain Transcription  - Editor'); // Set tab title

  const audioParagraphRef = useRef(null);
  const contentRefNew = useRef([]);
  const singleReplaceSpanIndexRef = useRef(null);
  const videoRef = useRef(null);
  const contentRef = useRef([]);
  const isMounted = useRef(false);
  const audioPlayerRef = useRef(null);
  const uniqueParentFileIdsRef = useRef([]);
  const commonErrorsOptionRef = useRef('0');
  const isCaseSensitiveRef = useRef(false);
  const isMatchFullWordRef = useRef(false);
  const findTextArrayRef = useRef([]);
  const isReplaceTextDisabledRef = useRef(false);
  const completedPercentageRef = useRef(null);
  const transcriptClaimIdRef = useRef(null);
  const totalAudioParagraphsRef = useRef(0);
  const selectedAudioParagraphsRef = useRef(0);
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  const speakerTragetRef = useRef(null);
  const apiCalledRef = useRef(false);
  const dropdownOpenRef = useRef(false);
  const didSetInitialSpeakers = useRef(false);
  const speakerCreateRef = useRef(false);
  const checkboxManualTrigger = useRef(false);
  const keyDownTrigger = useRef(false);
  const isCatchedOriginalData = useRef(false);
  const jKS647HasClass = useRef('');
  const speakerName = useRef('');
  const lastSavedTime = useRef('');
  const isInputClicked = useRef(false);
  const trnascriptSpanWords = useRef([]);
  const selectedValueRewindPushTime = useRef('5');
  const containerRef = useRef(null);

  const [buffered, setBuffered] = useState(0);
  const [isSeeking, setIsSeeking] = useState(false);
  const [videoSrc, setVideoSrc] = useState(null);
  const [selectedValueRewindPushTimeState, setselectedValueRewindPushTime] = useState('5');
  const [singleReplaceSpanId, setSingleReplaceSpanId] = useState(null);
  const [undoStackClass, setUndoStackClass] = useState([]);
  const [redoStackClass, setRedoStackClass] = useState([]);
  const [isCaseSensitive, setIsCaseSensitive] = useState(false);
  const [isMatchFullWord, setIsMatchFullWord] = useState(false);
  const [isFillerWords, setIsFillerWords] = useState(false);
  const [findText, setFindText] = useState('');
  const [replacedTextArray, setReplacedTextArray] = useState([]);
  const [replaceText, setReplaceText] = useState('');
  const [findReplaceShow, setFindReplaceShow] = useState(false);
  const [isCommonErrors, setIsCommonErrors] = useState(false);
  const [isAllTranscriptLoad, setIsAllTranscriptLoad] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const [fontSize, setFontSize] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpenComment, setDropdownOpenComment] = useState(false);
  const [open, setOpen] = useState(false);
  const [moreShow, setMoreShow] = useState(false);
  const [keyboardShortcutsShow, setKeyboardShortcutsShow] = useState(false);
  const [documentsShow, setDocumentsShow] = useState(false);
  const [unclaimShow, setUnclaimShow] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [warningShow, setwarningShow] = useState(usePreviousPath === true && todayWorkClick === true ? true : false);
  const [vendorSubmitConfirmModal, setVendorSubmitConfirmModal] = useState(false);
  const [resourceConfirmOpen, setResourceConfirmOpen] = useState(false);
  const [confiemResolved, setConfiemResolved] = useState(false);
  const [submitShow, setSubmitShow] = useState(false);
  const [saveTranscriptHtmlData, setSaveTranscriptHtmlData] = useState(null);
  const [saveTranscriptHtmlParentFileIds, setSaveTranscriptHtmlParentFileIds] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [isUnsavedChangesModalVisible, setIsUnsavedChangesModalVisible] = useState(false);
  const [isContinueKeyPressModalVisible, setIsContinueKeyPressModalVisible] = useState(false);
  const [errorSpeakerNamePopup, setErrorSpeakerNamePopup] = useState('');
  const [speakerNameCreate, setSpeakerNameCreate] = useState(false);
  const [isSaveTranscript, setIsSaveTranscript] = useState(false);
  const [restoreModalVisible, setRestoreModalVisible] = useState(false);
  const [nextTranscriptDataLoading, setnextTranscriptDataLoading] = useState(false);
  const [getContent, setGetContent] = useState(null);
  const [content, setContent] = useState([]);
  const [restoreButton, setRestorebutton] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userInfo = getUserInfo();
  const { id } = useParams();
  const location = useLocation();
  const fillerWords = ['ah', 'uh', 'um'];

  let isSaveScheduled = false;

  const removingUnidentifySpan = () => {
    const jks647 = document?.querySelector('.jks647');
    const elements = [...(jks647?.querySelectorAll('p.cb-m.inputwidthmachine span[id]') || [])].filter((el) =>
      /^\d+_\d+$/.test(el.id),
    );
    elements?.forEach((span) => span.replaceWith(document.createTextNode(span.textContent)));
  };

  const transcriptSaveInprogressToaster = (msg) => {
    toast(msg, {
      icon: '⚠️',
      position: 'top-center',
      style: {
        background: '#f0ad4e',
        color: '#fff',
        width: '450px',
      },
    });
  };

  const removeHighlightSpans = (html) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    tempDiv.querySelectorAll('span.highlight').forEach((span) => {
      span.classList.remove('highlight');
    });
    return tempDiv.innerHTML;
  };

  const undoRedoManage = (type = 0) => {
    let currentContent = null;
    // input
    if (type === 1) {
      currentContent = content?.map((item, index) => ({
        parentFileParagraphId: item?.parentFileParagraphId,
        fileData: isCatchedOriginalData.current ? contentRef?.current[index]?.innerHTML : item?.fileData,
      }));
      isCatchedOriginalData.current = true;
    } else if (type === 2) {
      //checkbox
      currentContent = contentRefNew?.current?.map((item, index) => ({
        parentFileParagraphId: item?.parentFileParagraphId,
        fileData: contentRef?.current[index]?.innerHTML,
      }));
    } else {
      currentContent = content?.map((item, index) => ({
        parentFileParagraphId: item?.parentFileParagraphId,
        fileData: contentRef?.current[index]?.innerHTML,
      }));
      isCatchedOriginalData.current = true;
    }
    setUndoStackClass((prev) => {
      const newUndoStack = [...prev, currentContent];
      if (newUndoStack?.length > UNDO_REDO_STACK_LIMIT) {
        newUndoStack?.shift();
      }
      return newUndoStack;
    });
  };

  const debouncedSaveEditTranscriptChanges = debounceCall(saveEditTranscriptChanges, AUTO_SAVE_TIME);
  const backSaveEditTranscriptChanges = debounceCall(saveEditTranscriptChanges, 0);

  const setDebounceValues = (isApplytoAll = false) => {
    if (isSaveTranscriptInProgressRef.current !== 1) {
      isSaveTranscriptInProgressRef.current = 1;
      debouncedSaveEditTranscriptChanges();
    }
  };

  const setDropDownClosed = () => {
    setDropdownOpen(false);
    dropdownOpenRef.current = false;
    speakerTragetRef.current = null;
  };

  const setDropDownOpen = () => {
    setDropdownOpen(true);
    dropdownOpenRef.current = true;
    setSpeakerNameCreate(false);
  };

  useEffect(() => {
    if (id === null) {
      navigate(DASHBOARD_ROUTE);
    }
  }, [id, navigate, location]);

  const findPreviousSpanTextClicked = (clickedSpan, wordCount = 0) => {
    let previousSpanText = '';
    let currentElement = clickedSpan;
    let wordsFound = 0;

    // Function to process text and update word count
    const processText = (text) => {
      const words = text
        .trim()
        .split(/\s+/)
        .filter((word) => word.trim() !== '');
      if (words.length > 0) {
        // Take only the number of words we need
        const remainingWords = 5 - wordsFound;
        const relevantWords = words.slice(-remainingWords);
        previousSpanText = relevantWords.join(' ') + ' ' + previousSpanText;
        wordsFound += relevantWords.length;
      }
      return wordsFound >= 5;
    };

    // Function to process a node and its previous siblings
    const processPreviousSiblings = (node) => {
      let currentNode = node;

      while (currentNode && wordsFound < 5) {
        let previousSibling = currentNode.previousSibling;

        while (previousSibling && wordsFound < 5) {
          // Handle text nodes
          if (previousSibling.nodeType === Node.TEXT_NODE) {
            if (processText(previousSibling.textContent)) return true;
          }
          // Handle span elements
          else if (previousSibling.nodeType === Node.ELEMENT_NODE && previousSibling.tagName.toLowerCase() === 'span') {
            if (processText(previousSibling.textContent)) return true;
          }
          previousSibling = previousSibling.previousSibling;
        }

        // Move up to parent if it's a span within the same paragraph
        const parent = currentNode.parentElement;
        if (parent && parent.tagName.toLowerCase() === 'span' && parent.closest('p') === clickedSpan.closest('p')) {
          currentNode = parent;
        } else {
          break;
        }
      }
      return false;
    };

    // Start processing from the clicked span
    processPreviousSiblings(currentElement);

    // Trim any extra spaces and return
    return previousSpanText.trim();
  };

  const findNextSpanTextClicked = (clickedSpan, wordCount = 0) => {
    let nextSpanText = '';
    let currentElement = clickedSpan;
    let wordsFound = 0;

    // Function to process text and update word count
    const processText = (text) => {
      const words = text
        .trim()
        .split(/\s+/)
        .filter((word) => word.trim() !== '');
      if (words.length > 0) {
        // Take only the number of words we need
        const remainingWords = 5 - wordsFound;
        const relevantWords = words.slice(0, remainingWords);
        nextSpanText = nextSpanText + ' ' + relevantWords.join(' ');
        wordsFound += relevantWords.length;
      }
      return wordsFound >= 5;
    };

    // Function to process a node and its next siblings
    const processNextSiblings = (node) => {
      let currentNode = node;

      while (currentNode && wordsFound < 5) {
        let nextSibling = currentNode.nextSibling;

        while (nextSibling && wordsFound < 5) {
          // Handle text nodes
          if (nextSibling.nodeType === Node.TEXT_NODE) {
            if (processText(nextSibling.textContent)) return true;
          }
          // Handle span elements
          else if (nextSibling.nodeType === Node.ELEMENT_NODE && nextSibling.tagName.toLowerCase() === 'span') {
            if (processText(nextSibling.textContent)) return true;
          }
          nextSibling = nextSibling.nextSibling;
        }

        // Move up to parent if it's a span within the same paragraph
        const parent = currentNode.parentElement;
        if (parent && parent.tagName.toLowerCase() === 'span' && parent.closest('p') === clickedSpan.closest('p')) {
          currentNode = parent;
        } else {
          break;
        }
      }
      return false;
    };

    // Start processing from the clicked span
    processNextSiblings(currentElement);

    // Trim any extra spaces and return
    return nextSpanText.trim();
  };

  const handleClickReplace = (index) => {
    setActiveIndex(index); // Set the clicked index as active

    let content = null;

    content = findTextArrayRef?.current[index];
    if (!content) {
      content = findTextArrayRef?.current[index - 1];
      index = index - 1;
    }

    if (content) {
      const match = content?.match(/<span[^>]*id=([^\s>]+)[^>]*>/);
      if (match && match[1]) {
        const id = match[1]?.replace(/"/g, '');
        setSingleReplaceSpanId(id);
        singleReplaceSpanIndexRef.current = index;
        const jks647 = document?.querySelector('.jks647');
        const targetSpan = jks647?.querySelector(`span[id="${id}"]`);
        if (targetSpan) {
          const audioParagraph = targetSpan?.closest('.audio-paragraph');
          if (audioParagraph) {
            const fw400Span = audioParagraph?.querySelector('.fw400');
            const fw400Text = fw400Span ? fw400Span?.textContent : null;
            const openSpeakerModelSpan = audioParagraph?.querySelector('#openSpeakerModel');
            const openSpeakerModelText = openSpeakerModelSpan ? openSpeakerModelSpan?.textContent : null;

            const matchText = content?.match(/<span[^>]*>([^<]*)<\/span>/);
            const highlightedMatchedPart = `<span class="findText">${matchText[1]}</span>`;

            const previousText = findPreviousSpanTextClicked(targetSpan);
            const nextText = findNextSpanTextClicked(targetSpan);

            const highlightedText = `${previousText} ${highlightedMatchedPart} ${nextText}`;

            const highlightedMatchedPartResult = `<span class="resultText">${replaceText}</span>`;

            const highlightedTextResult = `${previousText} ${highlightedMatchedPartResult} ${nextText}`;

            const existingHighlightedDescs = document?.querySelectorAll('.highlightedDesc');
            existingHighlightedDescs?.forEach((element) => {
              element?.remove();
            });

            const findLiByIndexOfOriginal = (index) => {
              const replaceTextUl = document?.querySelector('ul.orignalUL');
              if (replaceTextUl) {
                const liElements = replaceTextUl?.querySelectorAll('li');
                return liElements[index];
              }
              return null;
            };

            const findLiByIndexOfResult = (index) => {
              const replaceTextUl = document?.querySelector('ul.resultUL');
              if (replaceTextUl) {
                const liElements = replaceTextUl?.querySelectorAll('li');
                return liElements[index];
              }
              return null;
            };

            const newDescOriginal = `<div class="fnt-12 highlightedDesc">${openSpeakerModelText}  ${fw400Text}<div></div>${highlightedText}</div>`;
            const shortDescriptionLiOriginal = findLiByIndexOfOriginal(index);
            if (shortDescriptionLiOriginal) {
              shortDescriptionLiOriginal?.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              });
              shortDescriptionLiOriginal.classList = 'replaceTextItem active shortDescription';
              const firstSpan = shortDescriptionLiOriginal?.querySelector('span');
              if (firstSpan) {
                const newDivElement = document?.createElement('div');
                newDivElement.classList = 'highlightedDescColor';
                newDivElement.innerHTML = newDescOriginal;
                firstSpan?.parentNode?.insertBefore(newDivElement, firstSpan?.nextSibling);
              }
            }

            const newDescResult = `<div class="fnt-12 highlightedDesc">${openSpeakerModelText}  ${fw400Text}<div></div>${highlightedTextResult}</div>`;
            const shortDescriptionLiResult = findLiByIndexOfResult(index);
            if (shortDescriptionLiResult) {
              shortDescriptionLiResult?.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
              });
              shortDescriptionLiResult.classList = 'replaceTextItem active shortDescription';
              const firstSpan = shortDescriptionLiResult?.querySelector('span');
              if (firstSpan) {
                const newDivElement = document?.createElement('div');
                newDivElement.classList = 'highlightedDescColor';
                newDivElement.innerHTML = newDescResult;
                firstSpan?.parentNode?.insertBefore(newDivElement, firstSpan?.nextSibling);
              }
            }
          }
        }
      }
    }
  };

  const handleSaveAndStay = () => {
    backSaveEditTranscriptChanges();
    setIsUnsavedChangesModalVisible(false);
    transcriptSaveInprogressToaster('Please wait, your transcript is being saved...');
    handleFilterClear();
    setFullQcClick(false);
    setQcClick(false);
    setDueInDayClick(false);
    setDueInHalfDayClick(false);
    setLegalClick(false);
    setDashboardClick(true);
    dispatch(resetDdashboardProofreader());
    dispatch(resetProofreaderAllFiles());
    // Keep the user on the current page
    window.history?.pushState(null, '', window.location.pathname);
  };

  const handleDiscardAndLeave = () => {
    setIsUnsavedChangesModalVisible(false);
    // Set isSaveTranscriptInProgressRef?.current to 0
    isSaveTranscriptInProgressRef.current = 0;
    handleFilterClear();
    setFullQcClick(false);
    setQcClick(false);
    setDueInDayClick(false);
    setDueInHalfDayClick(false);
    setLegalClick(false);
    setDashboardClick(true);
    dispatch(resetDdashboardProofreader());
    dispatch(resetProofreaderAllFiles());
    dispatch(resetEditorData());
    dispatch(resetEditorDocumentData());
    dispatch(resetVendorNextTranscript());
    navigate(DASHBOARD_ROUTE);
  };

  useEffect(() => {
    const handlePopState = () => {
      // Block navigation if save is in progress
      if (isSaveTranscriptInProgressRef?.current === 1) {
        setIsUnsavedChangesModalVisible(true);
        // Re-push state to prevent navigation
        window.history?.pushState(null, '', window.location.pathname);
      } else {
        // Set isSaveTranscriptInProgressRef?.current to 0
        isSaveTranscriptInProgressRef.current = 0;
        navigate(DASHBOARD_ROUTE);
      }
    };

    // Push initial state into history
    window.history?.pushState(null, '', window.location.pathname);

    // Add popstate listener
    window?.addEventListener('popstate', handlePopState);

    return () => {
      // Cleanup listener
      window?.removeEventListener('popstate', handlePopState);
    };
  }, [isSaveTranscriptInProgressRef]);

  useEffect(() => {
    // This handles the page reload
    const handleBeforeUnload = (e) => {
      if (isSaveTranscriptInProgressRef?.current === 1 || isTempSaveTranscript?.current === 1) {
        e.preventDefault();
        e.returnValue = ''; // Show the default browser warning
        backSaveEditTranscriptChanges();
        transcriptSaveInprogressToaster('Please wait, your transcript is being saved...');
      }
    };

    // Add event listeners for popstate and beforeunload events
    window?.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      // Cleanup event listeners
      window?.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isSaveTranscriptInProgressRef]);

  useEffect(() => {
    setwarningShow(usePreviousPath === true && todayWorkClick === true ? true : false);
  }, [usePreviousPath, todayWorkClick]);

  const handleFindReplaceOpenModal = () => {
    setFindText('');
    setReplaceText('');
    findTextArrayRef.current = [];
    setReplacedTextArray([]);
    setIsCommonErrors(false);
    isCaseSensitiveRef.current = false;
    setIsCaseSensitive(false);
    findTextArrayRef.current = [];
    setReplacedTextArray([]);
    setIsCommonErrors(false);
    setIsMatchFullWord(false);
    setIsFillerWords(false);
    isMatchFullWordRef.current = false;
    commonErrorsOptionRef.current = 0;
    isReplaceTextDisabledRef.current = false;
    setFindReplaceShow(true);
  };

  const handleFindReplaceCloseModal = () => {
    setFindReplaceShow(false);
    removingUnidentifySpan();
    if (uniqueParentFileIdsRef?.current && uniqueParentFileIdsRef?.current.length > 0) {
      setDebounceValues();
    }
  };

  const handleWarningCloseModal = () => {
    setwarningShow(false);
    setTodayWorkClick(false);
  };

  const handleSpeakerInputFocus = () => {
    isInputClicked.current = true; // When the input is clicked (focused)
  };

  const handleSpeakerInputBlur = () => {
    if (isInputClicked.current && document?.getElementById('txtSpeakerLabel_speaker')?.value === '') {
      isInputClicked.current = false; // Reset after the alert
      inputRef?.current?.focus();
    }
  };

  const handleMoreShowOpenModal = () => {
    setMoreShow(true);
  };

  const handleMoreShowCloseModal = () => setMoreShow(false);
  const handleResourceConfirm = () => {
    if (id === null) {
      navigate(DASHBOARD_ROUTE);
    } else {
      let params = {
        audioFileId: id,
        userId: userInfo?.UserId,
        isClickOnClaim: false,
        isRestore: true,
        ClaimDate: formatDateWithMilliseconds(),
      };
      setRestorebutton(true);
      dispatch(resetAllSpeakrsData());
      allSpeakersRef.current = null;
      dispatch(editorRequest(params)); // Run the main function
      handleMoreShowCloseModal(); // Close any related modal
      setResourceConfirmOpen(false); // Close the confirm modal
      handleMoreShowCloseModal();
      didSetInitialSpeakers.current = false;
    }
  };

  const handleResourceCancel = () => {
    setResourceConfirmOpen(false);
    handleMoreShowCloseModal();
  };

  const handleKeyboardShortcutsOpenModal = () => setKeyboardShortcutsShow(true);

  const handleKeyboardShortcutsCloseModal = () => setKeyboardShortcutsShow(false);

  // EditorVendorDetails's Data
  let editorDetails = useSelector((state) => state?.editorDetails?.user?.data?.value);

  let editorDetailsData;
  if (editorDetails) {
    try {
      editorDetailsData = JSON.parse(editorDetails);
    } catch (error) {
      editorDetailsData = [];
    }
  } else {
    editorDetailsData = [];
  }

  // Client notes shown as bullets: default (template) notes first, then the client's own notes
  const clientNotes = [editorDetailsData?.DefaultClientNotes, editorDetailsData?.ClientNotes].filter(
    (note) => note && note.trim(),
  );

  useEffect(() => {
    if (id === null) {
      navigate(DASHBOARD_ROUTE);
    } else {
      let getTranscriptparams = {
        audioFileId: id,
        userId: userInfo?.UserId,
        isClickOnClaim: claimFile === true ? true : false,
        isRestore: false,
      };
      dispatch(vendorNextTranscriptRequest(getTranscriptparams));
      didSetInitialSpeakers.current = false;
      allSpeakersRef.current = null;
      let params = {
        audioFileId: id,
        userId: userInfo?.UserId,
        isClickOnClaim: claimFile === true ? true : false,
        isRestore: false,
        ClaimDate: formatDateWithMilliseconds(),
      };
      dispatch(editorRequest(params));
      dispatch(
        vendorProofreaderCommentRequest({
          audioFileId: id,
          userId: userInfo?.UserId,
        }),
      );
    }
  }, [dispatch]);

  useEffect(() => {
    if (!apiCalledRef?.current && editorDetailsData?.ClaimId && userInfo?.UserId) {
      const checkForceUnclaimparams = {
        claimId: editorDetailsData?.ClaimId,
        userId: userInfo?.UserId,
      };
      dispatch(checkForceUnclaimRequest(checkForceUnclaimparams));
      apiCalledRef.current = true;
    }
  }, [editorDetailsData, userInfo, dispatch]);

  const handleResolved = (dataId) => {
    if (dataId) {
      dispatch(
        vendorResolveProofreaderRequest({
          id: dataId,
          userId: userInfo?.UserId,
        }),
      );
    }
  };

  let vendorNextTranscriptDetailSuccess = useSelector((state) => state?.vendorNextTranscript?.user?.data?.success);

  let vendorTranscriptLoading = useSelector((state) => state?.vendorNextTranscript?.loading);

  let vendorNextTranscriptDetail = useSelector((state) => state?.vendorNextTranscript?.user?.data?.value);

  let vendorNextTranscriptDetailData = vendorNextTranscriptDetail && JSON.parse(vendorNextTranscriptDetail);

  const recordingDetails = useSelector((state) => state?.editorDetails);

  useEffect(() => {
    if (recordingDetails?.error !== null && recordingDetails?.loading === false) {
      navigate(-1);
    }
  }, [recordingDetails, navigate]);

  // Editor Vendor Proofreader Comment's Data
  let vendorProofreaderComment = useSelector((state) => state?.vendorProofreaderComment?.user?.data?.value);

  let vendorProofreaderCommentData = vendorProofreaderComment && JSON.parse(vendorProofreaderComment);

  // EditorDetails Api's loading
  let editorDetailsLoading = useSelector((state) => state?.editorDetails?.loading);

  let vendorDetail = useSelector((state) => state?.vendorDetils?.user?.data?.value);

  let vendorDetailData = vendorDetail && JSON.parse(vendorDetail);

  useEffect(() => {
    if (!!vendorTranscriptLoading) {
      setDropdownOpen(false);
      dropdownOpenRef.current = false;
      setErrorSpeakerNamePopup('');
      inputRef.current = null;
      const spekerLabel = document?.getElementById('txtSpeakerLabel_speaker');
      if (spekerLabel) {
        document.getElementById('txtSpeakerLabel_speaker').value = '';
      }
    }
  }, [vendorTranscriptLoading]);

  const handleDocumentsOpenModal = () => {
    if (id === null) {
      navigate(DASHBOARD_ROUTE);
    } else {
      dispatch(editorDocumentRequest(id));
      setDocumentsShow(true);
    }
  };

  const handleDocumentsCloseModal = () => setDocumentsShow(false);

  const unclaimHideModal = () => setUnclaimShow(false);

  const handleSubmitOpenModal = () => {
    if (id === null) {
      navigate(DASHBOARD_ROUTE);
    } else {
      dispatch(
        vendorDetailsRequest({
          audioFileId: id,
          userId: editorDetailsData?.VendorId,
        }),
      );
      setSubmitShow(true);
    }
  };

  const handleSubmitCloseModal = () => setSubmitShow(false);

  // Dcoument's Data
  let editorDocmentData = useSelector((state) => state?.editorDocument?.user?.data?.value);

  let docmentData = editorDocmentData && JSON.parse(editorDocmentData);

  let loadingDocument = useSelector((state) => state?.editorDocument?.loading);

  const allSpeakersData = useSelector((state) => state?.getAllSpeakers?.allSpeakers?.data?.value);

  // Parse and derive the speakers whenever the data changes
  const allSpeakers = useMemo(() => {
    if (allSpeakersData) {
      const allSpeakersDetails = JSON.parse(allSpeakersData);
      return allSpeakersDetails?.Speakers?.map((x) => x?.SpeakerName) || [];
    }
    return [];
  }, [allSpeakersData]);

  const [VendorNotesData, setVendorNotesData] = useState(editorDetailsData?.VendorNote);

  const handleRewind = () => {
    if (videoRef?.current) {
      videoRef.current.currentTime -= parseInt(selectedValueRewindPushTime.current);
    }
  };

  const handleForward = () => {
    if (videoRef?.current) {
      videoRef.current.currentTime += 5;
    }
  };

  useEffect(() => {
    if (videoRef?.current) {
      videoRef?.current?.play();
    }
  }, []);

  // Validation Schema
  const validationSchema = Yup.object().shape({
    unclaimReasonText: Yup.string()
      .required('Details about the issue are required.')
      ?.min(6, 'Please provide at least 6 characters.')
      .max(255, 'Unclaim reason text must be at most 255 characters.'),
  });

  const initialValues = {
    unclaimReason: [],
    unclaimReasonText: '',
  };

  const handleSubmitProofreaderClaim = (values) => {
    let payload = {
      claimId: editorDetailsData?.ClaimId,
      userId: userInfo?.UserId,
      unclaimReasonText: values?.unclaimReasonText,
      unclaimReason: [],
    };
    dispatch(proofreaderUnClaimRequest(payload));
    unclaimHideModal();
  };

  const formatDate = (dateString) => {
    const date = moment(dateString);

    if (date.isSame(new Date(), 'day')) {
      return `${date.format('hh:mm A')} Today`;
    } else {
      return date.format('hh:mm A MMM DD, YYYY');
    }
  };

  const handleDeleteKeyInEditor = (e) => {
    // handle Undo Stack
    undoRedoManage();

    if (audioParagraphRef?.current) {
      const editAreaDiv = audioParagraphRef?.current?.querySelector('.editArea');
      if (editAreaDiv) {
        const checkbox = editAreaDiv?.querySelector("input[type='checkbox']");
        if (checkbox) {
          const isCheckboxSelected = audioParagraphRef?.current?.getAttribute('data-ischeckboxselected-proofreader');
          if (isCheckboxSelected === 'true') {
            checkboxManualTrigger.current = true;
            checkbox?.click();
            checkbox?.removeAttribute('checked');
          }
        }
      }
    }

    const selection = window?.getSelection();

    if (selection?.rangeCount > 0) {
      const range = selection?.getRangeAt(0);

      if (range?.startOffset > 0) {
        if (range?.startOffset === range?.endOffset) {
          let currentSpan = range?.startContainer;

          if (currentSpan.nodeType === Node.TEXT_NODE) {
            currentSpan = currentSpan?.parentNode;
          }

          const currentPTag = currentSpan?.closest('p.cb-m.inputwidthmachine');

          if (currentPTag) {
            const currentAudioParagraph = currentPTag?.closest('.audio-paragraph');

            const lastSpan = currentPTag?.lastElementChild;
            if (lastSpan && currentSpan === lastSpan) {
              const nextAudioParagraph = currentAudioParagraph?.nextElementSibling;
              if (nextAudioParagraph && nextAudioParagraph?.classList?.contains('audio-paragraph')) {
                const nextPTag = nextAudioParagraph?.querySelector('p.cb-m.inputwidthmachine');

                if (nextPTag) {
                  const spansToMove = nextPTag?.querySelectorAll('span');
                  spansToMove?.forEach((span) => {
                    currentPTag?.appendChild(span);
                  });

                  const lastSpan = currentPTag?.lastElementChild;
                  if (lastSpan) {
                    const newRange = document?.createRange();
                    newRange?.setStartAfter(lastSpan);
                    newRange?.collapse(true);

                    selection?.removeAllRanges();
                    selection?.addRange(newRange);
                    lastSpan?.focus();
                  }
                  nextAudioParagraph?.remove();
                  e.preventDefault();
                  const targetParantFile = currentSpan?.closest('.parent-file-paragraph-div');
                  const parentFileId = targetParantFile?.getAttribute('data-parent-file-paragraph-id');

                  if (parentFileId) {
                    if (!uniqueParentFileIdsRef?.current?.includes(parentFileId)) {
                      uniqueParentFileIdsRef?.current?.push(parentFileId);
                    }
                  }

                  const editAreaDiv = currentAudioParagraph?.querySelector('.editArea');
                  if (editAreaDiv) {
                    const checkbox = editAreaDiv?.querySelector("input[type='checkbox']");
                    if (checkbox) {
                      const isCheckboxSelected = currentAudioParagraph?.getAttribute(
                        'data-ischeckboxselected-proofreader',
                      );
                      if (isCheckboxSelected === 'true') {
                        checkboxManualTrigger.current = true;
                        checkbox?.click();
                        checkbox?.removeAttribute('checked');
                      }
                    }
                  }
                  setDebounceValues();
                  setDropDownClosed();
                }
              }
            }
          }

          setTimeout(() => {
            const pTag = currentSpan?.closest('p.cb-m.inputwidthmachine');

            if (pTag) {
              const para = pTag?.closest('.audio-paragraph');

              let editAreaDiv = para?.querySelector('.editArea');

              if (!editAreaDiv) {
                // Create the editArea div since it doesn't exist
                editAreaDiv = document?.createElement('div');
                editAreaDiv?.classList?.add('editArea');
                editAreaDiv?.setAttribute('contenteditable', 'false');

                const checkbox = document?.createElement('input');
                checkbox.type = 'checkbox';
                checkbox?.classList?.add('form-check-input');
                checkbox?.classList?.add('checkCompleteParagraph');

                const isCheckboxSelected = para?.getAttribute('data-ischeckboxselected-proofreader');

                if (isCheckboxSelected === 'true') {
                  checkbox?.setAttribute('checked', 'true');
                } else {
                  checkbox?.removeAttribute('checked');
                }

                editAreaDiv?.appendChild(checkbox);
                para?.appendChild(editAreaDiv);
              }
            }
          }, [300]);
          return () => clearTimeout(300);
        }
      } else {
        let currentSpan = range?.startContainer;

        // Ensure the current span is valid and handle text nodes properly
        if (currentSpan.nodeType === Node.TEXT_NODE) {
          currentSpan = currentSpan?.parentNode;
        }

        // Find the closest paragraph element for the current span
        const currentPTag = currentSpan?.closest('p.cb-m.inputwidthmachine');

        if (currentPTag) {
          // Get the text selection range
          const selection = window.getSelection();
          if (selection?.rangeCount > 0) {
            const selectedRange = selection.getRangeAt(0);

            // Check if the entire paragraph is selected
            const isEntireParagraphSelected = selectedRange.toString().trim() === currentPTag.innerText.trim();

            if (isEntireParagraphSelected) {
              // If the entire paragraph is selected, remove all spans and add a <br> tag
              currentPTag.innerHTML = '<br>';
              currentPTag.classList.add('tf');
              currentPTag.setAttribute('contenteditable', 'true');
            } else {
              // Remove only the selected content
              selectedRange.deleteContents();

              // Adjust the cursor position to the end of the updated paragraph
              const newRange = document?.createRange();
              const lastChild = currentPTag?.lastChild;

              if (lastChild) {
                newRange.setStartAfter(lastChild);
                newRange.collapse(true);
                selection.removeAllRanges();
                selection.addRange(newRange);
              }
            }

            e.preventDefault();

            // Update metadata if necessary (e.g., parent file IDs and checkboxes)
            const targetParentFile = currentSpan?.closest('.parent-file-paragraph-div');
            const parentFileId = targetParentFile?.getAttribute('data-parent-file-paragraph-id');

            if (parentFileId) {
              if (!uniqueParentFileIdsRef?.current?.includes(parentFileId)) {
                uniqueParentFileIdsRef?.current?.push(parentFileId);
              }
            }

            const currentAudioParagraph = currentPTag?.closest('.audio-paragraph');
            if (currentAudioParagraph) {
              const editAreaDiv = currentAudioParagraph?.querySelector('.editArea');
              if (editAreaDiv) {
                const checkbox = editAreaDiv?.querySelector("input[type='checkbox']");
                if (checkbox) {
                  const isCheckboxSelected = currentAudioParagraph?.getAttribute('data-ischeckboxselected-proofreader');
                  if (isCheckboxSelected === 'true') {
                    checkboxManualTrigger.current = true;
                    checkbox?.click();
                    checkbox?.removeAttribute('checked');
                  }
                }
              }
            }
            setDebounceValues();
            setDropDownClosed();
          }
        }

        // Ensure the `editArea` div is created for the current paragraph
        setTimeout(() => {
          const pTag = currentSpan?.closest('p.cb-m.inputwidthmachine');

          if (pTag) {
            const para = pTag?.closest('.audio-paragraph');

            let editAreaDiv = para?.querySelector('.editArea');

            if (!editAreaDiv) {
              // Create the editArea div since it doesn't exist
              editAreaDiv = document?.createElement('div');
              editAreaDiv?.classList?.add('editArea');
              editAreaDiv?.setAttribute('contenteditable', 'false');

              const checkbox = document?.createElement('input');
              checkbox.type = 'checkbox';
              checkbox?.classList?.add('form-check-input');
              checkbox?.classList?.add('checkCompleteParagraph');

              const isCheckboxSelected = para?.getAttribute('data-ischeckboxselected-proofreader');

              if (isCheckboxSelected === 'true') {
                checkbox?.setAttribute('checked', 'true');
              } else {
                checkbox?.removeAttribute('checked');
              }

              editAreaDiv?.appendChild(checkbox);
              para?.appendChild(editAreaDiv);
            }
          }
        }, 300);
        return () => clearTimeout(300);
      }
    }
  };

  // Calculate the resulting time
  const plusIconHTML = ReactDOMServer.renderToString(<FaPlus />);

  useEffect(() => {
    // Example shortcuts based on the image
    const handleKeyDown = (event) => {
      if ((event.ctrlKey || event.metaKey) && event.key === 's') {
        event.preventDefault();
        backSaveEditTranscriptChanges();
        isSaveTranscriptInProgressRef.current = 0;
        // Implement Save functionality
      } else if ((event.ctrlKey || event.metaKey) && event.key === 'r') {
        event.preventDefault();
        handleFindReplaceOpenModal();
        // Implement Find and Replace functionality
      } else if ((event.ctrlKey || event.metaKey) && event.key === 'm') {
        event.preventDefault();
        const selection = window?.getSelection();
        if (selection?.rangeCount > 0) {
          const range = selection?.getRangeAt(0);
          let selectedElement = range?.startContainer;
          if (selectedElement.nodeType === Node.TEXT_NODE) {
            selectedElement = selectedElement?.parentElement;
          }
          const audioParagraph = selectedElement?.closest('.audio-paragraph');
          if (audioParagraph) {
            const editAreaDiv = audioParagraph?.querySelector('.editArea');
            if (editAreaDiv) {
              const checkbox = editAreaDiv?.querySelector("input[type='checkbox']");
              if (checkbox) {
                checkboxManualTrigger.current = true;
                checkbox?.click();
              }
            }

            // Find the last span inside `p.cb-m.inputwidthmachine`
            const targetParagraph = audioParagraph.querySelector('p.cb-m.inputwidthmachine');
            if (targetParagraph) {
              const lastSpan = targetParagraph.querySelector('span:last-child');
              if (lastSpan) {
                // Move cursor inside the last span
                const range = document.createRange();
                const selection = window.getSelection();
                range.selectNodeContents(lastSpan);
                range.collapse(false); // Place cursor at the end
                selection.removeAllRanges();
                selection.addRange(range);

                speakerTragetRef.current = lastSpan?.closest('.audio-paragraph')?.querySelector('#openSpeakerModel');
              }
            }
          }
        }
        // Implement Mark paragraph as completed functionality
      } else if (
        (event.ctrlKey || event.metaKey) &&
        event.shiftKey &&
        (event.key === 'Enter' || event.keyCode === 13)
      ) {
        event.preventDefault();

        if (speakerTragetRef?.current) {
          const currentAudioParagraph = speakerTragetRef?.current?.closest('.audio-paragraph');
          const subparaSpan = currentAudioParagraph?.querySelector('#openSpeakerModel.subpara');
          if (!subparaSpan) {
            const rect = speakerTragetRef?.current?.getBoundingClientRect();
            setDropdownPosition({ top: rect.top + 30, left: rect.left });
            if (allSpeakersRef?.current) {
              allSpeakersRef.current = allSpeakersRef.current.filter(
                (speaker, index, self) =>
                  index === self.findIndex((s) => s.trim().toLowerCase() === speaker.trim().toLowerCase()),
              );
            }
            setDropDownOpen();
          }
        }
      } else if ((event.ctrlKey || event.metaKey) && event.key === 'Enter') {
        event.preventDefault();

        if (speakerTragetRef.current) {
          const currentAudioParagraph = speakerTragetRef?.current?.closest('.audio-paragraph');

          // Initialize nextAudioParagraph as null
          let nextAudioParagraph = null;

          // First attempt: Use nextSibling
          if (currentAudioParagraph?.nextSibling?.classList?.contains('audio-paragraph')) {
            nextAudioParagraph = currentAudioParagraph.nextSibling;
          }

          // Fallback: Use querySelector if nextSibling is invalid
          if (!nextAudioParagraph) {
            const parent = currentAudioParagraph?.parentNode;
            const allAudioParagraphs = Array.from(parent?.children || []).filter((child) =>
              child.classList.contains('audio-paragraph'),
            );
            let currentIndex = allAudioParagraphs.indexOf(currentAudioParagraph);
            // Find the next valid paragraph (ignoring ones with ".subpara" inside)
            while (currentIndex + 1 < allAudioParagraphs.length) {
              nextAudioParagraph = allAudioParagraphs[currentIndex + 1];
              const subparaSpan = nextAudioParagraph?.querySelector('#openSpeakerModel.subpara');
              if (!subparaSpan) break; // Found the final valid next paragraph
              // If "subpara" exists, move to the next one
              currentIndex++;
            }
          }

          // If nextAudioParagraph is found, proceed
          if (nextAudioParagraph) {
            const spanElement = nextAudioParagraph?.querySelector('#openSpeakerModel');
            if (spanElement) {
              speakerTragetRef.current = spanElement;

              const rect = spanElement?.getBoundingClientRect();
              setDropdownPosition({ top: rect.top + 30, left: rect.left });
              if (allSpeakersRef?.current) {
                allSpeakersRef.current = allSpeakersRef.current.filter(
                  (speaker, index, self) =>
                    index === self.findIndex((s) => s.trim().toLowerCase() === speaker.trim().toLowerCase()),
                );
              }
              setDropDownOpen();
            }
          }
        }
      }
    };

    // Add event listener
    window?.addEventListener('keydown', handleKeyDown);

    // Cleanup the event listener on unmount
    return () => {
      window?.removeEventListener('keydown', handleKeyDown);
    };
  }, [id, speakerCreateRef.current]);

  useEffect(() => {
    if (content && content?.length > 0) {
      function handlePasteEvent(e) {
        playerPlayPause(false);
        e.preventDefault();
        undoRedoManage();

        if (audioParagraphRef?.current) {
          const editAreaDiv = audioParagraphRef?.current?.querySelector('.editArea');
          if (editAreaDiv) {
            const checkbox = editAreaDiv?.querySelector("input[type='checkbox']");
            if (checkbox) {
              const isCheckboxSelected = audioParagraphRef?.current?.getAttribute(
                'data-ischeckboxselected-proofreader',
              );
              if (isCheckboxSelected === 'true') {
                checkboxManualTrigger.current = true;
                checkbox?.click();
                checkbox?.removeAttribute('checked');
              }
            }
          }
        }

        const pastedText = (e?.clipboardData || window?.clipboardData)?.getData('text/plain');
        if (!pastedText) return;

        const selection = window?.getSelection();
        if (!selection?.rangeCount) return;

        const range = selection?.getRangeAt(0);
        range?.deleteContents(); // Remove any selected content

        let parent = e.target;

        // Handle cases where the target is a <br> tag
        if (e.target.nodeName.toLowerCase() === 'br') {
          parent = e.target.closest('p');
          parent.innerHTML = pastedText; // Replace with pasted text
          e.target?.remove();
        } else {
          parent.textContent += pastedText; // Append the pasted text inside the span
        }

        // Set focus at the end of the pasted text
        range.setStart(parent, parent.childNodes.length);
        range.setEnd(parent, parent.childNodes.length);
        selection.removeAllRanges();
        selection.addRange(range);

        // Ensure focus remains
        parent.focus();
      }

      document?.querySelectorAll('.cb-m.inputwidthmachine')?.forEach((element) => {
        element?.addEventListener('paste', handlePasteEvent);
      });

      const handleKeyCopyText = (e) => {
        // Get the selection text to check what is being copied
        const selection = window.getSelection().toString();

        // If the selection is inside an element with both .form-group and .mb-2, prevent the copy
        if (selection && e.target.closest('.form-group.mb-2')) {
          e.preventDefault();
        }
      };

      const handleKeyDownSelction = (e) => {
        if (e.keyCode === 46 || e.key === 'Delete') {
          playerPlayPause(false);
          handleDeleteKeyInEditor(e);
          keyDownTrigger.current = true;
        }
      };

      document?.addEventListener('keydown', handleKeyDownSelction);
      document?.addEventListener('copy', handleKeyCopyText);

      // Cleanup the event listener on unmount
      return () => {
        document?.removeEventListener('keydown', handleKeyDownSelction);
        document?.removeEventListener('copy', handleKeyCopyText);
        document?.querySelectorAll('.cb-m.inputwidthmachine')?.forEach((element) => {
          element?.removeEventListener('paste', handlePasteEvent);
        });
      };
    }
  }, [content]);

  const isNumeric = (str) => {
    return !isNaN(str) && !isNaN(parseFloat(str));
  };

  const timeFormatting = (seconds) => {
    const totalSeconds = Math?.floor(seconds);
    const hours = Math?.floor(totalSeconds / 3600);
    const minutes = Math?.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    const formattedHours = hours > 0 ? `${String(hours)?.padStart(2, '0')}:` : '';
    const formattedMinutes = String(minutes)?.padStart(2, '0');
    const formattedSeconds = String(secs)?.padStart(2, '0');

    return hours > 0
      ? `${formattedHours}${formattedMinutes}:${formattedSeconds}`
      : `${formattedMinutes}:${formattedSeconds}`;
  };

  const setTranscriptHtml = (tempDefaultContainer) => {
    const rows = tempDefaultContainer?.querySelectorAll('div.trans-row');
    rows?.forEach((row) => {
      // Find the last <p> element in each row
      const lastParagraph = row?.querySelector('p.cb-m.inputwidthmachine');

      // Find all <span> elements in the last <p>
      const spans = lastParagraph?.querySelectorAll('span');

      spans?.forEach((span) => {
        const text = span?.textContent;
        const dataStart = span?.getAttribute('data-start');

        if (text?.includes(' ') && text !== ' ') {
          // Split the text content by spaces
          const spanContent = text?.split(' ');
          const firstWord = spanContent[0];
          const remainingWords = spanContent?.slice(1)?.reverse();

          // Update the original span's content with the first word
          span.textContent = firstWord?.trim();

          const spanClass = span?.getAttribute('class');
          let typedContent = '';

          // Loop through the rest of the words and create new spans
          for (let i = 0; i < remainingWords?.length; i++) {
            const word = remainingWords[i];
            if (word !== '&nbsp;' && word !== ' ') {
              if (spanClass) {
                if (word?.trim()?.length > 0) {
                  typedContent += `<span class="${spanClass}" data-start="${dataStart}">${word}</span><span> </span>`;
                } else {
                  typedContent += `<span class="${spanClass}" data-start="${dataStart}"> </span>`;
                }
              } else {
                typedContent += `<span data-start="${dataStart}">${word}</span><span> </span>`;
              }
            }
          }

          // Insert the new spans after the original span
          const tempDiv = document?.createElement('div');
          tempDiv.innerHTML = typedContent;
          while (tempDiv?.firstChild) {
            span?.parentNode?.insertBefore(tempDiv?.firstChild, span?.nextSibling);
          }
        }
      });
    });
  };

  const setAttrInEverySpanWord = (tempDefaultContainer) => {
    const jks647 = document?.querySelector('.jks647');

    // Ensure `jks647` exists before querying for spans
    const existingFnrids = jks647
      ? Array?.from(jks647?.querySelectorAll('p.cb-m.inputwidthmachine span[data-fnrid]'))
          ?.map((span) => parseInt(span?.getAttribute('data-fnrid'), 10))
          ?.filter((value) => !isNaN(value))
      : [];

    // Determine the starting `data-fnrid` value
    let fnridCounter = existingFnrids?.length > 0 ? Math?.max(...existingFnrids) + 1 : 0;

    // Process all rows
    const rows = tempDefaultContainer?.querySelectorAll('div.trans-row');
    rows?.forEach((row) => {
      const lastParagraph = row?.querySelector('p.cb-m.inputwidthmachine');
      const spans = lastParagraph?.querySelectorAll('span');

      spans?.forEach((span) => {
        const text = span?.textContent?.trim(); // Trim text to avoid processing empty spaces
        if (text !== '&nbsp;' && text !== '') {
          span?.setAttribute('data-fnrid', fnridCounter);
          fnridCounter++;
        }
      });
    });
  };

  // Load content from storage when the component mounts
  useEffect(() => {
    if (!!vendorNextTranscriptDetailData?.EditTranscript) {
      const defaultContent = `${vendorNextTranscriptDetailData?.EditTranscript}`;

      const tempDefaultContainer = document?.createElement('div');
      tempDefaultContainer.innerHTML = defaultContent
        ?.replace(/class="0 /g, 'class="spk_0 ')
        ?.replace(/class="1 /g, 'class="spk_1 ')
        ?.replace(/\n/g, '');

      selectedValueRewindPushTime.current =
        editorDetailsData?.RewindOnPause === '' || editorDetailsData?.RewindOnPause === null
          ? '5'
          : editorDetailsData?.RewindOnPause;
      setselectedValueRewindPushTime(
        editorDetailsData?.RewindOnPause === '' || editorDetailsData?.RewindOnPause === null
          ? '5'
          : editorDetailsData?.RewindOnPause,
      );

      const fontSize =
        editorDetailsData?.FontSize === '' || editorDetailsData?.FontSize === null ? null : editorDetailsData?.FontSize;
      jKS647HasClass.current = `jks647 ${fontSize === null ? 'fnt-main-14' : fontSize}`;
      setFontSize(fontSize);

      setTranscriptHtml(tempDefaultContainer);
      setAttrInEverySpanWord(tempDefaultContainer);

      let previousTimestamp = null; // Store the last valid timestamp

      const elementsDiv = tempDefaultContainer?.querySelectorAll('.fw400');
      elementsDiv?.forEach(function (element) {
        let timestamp = element?.textContent?.trim();

        // Check for null or undefined timestamp and use previous valid value if needed
        if (timestamp === null || timestamp === undefined) {
          timestamp = previousTimestamp; // Use the last valid timestamp
        } else {
          if (isNumeric(timestamp)) {
            timestamp = timeFormatting(parseFloat(timestamp));
          } else {
            if (timestamp?.indexOf('-') !== -1) {
              timestamp = timestamp?.split('-')[0]; // Take the part before the hyphen
            }
            // Check if the timestamp is 8 characters long and starts with "00"
            if (timestamp?.length === 8 && timestamp?.startsWith('00')) {
              timestamp = timestamp?.substring(3); // Remove the first three characters ("00:")
            }
          }
        }

        // Update the element text content with the formatted timestamp
        element.textContent = timestamp;
        previousTimestamp = timestamp; // Update the previous valid timestamp
      });

      const spansWithSpeakerClass = tempDefaultContainer?.querySelectorAll("span[class^='spk_']");
      if (spansWithSpeakerClass?.length > 0) {
        spansWithSpeakerClass?.forEach((span) => (span.id = 'openSpeakerModel'));
      }

      const editLabel = tempDefaultContainer?.querySelectorAll('.editlabel');
      editLabel?.forEach((element) => {
        element?.setAttribute('contenteditable', 'false');
        element.style.display = 'none';
        const imgs = element?.querySelectorAll('img');
        imgs?.forEach((img) => {
          img?.setAttribute('contenteditable', 'false');
          img?.setAttribute('src', playIcon);
        });
      });

      const seekplay = tempDefaultContainer?.querySelectorAll('.seekplay');
      seekplay?.forEach((element) => {
        element?.setAttribute('contenteditable', 'false');
        const imgs = element?.querySelectorAll('img');
        imgs?.forEach((img) => {
          img?.setAttribute('contenteditable', 'false');
          img?.setAttribute('src', playIcon);
        });
      });

      const parentDiv = tempDefaultContainer?.querySelector('.parent-file-paragraph-div');

      const parentFileParagraphId = parentDiv?.getAttribute('data-parent-file-paragraph-id');

      const completedPercentage = editorDetailsData?.CompletedPercentage;
      const fileStatus = editorDetailsData?.Status;

      const fileClaimId = editorDetailsData?.ClaimId;
      const transcriptClaimId = parentDiv?.getAttribute('data-claimid');
      transcriptClaimIdRef.current = fileClaimId;

      const transRowDivs = tempDefaultContainer?.querySelectorAll('.audio-paragraph');
      transRowDivs?.forEach((transRowDiv) => {
        const firstPTag = transRowDiv?.querySelector('div p');
        if (firstPTag) {
          firstPTag?.setAttribute('contenteditable', 'false');
          const childElements = firstPTag?.querySelectorAll('*');
          childElements?.forEach((child) => {
            if (child?.classList?.contains('fw400') || child?.classList?.contains('fw500')) {
              child?.setAttribute('contenteditable', 'true');
            } else {
              child?.setAttribute('contenteditable', 'false');
            }
          });
        }

        const handleDOMContentLoaded = () => {
          // Select all elements with the class "audio-paragraph"
          const transRowDivs = document?.querySelectorAll('.audio-paragraph');

          transRowDivs?.forEach((transRowDiv) => {
            // Find the first <p> tag within the audio-paragraph
            const firstPTag = transRowDiv?.querySelector('.form-group.mb-2 p');
            if (firstPTag) {
              // Make the <p> tag itself non-editable
              firstPTag?.setAttribute('contenteditable', 'false');

              // Loop through child elements inside the <p> tag
              const childElements = firstPTag?.querySelectorAll('*');
              childElements?.forEach((child) => {
                // Make elements with the "timecls_spk_1" class editable
                if (child?.classList?.contains('timecls_spk_1')) {
                  child?.setAttribute('contenteditable', 'true');
                } else {
                  // Ensure other elements remain non-editable
                  child?.setAttribute('contenteditable', 'false');
                }
              });
            }

            // Find the second <p> tag within the audio-paragraph
            const secondPTag = transRowDiv?.querySelector('.form-group.mb-4 p');
            if (secondPTag) {
              // Make the second <p> tag editable
              secondPTag?.setAttribute('contenteditable', 'true');

              // Ensure spans inside the second <p> tag are editable
              const spanElements = secondPTag?.querySelectorAll('span');
              spanElements?.forEach((span) => {
                span?.setAttribute('contenteditable', 'true');
              });
            }
          });

          // Remove event listener after execution
          document?.removeEventListener('DOMContentLoaded', handleDOMContentLoaded);
        };

        // Attach event listener
        document?.addEventListener('DOMContentLoaded', handleDOMContentLoaded);

        const newDiv = document?.createElement('div');
        newDiv?.classList?.add('editArea');
        newDiv?.setAttribute('contenteditable', 'false');

        const checkbox = document?.createElement('input');
        checkbox.type = 'checkbox';
        checkbox?.classList?.add('form-check-input');
        checkbox?.classList?.add('checkCompleteParagraph');

        const isCheckboxSelected = transRowDiv?.getAttribute('data-ischeckboxselected-proofreader');

        if (parseFloat(completedPercentage) === 0 && fileStatus?.toLowerCase() === 'rework') {
          parentDiv?.setAttribute('data-claimid', fileClaimId);
          checkbox?.removeAttribute('checked');
          transRowDiv?.setAttribute('data-ischeckboxselected-proofreader', 'false');
          completedPercentageRef.current = 0;
        } else {
          parentDiv?.setAttribute('data-claimid', fileClaimId);
          if (fileClaimId === transcriptClaimId || transcriptClaimId === '00000000-0000-0000-0000-000000000000') {
            if (isCheckboxSelected === 'true') {
              checkbox?.setAttribute('checked', 'true');
            } else {
              checkbox?.removeAttribute('checked');
            }
          } else {
            checkbox?.removeAttribute('checked');
            transRowDiv?.setAttribute('data-ischeckboxselected-proofreader', 'false');
            completedPercentageRef.current = 0;
          }
        }

        newDiv?.appendChild(checkbox);
        transRowDiv?.appendChild(newDiv);
      });

      const fileData = parentDiv?.outerHTML;

      setContent([
        {
          parentFileParagraphId,
          fileData,
        },
      ]);

      contentRefNew.current = [
        {
          parentFileParagraphId,
          fileData,
        },
      ];

      const currentTime = getTime();
      lastSavedTime.current = currentTime;
      if (id === null) {
        navigate(DASHBOARD_ROUTE);
      } else {
        dispatch(getAllSpeakersRequest(id));
      }

      const nextParentFileParagraphId = parseInt(parentFileParagraphId) + 1;
      loadTranscriptParagraph(nextParentFileParagraphId);

      setTimeout(() => {
        updateCheckBoxPercentage();
      }, [200]);
      return () => clearTimeout(200);
    }
  }, [vendorNextTranscriptDetailData?.EditTranscript]);

  useEffect(() => {
    if (!!getContent) {
      const defaultContent = getContent;
      const tempDefaultContainer = document?.createElement('div');
      tempDefaultContainer.innerHTML = defaultContent
        ?.replace(/class="0 /g, 'class="spk_0 ')
        ?.replace(/class="1 /g, 'class="spk_1 ')
        ?.replace(/\n/g, '');

      setTranscriptHtml(tempDefaultContainer);
      setAttrInEverySpanWord(tempDefaultContainer);

      let previousTimestamp = null; // Store the last valid timestamp

      const elementsDiv = tempDefaultContainer?.querySelectorAll('.fw400');
      elementsDiv?.forEach(function (element) {
        let timestamp = element?.textContent?.trim();

        // Check if timestamp is null or undefined and use the previous valid timestamp if needed
        if (timestamp === null || timestamp === undefined || timestamp === '') {
          timestamp = previousTimestamp; // Use the last valid timestamp
        } else {
          if (isNumeric(timestamp)) {
            timestamp = timeFormatting(parseFloat(timestamp)); // Format numeric timestamp
          } else {
            if (timestamp?.indexOf('-') !== -1) {
              timestamp = timestamp?.split('-')[0]; // Take the part before the hyphen
            }
            // Check if the timestamp is 8 characters long and starts with "00"
            if (timestamp?.length === 8 && timestamp?.startsWith('00')) {
              timestamp = timestamp?.substring(3); // Remove the first three characters ("00:")
            }
          }
        }

        // Update the element's text content with the formatted timestamp
        element.textContent = timestamp;

        // Update the previousTimestamp to the current valid timestamp for future use
        previousTimestamp = timestamp;
      });

      const spansWithSpeakerClass = tempDefaultContainer?.querySelectorAll("span[class^='spk_']");
      if (spansWithSpeakerClass?.length > 0) {
        spansWithSpeakerClass?.forEach((span) => (span.id = 'openSpeakerModel'));
      }

      const editLabel = tempDefaultContainer?.querySelectorAll('.editlabel');
      editLabel?.forEach((element) => {
        element?.setAttribute('contenteditable', 'false');
        element.style.display = 'none';
        const imgs = element?.querySelectorAll('img');
        imgs?.forEach((img) => {
          img?.setAttribute('contenteditable', 'false');
          img?.setAttribute('src', playIcon);
        });
      });

      const seekplay = tempDefaultContainer?.querySelectorAll('.seekplay');
      seekplay?.forEach((element) => {
        element?.setAttribute('contenteditable', 'false');
        const imgs = element?.querySelectorAll('img');
        imgs?.forEach((img) => {
          img?.setAttribute('contenteditable', 'false');
          img?.setAttribute('src', playIcon);
        });
      });

      const parentDiv = tempDefaultContainer?.querySelector('.parent-file-paragraph-div');

      const parentFileParagraphId = parentDiv?.getAttribute('data-parent-file-paragraph-id');

      const completedPercentage = editorDetailsData?.CompletedPercentage;
      const fileStatus = editorDetailsData?.Status;

      const fileClaimId = editorDetailsData?.ClaimId;
      const transcriptClaimId = transcriptClaimIdRef?.current;

      const transRowDivs = tempDefaultContainer?.querySelectorAll('.audio-paragraph');
      transRowDivs?.forEach((transRowDiv) => {
        const firstPTag = transRowDiv?.querySelector('div p');
        if (firstPTag) {
          firstPTag?.setAttribute('contenteditable', 'false');
          const childElements = firstPTag?.querySelectorAll('*');
          childElements?.forEach((child) => {
            if (child?.classList?.contains('fw400')) {
              child?.setAttribute('contenteditable', 'true');
            } else {
              child?.setAttribute('contenteditable', 'false');
            }
          });
        }

        const handleDOMContentLoaded = () => {
          // Select all elements with the class "audio-paragraph"
          const transRowDivs = document?.querySelectorAll('.audio-paragraph');

          transRowDivs?.forEach((transRowDiv) => {
            // Find the first <p> tag within the audio-paragraph
            const firstPTag = transRowDiv?.querySelector('.form-group.mb-2 p');
            if (firstPTag) {
              // Make the <p> tag itself non-editable
              firstPTag?.setAttribute('contenteditable', 'false');

              // Loop through child elements inside the <p> tag
              const childElements = firstPTag?.querySelectorAll('*');
              childElements?.forEach((child) => {
                // Make elements with the "timecls_spk_1" class editable
                if (child?.classList?.contains('timecls_spk_1')) {
                  child?.setAttribute('contenteditable', 'true');
                } else {
                  // Ensure other elements remain non-editable
                  child?.setAttribute('contenteditable', 'false');
                }
              });
            }

            // Find the second <p> tag within the audio-paragraph
            const secondPTag = transRowDiv?.querySelector('.form-group.mb-4 p');
            if (secondPTag) {
              // Make the second <p> tag editable
              secondPTag?.setAttribute('contenteditable', 'true');

              // Ensure spans inside the second <p> tag are editable
              const spanElements = secondPTag?.querySelectorAll('span');
              spanElements?.forEach((span) => {
                span?.setAttribute('contenteditable', 'true');
              });
            }
          });

          // Remove event listener after execution
          document?.removeEventListener('DOMContentLoaded', handleDOMContentLoaded);
        };

        // Attach event listener
        document?.addEventListener('DOMContentLoaded', handleDOMContentLoaded);

        const newDiv = document?.createElement('div');
        newDiv?.classList?.add('editArea');
        newDiv?.setAttribute('contenteditable', 'false');

        const checkbox = document?.createElement('input');
        checkbox.type = 'checkbox';
        checkbox?.classList?.add('form-check-input');
        checkbox?.classList?.add('checkCompleteParagraph');

        const isCheckboxSelected = transRowDiv?.getAttribute('data-ischeckboxselected-proofreader');

        if (parseInt(completedPercentage) === 0 && fileStatus?.toLowerCase() === 'rework') {
          checkbox?.removeAttribute('checked');
          transRowDiv?.setAttribute('data-ischeckboxselected-proofreader', 'false');
          completedPercentageRef.current = 0;
        } else {
          if (fileClaimId === transcriptClaimId || transcriptClaimId === '00000000-0000-0000-0000-000000000000') {
            if (isCheckboxSelected === 'true') {
              checkbox?.setAttribute('checked', 'true');
            } else {
              checkbox?.removeAttribute('checked');
            }
          } else {
            checkbox?.removeAttribute('checked');
            transRowDiv?.setAttribute('data-ischeckboxselected-proofreader', 'false');
            completedPercentageRef.current = 0;
          }
        }

        newDiv?.appendChild(checkbox);
        transRowDiv?.appendChild(newDiv);
      });

      const fileData = parentDiv?.outerHTML;

      const existingContent = [...content];

      if (parentDiv && parentFileParagraphId) {
        existingContent?.push({
          parentFileParagraphId,
          fileData,
        });

        setContent(existingContent);
        contentRefNew.current = existingContent;
      }

      setTimeout(() => {
        updateCheckBoxPercentage();
      }, [200]);
      return () => clearTimeout(200);
    }
  }, [getContent]);

  const workerPlayer = createWorkerPlayer();

  const handleTimeUpdate = function () {
    if (isPlayingVideo(audioPlayerRef.current)) {
      const currentTime = audioPlayerRef.current?.currentTime;

      // Create an array with only data, no HTML elements
      const wordsArray = Array.from(trnascriptSpanWords.current).map((word, index) => ({
        start: parseFloat(word.dataset.start),
        index: index, // Store the index to reference later
      }));

      workerPlayer.postMessage({ currentTime, words: wordsArray });

      workerPlayer.onmessage = (event) => {
        const { highlightedIndex } = event.data;

        // Update the DOM based on the index received from the worker
        trnascriptSpanWords.current.forEach((word, index) => {
          if (index === highlightedIndex) {
            word.classList.add('highlight');
          } else {
            word.classList.remove('highlight');
          }
        });
      };
    } else {
      document.querySelectorAll('span.highlight').forEach((span) => {
        span.classList.remove('highlight');
      });
    }
  };

  useEffect(() => {
    if (vendorNextTranscriptDetailData?.Words?.length > 0) {
      const audioPlayerCtrl = document?.getElementById(`audiofile_${id}`);
      if (audioPlayerCtrl) {
        audioPlayerRef.current = audioPlayerCtrl;
        trnascriptSpanWords.current = document.querySelectorAll('p.cb-m.inputwidthmachine span[data-start]');
        // Attach event listener
        audioPlayerCtrl?.addEventListener('timeupdate', handleTimeUpdate);

        const handleDoubleClick = function (event) {
          document.querySelectorAll('span.highlight').forEach((span) => {
            span.classList.remove('highlight');
          });
          var element = event.target;
          if (element?.getAttribute('data-start') !== null && element?.getAttribute('data-start') !== undefined) {
            var startTimeInSec = parseFloat(element?.getAttribute('data-start'));
            audioPlayerCtrl.currentTime = startTimeInSec;
            audioPlayerRef.current = audioPlayerCtrl;

            try {
              let playPromise = audioPlayerCtrl?.play();
              if (playPromise !== undefined) {
                playPromise?.catch(() => false);
              }
            } catch (error) {
              return false;
            }
          }
        };

        // Attach event listeners
        document?.querySelectorAll("span[id^='c_']")?.forEach(function (element) {
          element?.addEventListener('dblclick', handleDoubleClick);
        });

        const transcriptSpan = document?.querySelector('.QuillTranscript');
        const handleClick = function (event) {
          const span = event.target;
          const audioParagraph = span?.closest('.audio-paragraph');
          if (audioParagraph) {
            audioParagraphRef.current = audioParagraph;
            speakerTragetRef.current = audioParagraph?.querySelector('#openSpeakerModel');
          }
        };

        // Attach event listeners
        transcriptSpan?.querySelectorAll('span')?.forEach(function (element) {
          element?.addEventListener('click', handleClick);
        });

        const handleParagraphClick = function (event) {
          const p = event.target;
          const audioParagraph = p?.closest('.audio-paragraph');
          if (audioParagraph) {
            audioParagraphRef.current = audioParagraph;
          }
        };

        // Attach event listeners
        transcriptSpan?.querySelectorAll('p')?.forEach((element) => {
          element?.addEventListener('click', handleParagraphClick);
        });

        const handleAudioParagraphClick = function (event) {
          const div = event.target;
          const audioParagraph = div?.closest('.audio-paragraph');
          if (audioParagraph) {
            audioParagraphRef.current = audioParagraph;
          }
        };

        // Attach event listeners
        transcriptSpan?.querySelectorAll('.audio-paragraph')?.forEach((element) => {
          element?.addEventListener('click', handleAudioParagraphClick);
        });

        return () => {
          workerPlayer.terminate();
        };
      }
    }
  }, [vendorNextTranscriptDetailData?.Words, !!vendorNextTranscriptDetailData?.EditTranscript, !!getContent]);

  const transcriptSpans = () => {
    const transcriptSpan = document?.querySelector('.QuillTranscript');
    const handleSpanClick = function (event) {
      const span = event.target;
      const audioParagraph = span?.closest('.audio-paragraph');
      if (audioParagraph) {
        audioParagraphRef.current = audioParagraph;
      }
    };

    // Attach event listeners
    transcriptSpan?.querySelectorAll('span')?.forEach((element) => {
      element?.addEventListener('click', handleSpanClick);
    });

    // Remove event listeners when needed
    transcriptSpan?.querySelectorAll('span')?.forEach((element) => {
      element?.removeEventListener('click', handleSpanClick);
    });

    const handlePClick = function (event) {
      const p = event.target;
      const audioParagraph = p?.closest('.audio-paragraph');
      if (audioParagraph) {
        audioParagraphRef.current = audioParagraph;
      }
    };

    // Attach event listeners
    transcriptSpan?.querySelectorAll('p')?.forEach((element) => {
      element?.addEventListener('click', handlePClick);
    });

    // Remove event listeners when needed
    transcriptSpan?.querySelectorAll('p')?.forEach((element) => {
      element?.removeEventListener('click', handlePClick);
    });

    const handleDivClick = function (event) {
      const div = event.target;
      const audioParagraph = div?.closest('.audio-paragraph');
      if (audioParagraph) {
        audioParagraphRef.current = audioParagraph;
      }
    };

    // Attach event listeners
    transcriptSpan?.querySelectorAll('.audio-paragraph')?.forEach((element) => {
      element?.addEventListener('click', handleDivClick);
    });

    // Remove event listeners when needed
    transcriptSpan?.querySelectorAll('.audio-paragraph')?.forEach((element) => {
      element?.removeEventListener('click', handleDivClick);
    });
  };

  const loadTranscriptParagraph = async (paragraphId) => {
    let i = 0;
    const callTranscriptRequest = async () => {
      try {
        if (paragraphId + i > 0) {
          setnextTranscriptDataLoading(true);
        } else {
          setnextTranscriptDataLoading(false);
        }
        const result = await postApiRequest(PROOFREADER_NEXT_TRANSCRIPT_SUBMIT_URL, {
          audioFileId: id,
          paragraphId: paragraphId + i,
        });
        if (result?.data?.statusCode === 200 && result?.data?.success === true) {
          const transcript = result?.data?.value && JSON.parse(result?.data?.value);
          setGetContent(transcript?.Transcript);

          if (!transcript.isTranscriptParagraphEmpty) {
            // Call again after 5 seconds if the result is true
            setTimeout(() => {
              i++;
              callTranscriptRequest();
            }, 5000);
            return () => clearTimeout(5000);
          } else {
            setIsAllTranscriptLoad(true);
            setnextTranscriptDataLoading(false);
            transcriptSpans();
          }
        } else {
          setIsAllTranscriptLoad(true);
          setnextTranscriptDataLoading(false);
          transcriptSpans();
        }
      } catch (error) {
        throw error;
      }
    };
    if (id) {
      // Initiate the first request
      await callTranscriptRequest();
    }
  };

  function findAudioParagraphParentAndRemoveSubparaClass(range) {
    let parentDiv = range?.startContainer?.parentElement?.closest('.audio-paragraph');
    if (parentDiv) {
      let pTagWithClass = parentDiv?.querySelector('p.uns-area');
      if (pTagWithClass) {
        let firstSpan = pTagWithClass?.querySelector('span');
        if (firstSpan && firstSpan?.classList?.contains('subpara')) {
          firstSpan?.classList?.remove('subpara');
          firstSpan?.classList?.add('seekplay');
          speakerTragetRef.current = parentDiv;
        }
        return pTagWithClass;
      }
    }
    return null;
  }

  function placeCaret(el, beginning) {
    el?.focus();
    if (window?.getSelection && document?.createRange) {
      const range = document?.createRange();
      range?.selectNodeContents(el);
      range?.collapse(beginning);
      const sel = window?.getSelection();
      sel?.removeAllRanges();
      sel?.addRange(range);
    } else if (document?.body?.createTextRange) {
      const textRange = document?.body?.createTextRange();
      textRange?.moveToElementText(el);
      textRange?.collapse(beginning);
      textRange?.select();
    }
  }

  // Toggle function to handle dropdown state
  const handleToggleDropdownComment = (isOpen) => {
    setDropdownOpenComment(isOpen);
  };

  const handleCloseDropdownComment = () => {
    setDropdownOpenComment(false);
  };

  const handleToggleSpeakerDropdown = () => {
    setDropdownOpen((prev) => !prev);
    dropdownOpenRef.current = dropdownOpen;
  };

  const handleChangeForwardTime = async (time) => {
    if (id === null) {
      navigate(DASHBOARD_ROUTE);
    } else {
      if (time) {
        selectedValueRewindPushTime.current = time;
        setselectedValueRewindPushTime(time);
        const param = {
          audioFileId: id,
          userId: userInfo?.UserId,
          rewindOnPause: time,
          fontSize: null,
        };

        try {
          const result = await postApiRequest(SAVE_TRANSCRIPTION_CONFIGURATION_API_URL, param);
        } catch (error) {
          toast.error('Error saving transcription configuration');
        }
      }
    }
  };

  const handleFontSizeChange = async (fontSizeClass) => {
    if (fontSizeClass) {
      setFontSize(fontSizeClass);
      const outputDiv = document?.createElement('div');
      const parentFileParagraphDiv = document?.querySelector(`div[data-parent-file-paragraph-id="1"]`);
      outputDiv.innerHTML = parentFileParagraphDiv?.outerHTML;

      const divElement = document?.querySelector('.jks647');
      divElement?.classList?.forEach((className) => {
        if (className?.startsWith('fnt-main')) {
          divElement?.classList?.remove(className);
        }
      });
      divElement?.classList?.add(fontSizeClass);

      if (id === null) {
        navigate(DASHBOARD_ROUTE);
      } else {
        const param = {
          audioFileId: id,
          userId: userInfo?.UserId,
          rewindOnPause: null,
          fontSize: fontSizeClass,
        };

        try {
          const result = await postApiRequest(SAVE_TRANSCRIPTION_CONFIGURATION_API_URL, param);
        } catch (error) {
          toast.error('Error saving transcription configuration');
        }
      }
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Detecting Ctrl + R
      if ((event.ctrlKey || event.metaKey) && event.key === 'r') {
        event.preventDefault(); // Prevent default browser behavior
        handleFindReplaceOpenModal(); // Open the modal when Ctrl + R is pressed
      }
    };

    const handleClick = (event) => {
      if (
        (event.target?.tagName === 'SPAN' || event.target?.tagName === 'U') &&
        event.target?.id === 'openSpeakerModel'
      ) {
        let defaultSpeakerListHeight = 340;
        if (allSpeakersRef?.current.length <= 1) {
          defaultSpeakerListHeight = 320;
        } else if (allSpeakersRef?.current.length === 2) {
          defaultSpeakerListHeight = 310;
        } else {
          defaultSpeakerListHeight = 340;
        }

        speakerTragetRef.current = event.target;
        const speakerTarget = event.target?.getBoundingClientRect();
        const transcriptScroll = document?.getElementsByClassName('editorView-inner');
        const transcriptTarget = transcriptScroll[0]?.getBoundingClientRect();
        if (transcriptScroll[0].scrollHeight > transcriptScroll[0].clientHeight) {
          setDropdownPosition({
            top:
              transcriptTarget.bottom - speakerTarget.bottom < 340
                ? speakerTarget.top - defaultSpeakerListHeight
                : speakerTarget.bottom,
            left: speakerTarget.left,
          });
        } else {
          setDropdownPosition({
            top:
              transcriptTarget.bottom - speakerTarget.bottom < 340
                ? speakerTarget.top - defaultSpeakerListHeight
                : speakerTarget.bottom,
            left: speakerTarget.left,
            zIndex: 10,
          });
        }
        handleToggleSpeakerDropdown();
        if (allSpeakersRef?.current) {
          allSpeakersRef.current = allSpeakersRef.current.filter(
            (speaker, index, self) =>
              index === self.findIndex((s) => s.trim().toLowerCase() === speaker.trim().toLowerCase()),
          );
        }
        setDropDownOpen();
      } else if (
        (event.target?.tagName === 'svg' || event.target?.tagName === 'DIV') &&
        event.target?.id === 'closedSpeakerModel'
      ) {
        const speakerCheckbox = document?.getElementById('cl2_speaker');
        if (speakerCheckbox) {
          speakerCheckbox.checked = false;
        }
        setDropDownClosed();
      } else if (event.target?.tagName === 'path') {
        const svg = event.target?.parentElement;
        if (svg?.id === 'closedSpeakerModel') {
          const speakerCheckbox = document?.getElementById('cl2_speaker');
          if (speakerCheckbox) {
            speakerCheckbox.checked = false;
          }
          setDropDownClosed();
        }
      } else if (event.target?.tagName === 'A' && event.target?.id === 'createSpeakerLabel') {
        setDropdownOpen(false);
        dropdownOpenRef.current = false;
      } else if (event.target?.id === 'txtSpeakerLabel_speaker') {
        if (allSpeakersRef?.current) {
          allSpeakersRef.current = allSpeakersRef.current.filter(
            (speaker, index, self) =>
              index === self.findIndex((s) => s.trim().toLowerCase() === speaker.trim().toLowerCase()),
          );
        }
        setDropDownOpen();
      } else if (event.target?.tagName === 'IMG') {
        const parentSpan = event.target?.closest('span');
        if (parentSpan && parentSpan?.classList?.contains('seekplay')) {
          const audioPlayerCtrl = document?.getElementById(`audiofile_${id}`);
          if (audioPlayerCtrl) {
            let startTimeInSec = parseFloat(parentSpan?.getAttribute('data-start'));

            if (startTimeInSec !== undefined && startTimeInSec !== '') {
              const playPromise = audioPlayerCtrl?.play();

              if (playPromise !== undefined) {
                playPromise
                  .then(function () {
                    audioPlayerCtrl.currentTime = startTimeInSec;
                  })
                  ?.catch(function (error) {});
              }
            }
          }
        }
      } else if (event.target?.classList?.contains('seekplay')) {
        const audioPlayerCtrl = document?.getElementById(`audiofile_${id}`);
        if (audioPlayerCtrl) {
          let startTimeInSec = parseFloat(event.target?.getAttribute('data-start'));

          if (startTimeInSec !== undefined && startTimeInSec !== '') {
            const playPromise = audioPlayerCtrl?.play();

            if (playPromise !== undefined) {
              playPromise
                .then(function () {
                  audioPlayerCtrl.currentTime = startTimeInSec;
                })
                ?.catch(function (error) {});
            }
          }
        }
      } else {
        const paragraph = event.target?.closest('.audio-paragraph');
        if (paragraph) {
          speakerTragetRef.current = event.target?.closest('.audio-paragraph')?.querySelector('#openSpeakerModel');
        }
        if (dropdownRef?.current && !dropdownRef?.current?.contains(event.target)) {
          const speakerCheckbox = document?.getElementById('cl2_speaker');
          if (speakerCheckbox) {
            speakerCheckbox.checked = false;
          }
          setDropdownOpen(false);
          dropdownOpenRef.current = false;
        } else {
          if (allSpeakersRef?.current) {
            allSpeakersRef.current = allSpeakersRef.current.filter(
              (speaker, index, self) =>
                index === self.findIndex((s) => s.trim().toLowerCase() === speaker.trim().toLowerCase()),
            );
          }
          setDropDownOpen();
        }
      }
    };

    const handleChange = (event) => {
      if (event.target?.classList?.contains('checkCompleteParagraph')) {
        handleCheckboxChange(event);
      }
    };

    window?.addEventListener('click', handleClick);
    window?.addEventListener('change', handleChange);
    window?.addEventListener('keydown', handleKeyDown);

    // Clean up the event listener on component unmount
    return () => {
      window?.removeEventListener('click', handleClick);
      window?.removeEventListener('change', handleChange);
      window?.removeEventListener('keydown', handleKeyDown);
    };
  }, [dropdownRef]);

  const scrollContainer = document?.querySelector('.editorView-inner');

  useEffect(() => {
    if (scrollContainer) {
      const handleScroll = () => {
        if (!!dropdownOpenRef.current && !!speakerTragetRef.current) {
          let defaultSpeakerListHeight = 340;
          if (allSpeakersRef?.current.length <= 1) {
            defaultSpeakerListHeight = 320;
          } else if (allSpeakersRef?.current.length === 2) {
            defaultSpeakerListHeight = 310;
          } else {
            defaultSpeakerListHeight = 340;
          }

          const speakerTarget = speakerTragetRef?.current?.getBoundingClientRect();
          const transcriptScroll = document?.getElementsByClassName('editorView-inner');
          const transcriptTarget = transcriptScroll[0]?.getBoundingClientRect();
          if (transcriptScroll[0].scrollHeight > transcriptScroll[0].clientHeight) {
            setDropdownPosition({
              top:
                transcriptTarget.bottom - speakerTarget.bottom < 340
                  ? speakerTarget.top - defaultSpeakerListHeight
                  : speakerTarget.bottom,
              left: speakerTarget.left,
            });
          } else {
            setDropdownPosition({
              top:
                transcriptTarget.bottom - speakerTarget.bottom < 340
                  ? speakerTarget.top - defaultSpeakerListHeight
                  : speakerTarget.bottom,
              left: speakerTarget.left,
              zIndex: 10,
            });
          }
          handleToggleSpeakerDropdown();
          if (allSpeakersRef?.current) {
            allSpeakersRef.current = allSpeakersRef.current.filter(
              (speaker, index, self) =>
                index === self.findIndex((s) => s.trim().toLowerCase() === speaker.trim().toLowerCase()),
            );
          }
          setDropDownOpen();
        }
      };
      scrollContainer?.addEventListener('scroll', handleScroll);

      return () => {
        scrollContainer?.removeEventListener('scroll', handleScroll);
      };
    }
  }, [scrollContainer]);

  useEffect(() => {
    if (allSpeakers?.length > 0) {
      allSpeakersRef.current = null;
      setTimeout(() => {
        allSpeakersRef.current = allSpeakers;
        didSetInitialSpeakers.current = true;
      }, 500);
      return () => clearTimeout(500);
    }
  }, [allSpeakers]);

  const isPlayingVideo = (audelem) => {
    return !audelem?.paused;
  };

  const getTime = () => {
    const time = new Date()?.toLocaleString([], {
      hour: 'numeric',
      minute: 'numeric',
    });
    return time;
  };

  // Assuming fileData and videoExtensions are already defined
  let mediaFile = editorDetailsData?.UserFileName;

  // Check if the media file contains any of the video extensions in its name
  let containsExtension = videoExtensions?.some((extension) =>
    mediaFile?.toLowerCase()?.includes(extension?.toLowerCase()),
  );

  const handleFillerWordsChange = (event) => {
    setIsFillerWords(event.target.checked);
    setIsCommonErrors(false);
    setReplaceText('');
    findTextArrayRef.current = [];
    setReplacedTextArray([]);
    setIsMatchFullWord(false);
    isMatchFullWordRef.current = false;
    commonErrorsOptionRef.current = '0';
    if (event.target.checked) {
      setFindText('ah uh um');
      isReplaceTextDisabledRef.current = true;
      findFillerWordsInTranscript();
    } else {
      setFindText('');
      isReplaceTextDisabledRef.current = false;
    }
  };

  const findFillerWordsInTranscript = () => {
    removingUnidentifySpan();
    const jks647 = document?.querySelector('.jks647');
    const elements = jks647?.querySelectorAll('p.cb-m.inputwidthmachine span');
    const resultArray = [];
    findTextArrayRef.current = [];

    elements?.forEach((span) => {
      const textContent = span?.textContent;
      if (!textContent) return;

      const splittedSpanText = textContent.trim().split(/\s+/);

      // Find indices of words that contain any filler word
      const matchedInnerWords = [];
      const matchInfoByIndex = {};

      splittedSpanText.forEach((word, index) => {
        // Check each filler word
        for (const fillerWord of fillerWords) {
          const wordLower = isCaseSensitiveRef.current ? word : word.toLowerCase();
          const fillerLower = isCaseSensitiveRef.current ? fillerWord : fillerWord.toLowerCase();

          if (wordLower.includes(fillerLower)) {
            matchedInnerWords.push(index);
            matchInfoByIndex[index] = fillerWord;
          }
        }
      });

      // If no matches found in this span, skip to next span
      if (matchedInnerWords.length === 0) return;

      let count = 1;
      let idCount = 1;
      const findId = span?.getAttribute('data-fnrid');

      matchedInnerWords.forEach((index) => {
        let startText = '';
        let endText = '';

        // Start text
        if (index >= 2) {
          startText = splittedSpanText[index - 2] + ' ' + splittedSpanText[index - 1];
        } else if (index === 1) {
          const previousSpanText = findPreviousSpanText(span, 1);
          startText = previousSpanText + ' ' + splittedSpanText[index - 1];
        } else if (index === 0) {
          const previousSpanText = findPreviousSpanText(span, 0);
          startText = previousSpanText;
        }

        // End Text
        if (splittedSpanText.length > index + 2) {
          endText = splittedSpanText[index + 1] + ' ' + splittedSpanText[index + 2];
        } else {
          if (splittedSpanText.length > index + 1) {
            endText = splittedSpanText[index + 1] + ' ' + findNextSpanText(span, 1);
          } else {
            endText = findNextSpanText(span, 0);
          }
        }

        const matchedWord = splittedSpanText[index];
        const searchTerm = matchInfoByIndex[index];

        // Similar to your original code: split the word by the search term
        const splittedSearchText = (
          isCaseSensitiveRef.current
            ? matchedWord.split(searchTerm)
            : matchedWord.toLowerCase().split(searchTerm.toLowerCase())
        ).filter((part) => part !== '');

        if (matchedWord === searchTerm || splittedSearchText.length === 0) {
          // Case 1: The word is exactly the search term
          const highlightedMatchedPart = `${startText} <span class="findText" id="${findId || idCount}_${count}">${matchedWord}</span> ${endText}`;
          resultArray.push(highlightedMatchedPart);

          const newMatchedSpan = `<span id="${findId || idCount}_${count}">${matchedWord}</span>`;
          splittedSpanText[index] = newMatchedSpan;
        } else if (splittedSearchText.length === 1) {
          // Case 2: The search term is at the beginning or end
          const matchedWordLower = matchedWord.toLowerCase();
          const searchTermLower = searchTerm.toLowerCase();

          const isAtEnd = matchedWordLower.endsWith(searchTermLower);

          if (isAtEnd) {
            // Search term is at the end
            const prefix = matchedWord.substring(0, matchedWord.length - searchTerm.length);
            const foundTerm = matchedWord.substring(matchedWord.length - searchTerm.length);

            const highlightedMatchedPart = `${startText} ${prefix}<span class="findText" id="${findId || idCount}_${count}">${foundTerm}</span> ${endText}`;
            resultArray.push(highlightedMatchedPart);
            const newMatchedSpan = `${prefix}<span id="${!!findId ? findId : idCount}_${count}">${foundTerm}</span>`;
            splittedSpanText[index] = newMatchedSpan;
          } else {
            // Search term is at the beginning
            const foundTerm = matchedWord.substring(0, searchTerm.length);
            const suffix = matchedWord.substring(searchTerm.length);

            const highlightedMatchedPart = `${startText} <span class="findText" id="${findId || idCount}_${count}">${foundTerm}</span>${suffix} ${endText}`;
            resultArray.push(highlightedMatchedPart);
            const newMatchedSpan = `<span id="${findId || idCount}_${count}">${foundTerm}</span>${suffix}`;
            splittedSpanText[index] = newMatchedSpan;
          }
        } else if (splittedSearchText.length === 2) {
          // Case 3: The search term is in the middle
          const parts = isCaseSensitiveRef.current
            ? matchedWord.split(searchTerm)
            : matchedWord.split(new RegExp(searchTerm, 'i'));

          // Find the actual matched term by its position
          const startPos = parts[0].length;
          const matchedPart = matchedWord.substr(startPos, searchTerm.length);

          const highlightedMatchedPart = `${startText} ${parts[0]}<span class="findText" id="${findId || idCount}_${count}">${matchedPart}</span>${parts[1]} ${endText}`;
          resultArray.push(highlightedMatchedPart);
          const newMatchedSpan = `${parts[0]}<span id="${findId || idCount}_${count}">${matchedPart}</span>${parts[1]}`;
          splittedSpanText[index] = newMatchedSpan;
        }

        count++;
        if (!findId) {
          idCount++;
        }
      });

      span.innerHTML = splittedSpanText.join(' ');
    });

    findTextArrayRef.current = resultArray;
    replaceAndHighlightTextForFillerWords();
  };

  const replaceAndHighlightTextForFillerWords = () => {
    if (findTextArrayRef?.current?.length > 0) {
      const newReplacedTextArray = findTextArrayRef?.current?.map((item) => {
        const regex = /<span class="findText" id="\d+_\d+">(.*?)<\/span>/gi;
        return item?.replace(regex, (match, p1) => {
          return `<del class="resultText">${p1}</del>`;
        });
      });
      setReplacedTextArray(newReplacedTextArray);
    }
  };

  const findPreviousSpanText = (span, wordCount = 0) => {
    let previousSpanText = '';

    // Start from the previous sibling
    let sibling = span.previousElementSibling;

    while (sibling) {
      if (sibling.tagName.toLowerCase() === 'span') {
        const text = sibling.textContent.trim();
        const words = text.split(/\s+/).filter((word) => word.trim() !== ''); // Split into words and remove empty

        // If there are words, accumulate them
        if (words.length > 0) {
          previousSpanText = words.join(' ') + ' ' + previousSpanText;
          wordCount += words.length;
        }
      } else {
        break;
      }

      // Stop if we've found two words
      if (wordCount >= 2) {
        break;
      }

      sibling = sibling.previousElementSibling; // Move to the previous sibling
    }

    return previousSpanText.trim();
  };

  const findNextSpanText = (span, wordCount = 0) => {
    let nextSpanText = '';

    // Start from the previous sibling
    let sibling = span.nextElementSibling;

    while (sibling) {
      if (sibling.tagName.toLowerCase() === 'span') {
        const text = sibling.textContent.trim();
        const words = text.split(/\s+/).filter((word) => word.trim() !== ''); // Split into words and remove empty

        // If there are words, accumulate them
        if (words.length > 0) {
          nextSpanText = nextSpanText + ' ' + words.join(' ');
          wordCount += words.length;
        }
      } else {
        break;
      }

      // Stop if we've found two words
      if (wordCount >= 2) {
        break;
      }

      sibling = sibling.nextElementSibling; // Move to the previous sibling
    }

    return nextSpanText.trim();
  };

  const findAndHighlightText = (searchTerm) => {
    findTextArrayRef.current = [];
    setReplacedTextArray([]);

    if (searchTerm) {
      const isValidSearchTerm = /[a-zA-Z0-9]/?.test(searchTerm); // Ensure it contains at least one alphanumeric character
      if (!isValidSearchTerm) {
        return;
      }
      const jks647 = document?.querySelector('.jks647');
      const elements = jks647?.querySelectorAll('p.cb-m.inputwidthmachine span');
      const resultArray = [];

      // Create a regex for finding the search term (apply case sensitivity and full word match)
      const regexFlags = isCaseSensitiveRef?.current ? 'g' : 'gi';
      const regex = isMatchFullWordRef?.current
        ? new RegExp(`\\b${searchTerm}\\b`, regexFlags)
        : new RegExp(searchTerm, regexFlags);

      elements?.forEach((span) => {
        const textContent = span?.textContent;
        if (regex?.test(textContent)) {
          const splittedSpanText = textContent.trim().split(/\s+/);
          const matchedInnerWords = splittedSpanText
            .map((word, index) => {
              if (isMatchFullWordRef?.current && isCaseSensitiveRef?.current) {
                // Both flags are true - exact match required
                return word === searchTerm ? index : -1;
              } else if (isMatchFullWordRef?.current) {
                // Only full word match required, case insensitive
                return word.toLowerCase() === searchTerm.toLowerCase() ? index : -1;
              } else if (isCaseSensitiveRef?.current) {
                // Only case sensitive required, partial match allowed
                return word.includes(searchTerm) ? index : -1;
              } else {
                // Neither flag is true - most flexible match
                return word.toLowerCase().includes(searchTerm.toLowerCase()) ? index : -1;
              }
            })
            .filter((index) => index !== -1);

          let count = 1;
          let idCount = 1;
          const findId = span?.getAttribute('data-fnrid');
          matchedInnerWords.forEach((index) => {
            let startText = '';
            let endText = '';

            // start text
            if (index >= 2) {
              startText = splittedSpanText[index - 2] + ' ' + splittedSpanText[index - 1];
            } else if (index === 1) {
              const previousSpanText = findPreviousSpanText(span, 1);
              startText = previousSpanText + ' ' + splittedSpanText[index - 1];
            } else if (index === 0) {
              const previousSpanText = findPreviousSpanText(span, 0);
              startText = previousSpanText;
            }

            // end Text
            if (splittedSpanText.length > index + 2) {
              endText = splittedSpanText[index + 1] + ' ' + splittedSpanText[index + 2];
            } else {
              if (splittedSpanText.length > index + 1) {
                endText = splittedSpanText[index + 1] + ' ' + findNextSpanText(span, 1);
              } else {
                endText = findNextSpanText(span, 0);
              }
            }

            const splittedSearchText = splittedSpanText[index]
              .trim()
              .toLowerCase()
              .split(`${searchTerm.trim().toLowerCase()}`)
              .filter((word) => word !== '');

            if (splittedSpanText[index] === searchTerm || splittedSearchText.length === 0) {
              const highlightedMatchedPart = `${startText} <span class="findText" id="${!!findId ? findId : idCount}_${count}">${splittedSpanText[index]}</span> ${endText}`;

              resultArray?.push(highlightedMatchedPart);

              const newMatchedSpan = `<span id="${!!findId ? findId : idCount}_${count}">${splittedSpanText[index]}</span>`;
              splittedSpanText[index] = newMatchedSpan;
            } else {
              if (splittedSearchText.length === 1) {
                const substring = splittedSpanText[index].substring(
                  splittedSpanText[index].length - searchTerm.length,
                  splittedSpanText[index].length,
                );
                if (substring.toLowerCase() === searchTerm.toLowerCase()) {
                  const highlightedMatchedPart = `${startText} ${splittedSearchText[0]}<span class="findText" id="${!!findId ? findId : idCount}_${count}">${searchTerm}</span> ${endText}`;
                  resultArray?.push(highlightedMatchedPart);
                  const newMatchedSpan = `${splittedSearchText[0]}<span id="${!!findId ? findId : idCount}_${count}">${searchTerm}</span>`;
                  splittedSpanText[index] = newMatchedSpan;
                } else {
                  const highlightedMatchedPart = `${startText} <span class="findText" id="${!!findId ? findId : idCount}_${count}">${searchTerm}</span>${splittedSearchText[0]} ${endText}`;
                  resultArray?.push(highlightedMatchedPart);
                  const newMatchedSpan = `<span id="${!!findId ? findId : idCount}_${count}">${searchTerm}</span>${splittedSearchText[0]}`;
                  splittedSpanText[index] = newMatchedSpan;
                }
              } else if (splittedSearchText.length === 2) {
                const highlightedMatchedPart = `${startText} ${splittedSearchText[0]}<span class="findText" id="${!!findId ? findId : idCount}_${count}">${searchTerm}</span>${splittedSearchText[1]} ${endText}`;
                resultArray?.push(highlightedMatchedPart);
                const newMatchedSpan = `${splittedSearchText[0]}<span id="${!!findId ? findId : idCount}_${count}">${searchTerm}</span>`;
                splittedSpanText[index] = newMatchedSpan;
              }
            }

            count++;
            if (findId) {
              idCount++;
            }
          });

          span.innerHTML = splittedSpanText.join(' ');
        }
      });

      findTextArrayRef.current = resultArray;

      if (replaceText) {
        replaceAndHighlightText(replaceText);
      }
    }
  };

  const replaceAndHighlightText = (searchTerm) => {
    if (findTextArrayRef?.current?.length > 0) {
      const newReplacedTextArray = findTextArrayRef?.current?.map((item) => {
        const regex = /<span class="findText" id="\d+_\d+">(.*?)<\/span>/gi;
        return item?.replace(regex, `<span class="resultText">${searchTerm}</span>`);
      });

      // Update the state with the new replaced text array
      setReplacedTextArray(newReplacedTextArray);
    }
  };

  const replaceAllTextInTranscript = () => {
    if (replaceText !== '' || isFillerWords) {
      // handle Undo Stack
      undoRedoManage();

      let regex;
      const jks647 = document?.querySelector('.jks647');

      const elements = [...(jks647?.querySelectorAll('p.cb-m.inputwidthmachine span[id]') || [])].filter((el) =>
        /^\d+_\d+$/.test(el.id),
      );

      if (isFillerWords) {
        elements?.forEach((span) => {
          span.outerHTML = '';
        });
      } else if (isCommonErrors) {
        if (commonErrorsOptionRef?.current === '1') {
          regex = /, ,/g;
          elements?.forEach((span) => {
            const textContent = span?.textContent;
            if (textContent?.includes(', ,')) {
              const replacedContent = textContent?.replace(regex, replaceText);
              span.textContent = replacedContent;
            }
          });
        }
        if (commonErrorsOptionRef?.current === '2') {
          regex = /[\s]{2}/g;
          elements?.forEach((span) => {
            const textContent = span?.textContent;
            if (regex?.test(textContent)) {
              const replacedContent = textContent?.replace(regex, replaceText);
              span.textContent = replacedContent;
            }
          });
        }
        if (commonErrorsOptionRef?.current === '3') {
          regex = /\s+\./g;
          elements?.forEach((span) => {
            const textContent = span?.textContent;
            if (regex?.test(textContent)) {
              const replacedContent = textContent?.replace(regex, replaceText);
              span.textContent = replacedContent;
            }
          });
        }
        if (commonErrorsOptionRef?.current === '4') {
          regex = /,,/g;
          elements?.forEach((span) => {
            const textContent = span?.textContent;
            if (regex?.test(textContent)) {
              const replacedContent = textContent?.replace(regex, replaceText);
              span.textContent = replacedContent;
            }
          });
        }
      } else {
        if (!findText && replaceText) return;

        const regexFlags = isCaseSensitiveRef?.current ? 'g' : 'gi';

        regex = isMatchFullWordRef?.current
          ? new RegExp(`\\b${findText}\\b`, regexFlags)
          : new RegExp(findText, regexFlags);

        elements?.forEach((span) => {
          span.outerHTML = replaceText;
        });
      }
      // Reset values after replacing
      setFindText('');
      setReplaceText('');
      findTextArrayRef.current = [];
      setReplacedTextArray([]);
      setIsCommonErrors(false);
      setIsCaseSensitive(false);
      setIsMatchFullWord(false);
      setIsFillerWords(false);
      isCaseSensitiveRef.current = false;
      isMatchFullWordRef.current = false;
      setIsCommonErrors(false);
      commonErrorsOptionRef.current = 0;
      handleFindReplaceCloseModal();

      const parentDiv = document?.querySelector('.jks647');
      const parentFileIds = [];
      if (parentDiv) {
        const paragraphDivs = Array?.from(parentDiv?.querySelectorAll('.parent-file-paragraph-div'));

        paragraphDivs?.forEach((parentFileDiv) => {
          const parentFileId = parentFileDiv?.getAttribute('data-parent-file-paragraph-id');
          if (!parentFileId) return;
          parentFileIds?.push(parentFileId);
        });

        if (parentFileIds?.length > 0) {
          parentFileIds?.map((parentFileId) => {
            if (!uniqueParentFileIdsRef?.current?.includes(parentFileId)) {
              uniqueParentFileIdsRef?.current?.push(parentFileId);
            }
          });

          if (uniqueParentFileIdsRef?.current && uniqueParentFileIdsRef?.current.length > 0) {
            setDebounceValues();
          }
        }
      }
    }
  };

  const replaceSingleTextInTranscript = () => {
    let parentFileId = '';
    if (replaceText !== '' || isFillerWords) {
      // handle Undo Stack
      undoRedoManage();

      let regex;
      const jks647 = document?.querySelector('.jks647');
      const elements = jks647?.querySelectorAll(`p.cb-m.inputwidthmachine span[id="${singleReplaceSpanId}"]`);
      // Update metadata if necessary (e.g., parent file IDs and checkboxes)
      const targetParentFile = elements[0]?.closest('.parent-file-paragraph-div');
      parentFileId = targetParentFile?.getAttribute('data-parent-file-paragraph-id');

      if (isFillerWords) {
        elements?.forEach((span) => {
          span.outerHTML = '';
        });
        const replaceTextUl = document?.querySelector('ul.orignalUL');
        const targetLi = replaceTextUl?.querySelectorAll('li')[singleReplaceSpanIndexRef?.current];
        if (targetLi) {
          findTextArrayRef?.current?.splice(singleReplaceSpanIndexRef?.current, 1);
          replacedTextArray?.splice(singleReplaceSpanIndexRef?.current, 1);
          targetLi?.click();
        }
      } else if (isCommonErrors) {
        if (commonErrorsOptionRef?.current === '1') {
          regex = /, ,/g;
          elements?.forEach((span) => {
            const textContent = span?.textContent;
            if (textContent?.includes(', ,')) {
              const replacedContent = textContent?.replace(regex, replaceText);
              span.textContent = replacedContent;
            }
          });
          const replaceTextUl = document?.querySelector('ul.orignalUL');
          const targetLi = replaceTextUl?.querySelectorAll('li')[singleReplaceSpanIndexRef?.current];
          if (targetLi) {
            findTextArrayRef?.current?.splice(singleReplaceSpanIndexRef?.current, 1);
            replacedTextArray?.splice(singleReplaceSpanIndexRef?.current, 1);
            targetLi?.click();
          }
        }
        if (commonErrorsOptionRef?.current === '2') {
          regex = /[\s]{2}/g;
          elements?.forEach((span) => {
            const textContent = span?.textContent;
            if (regex?.test(textContent)) {
              const replacedContent = textContent?.replace(regex, replaceText);
              span.textContent = replacedContent;
            }
          });
          const replaceTextUl = document?.querySelector('ul.orignalUL');
          const targetLi = replaceTextUl?.querySelectorAll('li')[singleReplaceSpanIndexRef?.current];
          if (targetLi) {
            findTextArrayRef?.current?.splice(singleReplaceSpanIndexRef?.current, 1);
            replacedTextArray?.splice(singleReplaceSpanIndexRef?.current, 1);
            targetLi?.click();
          }
        }
        if (commonErrorsOptionRef?.current === '3') {
          regex = /\s+\./g;
          elements?.forEach((span) => {
            const textContent = span?.textContent;
            if (regex?.test(textContent)) {
              const replacedContent = textContent?.replace(regex, replaceText);
              span.textContent = replacedContent;
            }
          });
          const replaceTextUl = document?.querySelector('ul.orignalUL');
          const targetLi = replaceTextUl?.querySelectorAll('li')[singleReplaceSpanIndexRef?.current];
          if (targetLi) {
            findTextArrayRef?.current?.splice(singleReplaceSpanIndexRef?.current, 1);
            replacedTextArray?.splice(singleReplaceSpanIndexRef?.current, 1);
            targetLi?.click();
          }
        }
        if (commonErrorsOptionRef?.current === '4') {
          regex = /,,/g;
          elements?.forEach((span) => {
            const textContent = span?.textContent;
            if (regex?.test(textContent)) {
              const replacedContent = textContent?.replace(regex, replaceText);
              span.textContent = replacedContent;
            }
          });
          const replaceTextUl = document?.querySelector('ul.orignalUL');
          const targetLi = replaceTextUl?.querySelectorAll('li')[singleReplaceSpanIndexRef?.current];
          if (targetLi) {
            findTextArrayRef?.current?.splice(singleReplaceSpanIndexRef?.current, 1);
            replacedTextArray?.splice(singleReplaceSpanIndexRef?.current, 1);
            targetLi?.click();
          }
        }
      } else {
        if (!findText && replaceText) return;

        elements?.forEach((span) => {
          span.outerHTML = replaceText;
        });

        const replaceTextUl = document?.querySelector('ul.orignalUL');
        const targetLi = replaceTextUl?.querySelectorAll('li')[singleReplaceSpanIndexRef?.current];
        if (targetLi) {
          findTextArrayRef?.current?.splice(singleReplaceSpanIndexRef?.current, 1);
          replacedTextArray?.splice(singleReplaceSpanIndexRef?.current, 1);
          targetLi?.click();
        }
      }

      if (parentFileId) {
        if (!uniqueParentFileIdsRef?.current?.includes(parentFileId)) {
          uniqueParentFileIdsRef?.current?.push(parentFileId);
        }
      }
    }
  };

  const handleChangeCommonErrors = (event) => {
    const value = event.target.value;
    commonErrorsOptionRef.current = value;

    findCommonErrors(value);
  };

  const findCommonErrors = (optionValue) => {
    findTextArrayRef.current = [];
    setReplacedTextArray([]);

    let searchTerm = null;

    switch (optionValue) {
      case '1':
        searchTerm = ', ,';
        break;
      case '2':
        searchTerm = '  ';
        break;
      case '3':
        searchTerm = ' .';
        break;
      case '4':
        searchTerm = ',,';
        break;
      default:
        break;
    }

    if (searchTerm) {
      let regex = null;
      if (searchTerm === ', ,') {
        regex = /, ,/g;
      } else if (searchTerm === '  ') {
        regex = /[\s]{2}/g;
      } else if (searchTerm === ' .') {
        regex = /\s+\./g;
      } else if (searchTerm === ',,') {
        regex = /,,/g;
      }
      const resultArray = [];
      const checkedSpans = new Set();
      const elements = document?.querySelectorAll('p.cb-m.inputwidthmachine');
      elements?.forEach((pTag) => {
        const pTagText = pTag.textContent.replace(/\u00A0/g, ' ');
        if (pTagText) {
          if (regex && regex.test(pTagText)) {
            const spans = Array.from(pTag.querySelectorAll('span'));
            let count = 1;
            let idCount = 1;
            for (let i = 0; i < spans.length; i++) {
              if (checkedSpans.has(spans[i])) continue;
              let text = spans[i].textContent.replace(/\u00A0/g, ' ');
              if (text.includes(', ,')) {
                checkedSpans.add(spans[i]);
                const findId = spans[i]?.getAttribute('data-fnrid');
                const splittedSearchText = text
                  .trim()
                  .toLowerCase()
                  .split(', ,')
                  .filter((word) => word !== '');
                const previousSpanText = findPreviousSpanText(spans[i], 0);
                const startText = previousSpanText;
                const endText = findNextSpanText(spans[i], 0);
                if (text === ', ,' || splittedSearchText.length === 0) {
                  const highlightedMatchedPart = `${startText} <span class="findText" id="${!!findId ? findId : idCount}_${count}">${text}</span> ${endText}`;
                  resultArray?.push(highlightedMatchedPart);
                  const newMatchedSpan = `<span id="${!!findId ? findId : idCount}_${count}">${text}</span>`;
                  spans[i].innerHTML = newMatchedSpan;
                  count++;
                  if (findId) {
                    idCount++;
                  }
                } else if (splittedSearchText.length === 2) {
                  const parts = text.split(', ,');
                  const startPos = parts[0].length;
                  const matchedPart = text.substr(startPos, ', ,'.length);
                  const highlightedMatchedPart = `${startText} ${parts[0]}<span class="findText" id="${findId || idCount}_${count}">${matchedPart}</span>${parts[1]} ${endText}`;
                  resultArray.push(highlightedMatchedPart);
                  const newMatchedSpan = `${parts[0]}<span id="${findId || idCount}_${count}">${matchedPart}</span>${parts[1]}`;
                  spans[i].innerHTML = newMatchedSpan;
                }
              } else if (
                text.includes(', ') &&
                spans[i + 1] &&
                spans[i + 1].textContent.replace(/\u00A0/g, ' ').startsWith(',')
              ) {
                resultArray.push(spans[i], spans[i + 1]);
                checkedSpans.add(spans[i]);
                checkedSpans.add(spans[i + 1]);
              } else if (
                text.includes(',') &&
                spans[i + 1] &&
                spans[i + 1].textContent.replace(/\u00A0/g, ' ').startsWith(' ,')
              ) {
                resultArray.push(spans[i], spans[i + 1]);
                checkedSpans.add(spans[i]);
                checkedSpans.add(spans[i + 1]);
              } else if (
                text.includes(',') &&
                spans[i + 1]?.textContent.replace(/\u00A0/g, ' ').startsWith(' ') &&
                spans[i + 2]?.textContent.replace(/\u00A0/g, ' ').startsWith(',')
              ) {
                resultArray.push(spans[i], spans[i + 1], spans[i + 2]);
                checkedSpans.add(spans[i]);
                checkedSpans.add(spans[i + 1]);
                checkedSpans.add(spans[i + 2]);
              }
            }
          }
        }
      });

      findTextArrayRef.current = resultArray;
      if (replaceText) {
        replaceAndHighlightText(replaceText);
      }
    }
  };

  // Debounce for smooth search performance
  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (findText && !isFillerWords) {
        findAndHighlightText(findText);
      }
    }, 300); // 300ms debounce

    return () => clearTimeout(debounceTimer); // Cleanup the debounce timer
  }, [findText]);

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (replaceText) {
        replaceAndHighlightText(replaceText);
      }
    }, 300); // 300ms debounce

    return () => clearTimeout(debounceTimer); // Cleanup the debounce timer
  }, [replaceText]);

  const handleCheckboxChange = (event) => {
    handleCheckTranscriptEditor(event);
  };

  // full editor changes
  const handleOpenEditor = (e) => {
    const event = e.target?.closest('.cb-m.inputwidthmachine');
    if (event) {
      contentRef?.current?.forEach((ref, idx) => {
        ref.contentEditable = true;
        ref.style.pointerEvents = 'auto';
        ref.style.opacity = '1';
      });
      const inputElements = document?.querySelectorAll('.cb-m.inputwidthmachine');

      // If multiple divs exist, process each individually
      inputElements?.forEach((input) => {
        input?.setAttribute('contenteditable', 'true');
      });

      const element = document?.querySelector('.jks647');

      if (element) {
        if (!element?.classList?.contains('editorBorder')) {
          element?.classList?.add('editorBorder');
        }
      }
    }
    const handleDocumentClick = function (event) {
      const element = document?.querySelector('.jks647');
      if (element && !element?.contains(event.target)) {
        if (element?.classList?.contains('editorBorder')) {
          element?.classList?.remove('editorBorder');
          contentRef?.current?.forEach((ref, idx) => {
            ref.contentEditable = false;
            ref.style.pointerEvents = 'auto';
            ref.style.opacity = '1';
          });
          const inputElements = document?.querySelectorAll('.cb-m.inputwidthmachine');
          inputElements?.forEach((input) => {
            input?.setAttribute('contenteditable', 'false');
          });
        }
      }
    };

    // Attach event listener
    document?.addEventListener('click', handleDocumentClick);

    // Remove event listener when needed
    document?.removeEventListener('click', handleDocumentClick);
  };

  const handleKeyDownInEditor = (e) => {
    if ((e.key === 'Enter' || e.keyCode === 13) && !e.shiftKey && !(e.ctrlKey || e.metaKey)) {
      if (e.target?.classList?.contains('fw400') || e.target?.classList?.contains('fw500')) {
        e.preventDefault();
      } else {
        e.preventDefault();
        keyDownTrigger.current = true;
        speakerCreateRef.current = true;
        handleSingleEnterKeyDownInEditor(e);
      }
    } else if ((e.ctrlKey || e.metaKey) && (e.key === 'z' || e.keyCode === 90 || e.key === 'KeyZ')) {
      playerPlayPause(false);
      handleUndoEvent(e);
      e.preventDefault();
    } else if ((e.ctrlKey || e.metaKey) && (e.key === 'y' || e.keyCode === 89 || e.key === 'KeyY')) {
      playerPlayPause(false);
      handleRedoEvent(e);
      e.preventDefault();
    } else if ((e.ctrlKey || e.metaKey) && (e.key === 'x' || e.keyCode === 88)) {
      playerPlayPause(false);
      handleCutKeyInEditor(e);
      keyDownTrigger.current = true;
    } else if (e.keyCode === 8 || e.key === 'Backspace') {
      keyDownTrigger.current = true;
      playerPlayPause(false);
      handleBackspaceKeyInEditor(e);
    } else if (e.target?.classList?.contains('fw400') && !((e.ctrlKey || e.metaKey) && e.key === 'Enter')) {
      const audioParagraph = e.target?.closest('.audio-paragraph');
      if (audioParagraph) {
        speakerTragetRef.current = audioParagraph?.querySelector('#openSpeakerModel');
      }
      const allowedKeys = /^[0-9:]$/;
      const allowedKeyCodes = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
      if (!allowedKeys?.test(e.key) && !allowedKeyCodes?.includes(e.key)) {
        e.preventDefault();
        return;
      }
    } else if ((e.key === 'Enter' || e.keyCode === 13) && e.shiftKey) {
      e.preventDefault();
      return;
    }
  };

  const isLastNonEmptySpan = (span) => {
    if (!span || span?.textContent?.trim() !== '') {
      return span;
    }
    return isLastNonEmptySpan(span?.previousElementSibling);
  };

  const handleSingleEnterKeyDownInEditor = (e) => {
    const selection = window?.getSelection();
    if (selection && selection?.rangeCount > 0) {
      const range = selection?.getRangeAt(0);
      if (audioParagraphRef?.current) {
        const editAreaDiv = audioParagraphRef?.current?.querySelector('.editArea');
        if (editAreaDiv) {
          const checkbox = editAreaDiv?.querySelector("input[type='checkbox']");
          if (checkbox) {
            const isCheckboxSelected = audioParagraphRef?.current?.getAttribute('data-ischeckboxselected-proofreader');
            if (isCheckboxSelected === 'true') {
              checkboxManualTrigger.current = true;
              checkbox?.click();
              checkbox?.removeAttribute('checked');
            }
          }
        }
      }
      if (range?.startOffset === 0 && range?.endOffset === 0) {
        // handle Undo Stack
        undoRedoManage();

        findAudioParagraphParentAndRemoveSubparaClass(range);
        setDebounceValues();
        setDropdownOpen(false);
        dropdownOpenRef.current = false;
      } else {
        let currentSpan = range?.startContainer;
        if (currentSpan.nodeType === Node.TEXT_NODE) {
          currentSpan = currentSpan?.parentNode;
        }

        const parentPTag = currentSpan?.closest('p');
        const lastNonEmptySpan = isLastNonEmptySpan(parentPTag?.lastElementChild);
        const isLastSpanInPTag = currentSpan === lastNonEmptySpan;

        const isCursorAtEndOfLastSpan = isLastSpanInPTag && range?.endOffset === currentSpan?.textContent?.length;

        if (isLastSpanInPTag && isCursorAtEndOfLastSpan) {
          return;
        }

        if (currentSpan?.tagName !== 'SPAN') {
          let previousSpan = currentSpan?.previousSibling;
          let nextSpan = currentSpan?.nextSibling;

          if (previousSpan && previousSpan?.tagName === 'SPAN') {
            currentSpan = previousSpan;
          } else if (nextSpan && nextSpan?.tagName === 'SPAN') {
            currentSpan = nextSpan;
          } else {
            return;
          }
        }

        // handle Undo Stack
        undoRedoManage();

        let dataStart = currentSpan?.getAttribute('data-start');

        if (currentSpan.innerText?.trim() === '') {
          if (currentSpan?.previousElementSibling === null) {
            dataStart = currentSpan?.parentNode?.previousElementSibling?.getAttribute('data-start');
          } else {
            dataStart = currentSpan?.previousElementSibling?.getAttribute('data-start');
          }
        }
        const textBeforeCursor = currentSpan?.textContent?.slice(0, range?.startOffset);
        const textAfterCursor = currentSpan?.textContent?.slice(range?.startOffset);
        let idAfterCursor = currentSpan?.getAttribute('id');

        if (!idAfterCursor) {
          let previousElement = currentSpan?.previousElementSibling;
          while (previousElement) {
            if (previousElement?.tagName === 'SPAN' && previousElement?.getAttribute('id')) {
              idAfterCursor = previousElement?.getAttribute('id');
              break;
            }
            previousElement = previousElement?.previousElementSibling;
          }
        }
        currentSpan.textContent = textBeforeCursor;
        const newSpan = document?.createElement('span');
        newSpan.textContent = textAfterCursor;

        if (idAfterCursor) {
          newSpan?.setAttribute('id', idAfterCursor);
        }
        newSpan?.setAttribute('data-start', dataStart);

        const spansToMove = [];
        let nextSibling = currentSpan?.nextSibling;
        while (nextSibling) {
          spansToMove?.push(nextSibling);
          const toRemove = nextSibling;
          nextSibling = nextSibling?.nextSibling;
          toRemove?.remove();
        }

        let seekplayStart = dataStart;
        const createNewParagraph = (spansToMove, newSpan, newSpanDataStart) => {
          const spansToMoveHTML = spansToMove?.map((span) => span?.outerHTML)?.join('');
          const newSpanHTML = newSpan?.outerHTML;
          const HTML = `
          <div class="trans-row d-block newpara changed audio-paragraph">
            <div class="form-group mb-2">
              <p class="mb-0 uns-area" contenteditable="false">
                <span class="spk_1 inputwidthmachine mr-3 fs13 fw500 cb-d scope-one text-capitalize subpara tf" role="textbox" contenteditable="true" id="openSpeakerModel">
                ${plusIconHTML}
                  <u id="openSpeakerModel">add speaker</u>
                </span>
                <span class="d-inline-block pl-bx seekplay" data-start="${seekplayStart}" contenteditable="false">
                 <img src="${playIcon}" contenteditable="false" style="cursor: pointer; height: 20px;"></img>
                </span>
                <span class="timecls_spk_1 inputwidthmachine d-inline-block fs13 fw400 c-o tf" role="textbox" contenteditable="true">${newSpanDataStart}</span>
              </p>
            </div>
            <div class="form-group mb-4">
              <p class="mb-0 cb-m fs17 inputwidthmachine tf" role="textbox" spellcheck="true" contenteditable="true">
              ${newSpanHTML}
              ${spansToMoveHTML}
              </p>
            </div>
            <div class="editArea" contenteditable="false">
              <input type="checkbox" class="form-check-input checkCompleteParagraph">
            </div>
          </div>`;
          return HTML;
        };

        let previousDataStart = null; // Store the last valid dataStart value
        const audioParagraphDiv = currentSpan?.closest('.audio-paragraph');

        if (dataStart === null || dataStart === undefined || dataStart === '') {
          dataStart = previousDataStart; // Use the last valid dataStart value if the current one is invalid
        } else {
          if (isNumeric(dataStart)) {
            dataStart = timeFormatting(parseFloat(dataStart)); // Format numeric dataStart
          } else {
            if (dataStart?.indexOf('-') !== -1) {
              dataStart = dataStart?.split('-')[0]; // Take the part before the hyphen
            }

            // Check if the timestamp is 8 characters long and starts with "00"
            if (dataStart?.length === 8 && dataStart?.startsWith('00')) {
              dataStart = dataStart?.substring(3); // Remove the first three characters ("00:")
            }
          }

          // Update the previousDataStart to the current valid dataStart for future use
          previousDataStart = dataStart;
        }

        const newParagraphHTML = createNewParagraph(spansToMove, newSpan, dataStart);
        if (audioParagraphDiv) {
          audioParagraphDiv?.insertAdjacentHTML('afterend', newParagraphHTML);
        }
        const newParagraph = audioParagraphDiv?.nextElementSibling;
        const targetSpan = newParagraph?.querySelector('p.cb-m.inputwidthmachine');
        targetSpan?.focus();
        if (targetSpan) {
          placeCaret(targetSpan, true);
        }

        const targetParantFile = currentSpan?.closest('.parent-file-paragraph-div');
        const parentFileId = targetParantFile?.getAttribute('data-parent-file-paragraph-id');

        if (parentFileId) {
          if (!uniqueParentFileIdsRef?.current?.includes(parentFileId)) {
            uniqueParentFileIdsRef?.current?.push(parentFileId);
          }
        }

        const inputElements = document?.querySelectorAll('.cb-m.inputwidthmachine');

        // If multiple divs exist, process each individually
        inputElements?.forEach((input) => {
          input?.setAttribute('contenteditable', 'true');
        });

        speakerTragetRef.current = targetSpan;
        setDebounceValues();
        setDropdownOpen(false);
        dropdownOpenRef.current = false;

        const handleClick = (event) => {
          if (
            (event.target?.tagName === 'SPAN' || event.target?.tagName === 'U') &&
            event.target?.id === 'openSpeakerModel'
          ) {
            let defaultSpeakerListHeight = 340;
            if (allSpeakersRef?.current.length <= 1) {
              defaultSpeakerListHeight = 320;
            } else if (allSpeakersRef?.current.length === 2) {
              defaultSpeakerListHeight = 310;
            } else {
              defaultSpeakerListHeight = 340;
            }

            speakerTragetRef.current = event.target;
            const speakerTarget = event.target?.getBoundingClientRect();
            const transcriptScroll = document?.getElementsByClassName('editorView-inner');
            const transcriptTarget = transcriptScroll[0]?.getBoundingClientRect();
            if (transcriptScroll[0].scrollHeight > transcriptScroll[0].clientHeight) {
              setDropdownPosition({
                top:
                  transcriptTarget.bottom - speakerTarget.bottom < 340
                    ? speakerTarget.top - defaultSpeakerListHeight
                    : speakerTarget.bottom,
                left: speakerTarget.left,
              });
            } else {
              setDropdownPosition({
                top:
                  transcriptTarget.bottom - speakerTarget.bottom < 340
                    ? speakerTarget.top - defaultSpeakerListHeight
                    : speakerTarget.bottom,
                left: speakerTarget.left,
                zIndex: 10,
              });
            }
            handleToggleSpeakerDropdown();
            if (allSpeakersRef?.current) {
              allSpeakersRef.current = allSpeakersRef.current.filter(
                (speaker, index, self) =>
                  index === self.findIndex((s) => s.trim().toLowerCase() === speaker.trim().toLowerCase()),
              );
            }
            setDropDownOpen();
          } else if (
            (event.target?.tagName === 'svg' || event.target?.tagName === 'DIV') &&
            event.target?.id === 'closedSpeakerModel'
          ) {
            const speakerCheckbox = document?.getElementById('cl2_speaker');
            if (speakerCheckbox) {
              speakerCheckbox.checked = false;
            }
            setDropDownClosed();
          } else if (event.target?.tagName === 'path') {
            const svg = event.target?.parentElement;
            if (svg?.id === 'closedSpeakerModel') {
              const speakerCheckbox = document?.getElementById('cl2_speaker');
              if (speakerCheckbox) {
                speakerCheckbox.checked = false;
              }
              setDropDownClosed();
            }
          } else if (event.target?.tagName === 'A' && event.target?.id === 'createSpeakerLabel') {
            setDropdownOpen(false);
            dropdownOpenRef.current = false;
          } else if (event.target?.id === 'txtSpeakerLabel_speaker') {
            if (allSpeakersRef?.current) {
              allSpeakersRef.current = allSpeakersRef.current.filter(
                (speaker, index, self) =>
                  index === self.findIndex((s) => s.trim().toLowerCase() === speaker.trim().toLowerCase()),
              );
            }
            setDropDownOpen();
          } else if (event.target?.tagName === 'IMG') {
            const parentSpan = event.target?.closest('span');
            if (parentSpan && parentSpan?.classList?.contains('seekplay')) {
              const audioPlayerCtrl = document?.getElementById(`audiofile_${id}`);
              if (audioPlayerCtrl) {
                let startTimeInSec = parseFloat(parentSpan?.getAttribute('data-start'));

                if (startTimeInSec !== undefined && startTimeInSec !== '') {
                  const playPromise = audioPlayerCtrl?.play();

                  if (playPromise !== undefined) {
                    playPromise
                      .then(function () {
                        audioPlayerCtrl.currentTime = startTimeInSec;
                      })
                      ?.catch(function (error) {});
                  }
                }
              }
            }
          } else if (event.target?.classList?.contains('seekplay')) {
            const audioPlayerCtrl = document?.getElementById(`audiofile_${id}`);
            if (audioPlayerCtrl) {
              let startTimeInSec = parseFloat(event.target?.getAttribute('data-start'));

              if (startTimeInSec !== undefined && startTimeInSec !== '') {
                const playPromise = audioPlayerCtrl?.play();

                if (playPromise !== undefined) {
                  playPromise
                    .then(function () {
                      audioPlayerCtrl.currentTime = startTimeInSec;
                    })
                    ?.catch(function (error) {});
                }
              }
            }
          } else {
            const paragraph = event.target?.closest('.audio-paragraph');
            if (paragraph) {
              speakerTragetRef.current = event.target?.closest('.audio-paragraph')?.querySelector('#openSpeakerModel');
            }
            if (dropdownRef?.current && !dropdownRef?.current?.contains(event.target)) {
              const speakerCheckbox = document?.getElementById('cl2_speaker');
              if (speakerCheckbox) {
                speakerCheckbox.checked = false;
              }
              setDropdownOpen(false);
              dropdownOpenRef.current = false;
            } else {
              if (allSpeakersRef?.current) {
                allSpeakersRef.current = allSpeakersRef.current.filter(
                  (speaker, index, self) =>
                    index === self.findIndex((s) => s.trim().toLowerCase() === speaker.trim().toLowerCase()),
                );
              }
              setDropDownOpen();
            }
          }
        };

        window?.addEventListener('click', handleClick);
        return () => {
          window?.removeEventListener('click', handleClick);
        };
      }
    }
  };

  const handleCutKeyInEditor = (e) => {
    // handle Undo Stack
    undoRedoManage();

    if (audioParagraphRef?.current) {
      const editAreaDiv = audioParagraphRef?.current?.querySelector('.editArea');
      if (editAreaDiv) {
        const checkbox = editAreaDiv?.querySelector("input[type='checkbox']");
        if (checkbox) {
          const isCheckboxSelected = audioParagraphRef?.current?.getAttribute('data-ischeckboxselected-proofreader');
          if (isCheckboxSelected === 'true') {
            checkboxManualTrigger.current = true;
            checkbox?.click();
            checkbox?.removeAttribute('checked');
          }
        }
      }
    }

    const selection = window?.getSelection();

    if (selection?.rangeCount > 0) {
      const range = selection?.getRangeAt(0);

      if (range?.startOffset === 0 && range?.endOffset === 0) {
        let currentSpan = range?.startContainer;
        const targetElement = range?.startContainer?.parentElement?.parentElement;
        const unsAreaElement = targetElement?.querySelector('.uns-area');
        if (unsAreaElement) {
          const inputWidthMachineElement = unsAreaElement?.querySelector('.inputwidthmachine');
          if (inputWidthMachineElement) {
            if (!inputWidthMachineElement?.classList?.contains('subpara')) {
              inputWidthMachineElement?.classList?.add('subpara');
              e.preventDefault();
              const targetParantFile = currentSpan?.parentElement?.closest('.parent-file-paragraph-div');
              const parentFileId = targetParantFile?.getAttribute('data-parent-file-paragraph-id');

              if (parentFileId) {
                if (!uniqueParentFileIdsRef?.current?.includes(parentFileId)) {
                  uniqueParentFileIdsRef?.current?.push(parentFileId);
                }
              }
              setDropdownOpen(false);
              setDropDownClosed();
              return;
            }
          }
        }

        if (currentSpan.nodeType === Node.TEXT_NODE) {
          currentSpan = currentSpan?.parentNode;
        }

        const currentPTag = currentSpan?.closest('p.cb-m.inputwidthmachine');

        if (currentPTag) {
          const currentAudioParagraph = currentPTag?.closest('.audio-paragraph');

          const previousAudioParagraph = currentAudioParagraph?.previousElementSibling;
          if (previousAudioParagraph && previousAudioParagraph?.classList?.contains('audio-paragraph')) {
            const previousPTag = previousAudioParagraph?.querySelector('p.cb-m.inputwidthmachine');

            if (previousPTag) {
              const spansToMove = currentPTag?.querySelectorAll('span');
              spansToMove?.forEach((span) => {
                previousPTag?.appendChild(span);
              });

              const lastSpan = previousPTag?.lastElementChild;
              if (lastSpan) {
                const newRange = document?.createRange();
                newRange?.setStartAfter(lastSpan);
                newRange?.collapse(true);

                selection?.removeAllRanges();
                selection?.addRange(newRange);
                lastSpan?.focus();
              }
              currentAudioParagraph?.remove();
              e.preventDefault();
              const targetParantFile = lastSpan?.closest('.parent-file-paragraph-div');
              if (targetParantFile) {
                const parentFileId = targetParantFile?.getAttribute('data-parent-file-paragraph-id');

                if (parentFileId) {
                  if (!uniqueParentFileIdsRef?.current?.includes(parentFileId)) {
                    uniqueParentFileIdsRef?.current?.push(parentFileId);
                  }
                }

                const editAreaDiv = previousAudioParagraph?.querySelector('.editArea');
                if (editAreaDiv) {
                  const checkbox = editAreaDiv?.querySelector("input[type='checkbox']");
                  if (checkbox) {
                    const isCheckboxSelected = previousAudioParagraph?.getAttribute(
                      'data-ischeckboxselected-proofreader',
                    );
                    if (isCheckboxSelected === 'true') {
                      checkboxManualTrigger.current = true;
                      checkbox?.click();
                      checkbox?.removeAttribute('checked');
                    }
                  }
                }
                setDebounceValues();
                setDropDownClosed();
              }
            }
          } else {
            if (currentAudioParagraph?.parentNode?.classList?.contains('parent-file-paragraph-div')) {
              const parentElement = currentAudioParagraph?.parentNode;
              const dataValue = parentElement?.getAttribute('data-parent-file-paragraph-id');
              const targetDataValue = parseInt(dataValue) - 1;
              const targetElement = document?.querySelector(`[data-parent-file-paragraph-id='${targetDataValue}']`);
              if (targetElement) {
                const lastDiv = targetElement?.querySelector('div.audio-paragraph:last-of-type');
                if (lastDiv) {
                  const previousPTag = lastDiv?.querySelector('p.cb-m.inputwidthmachine');
                  if (previousPTag) {
                    const spansToMove = currentPTag?.querySelectorAll('span');
                    spansToMove?.forEach((span) => {
                      previousPTag?.appendChild(span);
                    });

                    const lastSpan = previousPTag?.lastElementChild;
                    if (lastSpan) {
                      const newRange = document?.createRange();
                      newRange?.setStartAfter(lastSpan);
                      newRange?.collapse(true);

                      selection?.removeAllRanges();
                      selection?.addRange(newRange);
                      lastSpan?.focus();
                    }
                    currentAudioParagraph?.remove();
                    e.preventDefault();

                    // old paragraph
                    if (!uniqueParentFileIdsRef?.current?.includes(String(targetDataValue))) {
                      uniqueParentFileIdsRef?.current?.push(String(targetDataValue));
                    }

                    // new paragraph
                    if (!uniqueParentFileIdsRef?.current?.includes(dataValue)) {
                      uniqueParentFileIdsRef?.current?.push(dataValue);
                    }

                    const editAreaDiv = lastDiv?.querySelector('.editArea');
                    if (editAreaDiv) {
                      const checkbox = editAreaDiv?.querySelector("input[type='checkbox']");
                      if (checkbox) {
                        const isCheckboxSelected = lastDiv?.getAttribute('data-ischeckboxselected-proofreader');
                        if (isCheckboxSelected === 'true') {
                          checkboxManualTrigger.current = true;
                          checkbox?.click();
                          checkbox?.removeAttribute('checked');
                        }
                      }
                    }
                    setDebounceValues();
                    setDropDownClosed();
                  }
                }
              }
            }
          }
        }
      } else {
        let currentSpan = range?.startContainer;

        if (currentSpan.nodeType === Node.TEXT_NODE) {
          currentSpan = currentSpan?.parentNode;
        }

        // Check if the current span has the "fw400" class
        if (currentSpan?.classList?.contains('fw400')) {
          const childNodes = Array?.from(currentSpan.childNodes);
          const hasNonEmptyText = childNodes?.some(
            (child) => child.nodeType === Node.TEXT_NODE && child?.textContent?.trim()?.length > 0,
          );

          if (!hasNonEmptyText) {
            // If all child nodes are empty, do not remove the currentSpan
            e.preventDefault();
            return;
          }
        }
      }
    }
  };

  const handleBackspaceKeyInEditor = (e) => {
    // handle Undo Stack
    undoRedoManage();

    if (audioParagraphRef?.current) {
      const editAreaDiv = audioParagraphRef?.current?.querySelector('.editArea');
      if (editAreaDiv) {
        const checkbox = editAreaDiv?.querySelector("input[type='checkbox']");
        if (checkbox) {
          const isCheckboxSelected = audioParagraphRef?.current?.getAttribute('data-ischeckboxselected-proofreader');
          if (isCheckboxSelected === 'true') {
            checkboxManualTrigger.current = true;
            checkbox?.click();
            checkbox?.removeAttribute('checked');
          }
        }
      }
    }

    const selection = window?.getSelection();

    if (selection?.rangeCount > 0) {
      const range = selection?.getRangeAt(0);

      if (range?.startOffset === 0 && range?.endOffset === 0) {
        let currentSpan = range?.startContainer;

        const targetElement = range?.startContainer?.parentElement?.parentElement;

        const unsAreaElement = targetElement?.querySelector('.uns-area');
        if (unsAreaElement) {
          const inputWidthMachineElement = unsAreaElement?.querySelector('.inputwidthmachine');
          if (inputWidthMachineElement) {
            if (!inputWidthMachineElement?.classList?.contains('subpara')) {
              inputWidthMachineElement?.classList?.add('subpara');
              e.preventDefault();
              const targetParantFile = currentSpan?.parentElement?.closest('.parent-file-paragraph-div');
              const parentFileId = targetParantFile?.getAttribute('data-parent-file-paragraph-id');

              if (parentFileId) {
                if (!uniqueParentFileIdsRef?.current?.includes(parentFileId)) {
                  uniqueParentFileIdsRef?.current?.push(parentFileId);
                }
              }
              setDebounceValues();
              setDropDownClosed();
              return;
            }
          }
        }

        if (currentSpan.nodeType === Node.TEXT_NODE) {
          currentSpan = currentSpan?.parentNode;
        }

        const currentPTag = currentSpan?.closest('p.cb-m.inputwidthmachine');

        if (currentPTag) {
          const currentAudioParagraph = currentPTag?.closest('.audio-paragraph');

          const previousAudioParagraph = currentAudioParagraph?.previousElementSibling;
          if (previousAudioParagraph && previousAudioParagraph?.classList?.contains('audio-paragraph')) {
            const previousPTag = previousAudioParagraph?.querySelector('p.cb-m.inputwidthmachine');

            if (previousPTag) {
              const spansToMove = currentPTag?.querySelectorAll('span');
              spansToMove?.forEach((span) => {
                previousPTag?.appendChild(span);
              });

              const lastSpan = previousPTag?.lastElementChild;
              if (lastSpan) {
                const newRange = document?.createRange();
                newRange?.setStartAfter(lastSpan);
                newRange?.collapse(true);

                selection?.removeAllRanges();
                selection?.addRange(newRange);
                lastSpan?.focus();
              }
              currentAudioParagraph?.remove();
              e.preventDefault();
              const targetParantFile = lastSpan?.closest('.parent-file-paragraph-div');
              if (targetParantFile) {
                const parentFileId = targetParantFile?.getAttribute('data-parent-file-paragraph-id');

                if (parentFileId) {
                  if (!uniqueParentFileIdsRef?.current?.includes(parentFileId)) {
                    uniqueParentFileIdsRef?.current?.push(parentFileId);
                  }
                }

                const editAreaDiv = previousAudioParagraph?.querySelector('.editArea');
                if (editAreaDiv) {
                  const checkbox = editAreaDiv?.querySelector("input[type='checkbox']");
                  if (checkbox) {
                    const isCheckboxSelected = previousAudioParagraph?.getAttribute(
                      'data-ischeckboxselected-proofreader',
                    );
                    if (isCheckboxSelected === 'true') {
                      checkboxManualTrigger.current = true;
                      checkbox?.click();
                      checkbox?.removeAttribute('checked');
                    }
                  }
                }
                setDebounceValues();
                setDropDownClosed();
              }
            }
          } else {
            if (currentAudioParagraph?.parentNode?.classList?.contains('parent-file-paragraph-div')) {
              const parentElement = currentAudioParagraph?.parentNode;
              const dataValue = parentElement?.getAttribute('data-parent-file-paragraph-id');
              const targetDataValue = parseInt(dataValue) - 1;
              const targetElement = document?.querySelector(`[data-parent-file-paragraph-id='${targetDataValue}']`);
              if (targetElement) {
                const lastDiv = targetElement?.querySelector('div.audio-paragraph:last-of-type');
                if (lastDiv) {
                  const previousPTag = lastDiv?.querySelector('p.cb-m.inputwidthmachine');
                  if (previousPTag) {
                    const spansToMove = currentPTag?.querySelectorAll('span');
                    spansToMove?.forEach((span) => {
                      previousPTag?.appendChild(span);
                    });

                    const lastSpan = previousPTag?.lastElementChild;
                    if (lastSpan) {
                      const newRange = document?.createRange();
                      newRange?.setStartAfter(lastSpan);
                      newRange?.collapse(true);

                      selection?.removeAllRanges();
                      selection?.addRange(newRange);
                      lastSpan?.focus();
                    }
                    currentAudioParagraph?.remove();
                    e.preventDefault();

                    // old paragraph
                    if (!uniqueParentFileIdsRef?.current?.includes(String(targetDataValue))) {
                      uniqueParentFileIdsRef?.current?.push(String(targetDataValue));
                    }

                    // new paragraph
                    if (!uniqueParentFileIdsRef?.current?.includes(dataValue)) {
                      uniqueParentFileIdsRef?.current?.push(dataValue);
                    }

                    const editAreaDiv = lastDiv?.querySelector('.editArea');
                    if (editAreaDiv) {
                      const checkbox = editAreaDiv?.querySelector("input[type='checkbox']");
                      if (checkbox) {
                        const isCheckboxSelected = lastDiv?.getAttribute('data-ischeckboxselected-proofreader');
                        if (isCheckboxSelected === 'true') {
                          checkboxManualTrigger.current = true;
                          checkbox?.click();
                          checkbox?.removeAttribute('checked');
                        }
                      }
                    }
                    setDebounceValues();
                    setDropDownClosed();
                  }
                }
              }
            }
          }
        }
      } else {
        let currentSpan = range?.startContainer;

        if (currentSpan.nodeType === Node.TEXT_NODE) {
          currentSpan = currentSpan?.parentNode;
        }

        // Check if the current span has the "fw400" class
        if (currentSpan?.classList?.contains('fw400')) {
          const childNodes = Array?.from(currentSpan.childNodes);
          const hasNonEmptyText = childNodes?.some(
            (child) => child.nodeType === Node.TEXT_NODE && child?.textContent?.trim()?.length > 0,
          );

          if (!hasNonEmptyText) {
            // If all child nodes are empty, do not remove the currentSpan
            e.preventDefault();
            return;
          }
        }
      }
    }
  };

  const updateCheckBoxPercentage = () => {
    const audioParagraphs = document?.querySelectorAll('.audio-paragraph P.cb-m.inputwidthmachine span');
    const selectedAudioParagraphs = document?.querySelectorAll(
      '.audio-paragraph[data-ischeckboxselected-proofreader="true"] p.cb-m.inputwidthmachine span',
    );
    const totalChars = Array.from(audioParagraphs).reduce((count, span) => count + (span.textContent || '').length, 0);
    const selectedChars = Array.from(selectedAudioParagraphs).reduce(
      (count, span) => count + (span.textContent || '').length,
      0,
    );
    let completionPercentage = totalChars > 0 ? Math.round(((selectedChars * 100) / totalChars) * 100) / 100 : 0;
    completedPercentageRef.current = completionPercentage;
    totalAudioParagraphsRef.current = totalChars;
    selectedAudioParagraphsRef.current = selectedChars;
  };

  const handleCheckTranscriptEditor = async (e) => {
    if (checkboxManualTrigger.current === false) {
      // handle Undo Stack
      undoRedoManage(2);
    } else {
      checkboxManualTrigger.current = false;
    }

    const isChecked = e.target.checked;
    const closestAudioParagraph = e.target?.closest('.audio-paragraph');
    if (closestAudioParagraph) {
      closestAudioParagraph?.setAttribute('data-ischeckboxselected-proofreader', isChecked);
      e.target?.setAttribute('checked', isChecked);
      updateCheckBoxPercentage();

      const targetParantFile = closestAudioParagraph?.closest('.parent-file-paragraph-div');
      const parentFileId = targetParantFile?.getAttribute('data-parent-file-paragraph-id');

      if (parentFileId) {
        if (!uniqueParentFileIdsRef?.current?.includes(parentFileId)) {
          uniqueParentFileIdsRef?.current?.push(parentFileId);
        }
      }

      setDropDownClosed();
      // Trigger debounced save function only if save is not already in progress
      if (isSaveTranscriptInProgressRef.current !== 1) {
        isSaveTranscriptInProgressRef.current = 1;
        debouncedSaveEditTranscriptChangesForCheckBox();
      }
    }
  };

  function debounceCall(func, wait) {
    var timeout;
    return function () {
      var context = this,
        args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(context, args);
      }, wait);
    };
  }

  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  function debounceCallForCheckBox(func, wait) {
    let timeout;
    return function () {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func();
        isSaveScheduled = false;
      }, wait);
    };
  }

  const debouncedSaveEditTranscriptChangesForCheckBox = debounceCallForCheckBox(
    saveEditTranscriptChanges,
    AUTO_SAVE_TIME,
  );

  function saveEditTranscriptChanges(isApplytoAll = false) {
    let paragraphDivs = [];
    const parentFileIds = [];
    let innerHTMLContent = '';

    if (isApplytoAll) {
      const parentDiv = document?.querySelector('.jks647');
      if (parentDiv) {
        paragraphDivs = Array?.from(parentDiv?.querySelectorAll('.parent-file-paragraph-div'));
      }
    } else {
      if (uniqueParentFileIdsRef?.current?.length > 0) {
        uniqueParentFileIdsRef?.current?.forEach((id, index) => {
          const parentFileParagraphDiv = document?.querySelector(`div[data-parent-file-paragraph-id="${id}"]`);
          if (parentFileParagraphDiv) {
            paragraphDivs?.push(parentFileParagraphDiv);
          }
        });
      }
    }

    paragraphDivs?.forEach((parentFileDiv) => {
      const parentFileId = parentFileDiv?.getAttribute('data-parent-file-paragraph-id');
      if (!parentFileId) return;
      parentFileIds?.push(parentFileId);
      innerHTMLContent += parentFileDiv?.outerHTML;
    });

    const tempContainer = document?.createElement('div');
    tempContainer.innerHTML = innerHTMLContent;

    tempContainer?.querySelectorAll('.editArea')?.forEach((element) => element?.remove());

    tempContainer
      ?.querySelectorAll('.cb-m.inputwidthmachine')
      ?.forEach((input) => input?.setAttribute('contenteditable', 'false'));

    tempContainer
      ?.querySelectorAll("span[id^='c_'].highlight")
      ?.forEach((span) => span?.classList?.remove('highlight'));

    setSaveTranscriptHtmlData(tempContainer?.innerHTML);
    setSaveTranscriptHtmlParentFileIds(parentFileIds);
  }

  useEffect(() => {
    const audioParagraphsCount = document?.querySelectorAll('.parent-file-paragraph-div .audio-paragraph span')?.length;
    const selectedAudioParagraphsCount = document?.querySelectorAll(
      '.parent-file-paragraph-div .audio-paragraph[data-ischeckboxselected-proofreader="true"] span',
    )?.length;

    // Assuming this is part of a function, make sure it's async
    if (!!saveTranscriptHtmlData) {
      if (id) {
        isSaveTranscriptInProgressRef.current = 0;
        isTempSaveTranscript.current = 1;

        setIsSaveTranscript(true);

        let checkForceUnclaimparams = {
          claimId: editorDetailsData?.ClaimId,
          userId: userInfo?.UserId,
        };

        const param = {
          audioFileId: id,
          userId: userInfo?.UserId,
          totalParagraphs: audioParagraphsCount,
          completedParagraphs: selectedAudioParagraphsCount,
          isVendor: false,
        };
        const action = {
          transcript: saveTranscriptHtmlData,
          speaker: 'string',
          startTime: 0,
          endTime: 0,
          time: 0,
          words: [
            {
              endTime: 0,
              startTime: 0,
              speakerTag: 0,
              word: 'string',
              confidence: 'string',
            },
          ],
          paragraphs: [
            {
              speaker: 0,
              num_words: 0,
            },
          ],
          fileId: id,
          paragraphId: saveTranscriptHtmlParentFileIds?.join(','),
          checkBox: audioParagraphsCount === null || selectedAudioParagraphsCount === null ? null : param,
        };

        const paramComplateParghaph = {
          audioFileId: id,
          userId: userInfo?.UserId,
          totalParagraphs:
            totalAudioParagraphsRef?.current === null ? audioParagraphsCount : totalAudioParagraphsRef?.current,
          completedParagraphs:
            selectedAudioParagraphsRef?.current === null
              ? selectedAudioParagraphsCount
              : selectedAudioParagraphsRef?.current,
          isVendor: false,
        };

        workerCode(
          PROOFREADER_CHECK_FORCE_UNCLAIM_API_URL,
          JSON.stringify(checkForceUnclaimparams),
          JSON.stringify(action),
          JSON.stringify(paramComplateParghaph),
        );
      } else {
        navigate(DASHBOARD_ROUTE);
      }
    }
  }, [saveTranscriptHtmlData]);

  const workerCode = (API_URL, foreceUnclaimParam, saveTranscriptParam, checkBoxParam) => {
    const userData = Cookies.get('userDataProofreader');
    const token = userData ? JSON.parse(userData).Token : null;
    const options = {};
    const headers = {
      ...(token && { Authorization: `Bearer ${token}` }),
      'Content-Type': 'application/json', // Changed to JSON
      ...options.headers,
    };
    const bodyParam =
      API_URL === PROOFREADER_CHECK_FORCE_UNCLAIM_API_URL
        ? foreceUnclaimParam
        : API_URL === PROOFREADER_SAVE_TRANSCRIPT_PARAGRAPH_FILE_URL
          ? saveTranscriptParam
          : checkBoxParam;
    const worker = createWorker();
    worker.postMessage({
      url: `${BASE_URL}${API_URL}`,
      options: {
        method: 'POST',
        headers: headers,
        body: bodyParam, // Ensure action is stringified
      },
    });

    worker.onmessage = (event) => {
      const { success, data, error, type } = event.data;
      if (type === 'SESSION_EXPIRED') {
        UserLogout(); // Call function in main thread
      }
      if (success) {
        if (API_URL === PROOFREADER_CHECK_FORCE_UNCLAIM_API_URL) {
          if (data?.success === false) {
            workerCode(
              PROOFREADER_SAVE_TRANSCRIPT_PARAGRAPH_FILE_URL,
              foreceUnclaimParam,
              saveTranscriptParam,
              checkBoxParam,
            );
          }
        } else if (API_URL === PROOFREADER_SAVE_TRANSCRIPT_PARAGRAPH_FILE_URL) {
          if (data?.success) {
            setIsSaveTranscript(false);
            isTempSaveTranscript.current = 2;
            workerCode(TRANSCRIPT_COMPLETE_PARAGRAPH_API_URL, foreceUnclaimParam, saveTranscriptParam, checkBoxParam);
          } else {
            if (isTempSaveTranscript.current === 1) {
              isSaveTranscriptInProgressRef.current = 1;
              isTempSaveTranscript.current = 2;
            }
          }
        } else {
          lastSavedTime.current = getTime();
        }
      } else {
        toast.error(error);
      }
      worker.terminate(); // Terminate after response
    };
  };

  const handleInputInEditor = debounce((e) => {
    if (!e.target?.classList?.contains('checkCompleteParagraph')) {
      if (keyDownTrigger.current === false) {
        undoRedoManage(1);
      } else {
        keyDownTrigger.current = false;
      }

      if (audioParagraphRef?.current) {
        const editAreaDiv = audioParagraphRef?.current?.querySelector('.editArea');
        if (editAreaDiv) {
          const checkbox = editAreaDiv?.querySelector("input[type='checkbox']");
          if (checkbox) {
            const isCheckboxSelected = audioParagraphRef?.current?.getAttribute('data-ischeckboxselected-proofreader');
            if (isCheckboxSelected === 'true') {
              checkboxManualTrigger.current = true;
              checkbox?.click();
              checkbox?.removeAttribute('checked');
            }
          }
        }
      }

      const selection = window?.getSelection();
      if (selection?.rangeCount > 0) {
        const range = selection?.getRangeAt(0);
        let selectedElement = range?.startContainer;
        const targetParantFile = selectedElement?.parentElement?.closest('.parent-file-paragraph-div');
        const parentFileId = targetParantFile?.getAttribute('data-parent-file-paragraph-id');

        if (parentFileId) {
          if (!uniqueParentFileIdsRef?.current?.includes(parentFileId)) {
            uniqueParentFileIdsRef?.current?.push(parentFileId);
          }
          setDebounceValues();
        }
      }
    }
  }, 500);

  const handleUndoEvent = (e) => {
    if (undoStackClass?.length > 0) {
      const lastState = undoStackClass[undoStackClass?.length - 1];
      setUndoStackClass((prev) => prev?.slice(0, -1));
      const currentState = content?.map((item, index) => ({
        parentFileParagraphId: item?.parentFileParagraphId,
        fileData: removeHighlightSpans(contentRef?.current[index]?.innerHTML || ''),
      }));

      setRedoStackClass((prev) => [...prev, currentState]);
      setContent(lastState);
      contentRefNew.current = lastState;
      lastState?.forEach((item, index) => {
        if (contentRef?.current[index]) {
          contentRef.current[index].innerHTML = item?.fileData;
        }
      });
      updateCheckBoxPercentage();
    }
  };

  const handleRedoEvent = (e) => {
    if (redoStackClass?.length > 0) {
      const nextState = redoStackClass[redoStackClass?.length - 1];
      setRedoStackClass((prev) => prev?.slice(0, -1));
      const currentState = content?.map((item, index) => ({
        parentFileParagraphId: item?.parentFileParagraphId,
        fileData: contentRef?.current[index]?.innerHTML,
      }));
      setUndoStackClass((prev) => [...prev, currentState]);

      setContent(nextState);
      contentRefNew.current = nextState;
      nextState?.forEach((item, index) => {
        if (contentRef?.current[index]) {
          contentRef.current[index].innerHTML = item?.fileData;
        }
      });
      updateCheckBoxPercentage();
    }
  };

  const playerPlayPause = (isVideoPlay) => {
    const audioPlayerCtrl = document?.getElementById(`audiofile_${id}`);
    if (audioPlayerCtrl) {
      if (!audioPlayerCtrl?.paused) {
        if (!isVideoPlay) {
          audioPlayerCtrl?.pause();
        }
      }
    }
  };

  const markeUncheckedParagraphCheckBox = (audioParagraph) => {
    if (audioParagraph) {
      const editAreaDiv = audioParagraph?.querySelector('.editArea');
      if (editAreaDiv) {
        const checkbox = editAreaDiv?.querySelector("input[type='checkbox']");
        if (checkbox) {
          const isCheckboxSelected = audioParagraph?.getAttribute('data-ischeckboxselected-proofreader');
          if (isCheckboxSelected === 'true') {
            checkboxManualTrigger.current = true;
            checkbox?.click();
            checkbox?.removeAttribute('checked');
          }
        }
      }
    }
  };

  const applySpeakerLabelChanges = () => {
    setSpeakerNameCreate(false);

    // handle Undo Stack
    undoRedoManage();

    const labelCtrl = speakerTragetRef?.current;
    const labelText = document?.getElementById('txtSpeakerLabel_speaker')?.value?.trim() || '';
    const spanCtrl = labelCtrl;
    const spanText = spanCtrl?.textContent;
    const pDiv = document?.querySelector('.pDiv');

    if (spanCtrl?.parentElement?.id === 'openSpeakerModel') {
      spanCtrl.parentElement.textContent = labelText;
    } else {
      spanCtrl.textContent = labelText;
    }
    const cl2SpeakerCheckbox = document?.getElementById('cl2_speaker');
    let isApplytoAll = false;
    if (cl2SpeakerCheckbox.checked) {
      isApplytoAll = true;
      if (spanCtrl) {
        const audioParagraph = spanCtrl?.closest('.audio-paragraph');
        markeUncheckedParagraphCheckBox(audioParagraph);
      }
      const spans = document?.querySelectorAll('span#openSpeakerModel');
      spans?.forEach(function (span) {
        if (span?.textContent?.toLowerCase()?.trim() === spanText?.toLowerCase()?.trim()) {
          span.textContent = labelText;
          const audioParagraph = span?.closest('.audio-paragraph');
          markeUncheckedParagraphCheckBox(audioParagraph);
        }
      });
    }

    document.getElementById('txtSpeakerLabel_speaker').value = '';
    const speaker = labelText?.trim();

    let array1 = [];
    let array2 = [];

    if (speaker !== '' && speaker !== 'add speaker') {
      const speakerExists = allSpeakersRef?.current?.some(function (existingSpeaker) {
        return existingSpeaker?.toLowerCase() === speaker?.toLowerCase();
      });

      if (!speakerExists) {
        allSpeakersRef?.current?.push(speaker);
        const cl2SpeakerChecked = document?.getElementById('cl2_speaker').checked;

        if (cl2SpeakerChecked) {
          if (id === null) {
            navigate(DASHBOARD_ROUTE);
          } else {
            const updateParam = {
              fileId: id,
              OldSpeakerName: spanText,
              NewSpeakerName: speaker,
            };
            dispatch(updateSpeakersRequest(updateParam));
            setSpeakerNameCreate(false);
          }
        } else {
          let firstInputWidthMachine = document?.querySelector('.uns-area .inputwidthmachine:first-child');
          if (firstInputWidthMachine) {
            array1?.push(firstInputWidthMachine?.textContent?.trim());
          }

          let speakToEditListItems = document?.querySelectorAll('.speaktoedit-list');
          speakToEditListItems?.forEach(function (item) {
            const secondDiv = item?.querySelectorAll('div')[1];
            if (secondDiv) {
              array2?.push(secondDiv?.textContent?.trim());
            }
          });

          if (!array1?.includes(spanText)) {
            // If not present, remove the name from array2
            const index = array2?.indexOf(spanText);
            if (index !== -1) {
              array2?.splice(index, 1);

              // Loop through '.speaktoedit-list' and remove the one that matches spanText
              speakToEditListItems?.forEach(function (item) {
                const secondDiv = item?.querySelectorAll('div')[1];
                if (secondDiv && secondDiv?.textContent?.trim() === spanText) {
                  return; // Exit the loop
                }
              });
            }
          }
          const commaSeparatedText = array2?.join(',');
          if (id === null) {
            navigate(DASHBOARD_ROUTE);
          } else {
            const addParam = {
              fileId: id,
              speakerName: speaker,
              speakerNames: commaSeparatedText,
            };
            dispatch(addSpeakersRequest(addParam));
          }
          array1 = [];
          array2 = [];
        }
      } else {
        if (!document?.getElementById('cl2_speaker').checked) {
          let firstInputWidthMachine = document?.querySelector('.uns-area .inputwidthmachine:first-child');
          if (firstInputWidthMachine) {
            array1?.push(firstInputWidthMachine?.textContent?.trim());
          }

          let speakToEditListItems = document?.querySelectorAll('.speaktoedit-list');
          speakToEditListItems?.forEach(function (item) {
            const secondDiv = item?.querySelectorAll('div')[1];
            if (secondDiv) {
              array2?.push(secondDiv?.textContent?.trim());
            }
          });

          if (!array1?.includes(spanText)) {
            // If not present, remove the name from array2 and speakerColl
            const index = array2?.indexOf(spanText);
            if (index !== -1) {
              array2?.splice(index, 1);

              // Loop through each '.speaktoedit-list' and remove the item that matches spanText
              speakToEditListItems?.forEach(function (item) {
                const secondDiv = item?.querySelectorAll('div')[1];
                if (secondDiv && secondDiv?.textContent?.trim() === spanText) {
                  return; // Exit the loop
                }
              });
            }
          }
          const commaSeparatedText = array2?.join(',');
          if (id === null) {
            navigate(DASHBOARD_ROUTE);
          } else {
            const deleteParam = {
              fileId: id,
              SpeakerNames: commaSeparatedText,
            };
            dispatch(deleteSpeakersRequest(deleteParam));
          }
          array1 = [];
          array2 = [];
        }
      }
    }

    if (!pDiv) {
      let speakerColl = [];
      document.getElementById('txtSpeakerLabel_speaker').value = '';
      var speakers = document?.querySelectorAll(".jks647 span[class^='spk_']");

      speakers?.forEach(function (speakerElem) {
        var speaker = speakerElem?.textContent?.trim();
        var speakerCollAsString = speakerColl?.toString()?.toLowerCase();

        if (speaker !== '' && speaker !== 'add speaker') {
          if (speakerCollAsString?.indexOf(speaker?.toLowerCase()) < 0) {
            speakerColl?.push(speaker);
          }
        }
      });
      if (speakerColl.length !== 0) {
        allSpeakersRef.current = speakerColl;
      }
      speakerColl?.sort();
      const commaSeparatedText = speakerColl?.join(',');
      if (id === null) {
        navigate(DASHBOARD_ROUTE);
      } else {
        const removeUnusedParam = {
          fileId: id,
          SpeakerNames: commaSeparatedText,
          projectId: null,
        };
        dispatch(removeUnusedSpeakersRequest(removeUnusedParam));
      }

      const currentSpeakerTarget = speakerTragetRef?.current;
      const targetParantFile = currentSpeakerTarget?.closest('.parent-file-paragraph-div');
      const parentFileId = targetParantFile?.getAttribute('data-parent-file-paragraph-id');

      if (parentFileId) {
        if (!uniqueParentFileIdsRef?.current?.includes(parentFileId)) {
          uniqueParentFileIdsRef?.current?.push(parentFileId);
        }
      }
      setDebounceValues(isApplytoAll);
      const speakerCheckbox = document?.getElementById('cl2_speaker');
      if (speakerCheckbox) {
        speakerCheckbox.checked = false;
      }
      setDropDownClosed();
      setSpeakerNameCreate(false);
    }
    setErrorSpeakerNamePopup('');
    inputRef.current = null;
    document.getElementById('txtSpeakerLabel_speaker').value = '';

    if (audioParagraphRef?.current) {
      const editAreaDiv = audioParagraphRef?.current?.querySelector('.editArea');
      if (editAreaDiv) {
        const checkbox = editAreaDiv?.querySelector("input[type='checkbox']");
        if (checkbox) {
          const isCheckboxSelected = audioParagraphRef?.current?.getAttribute('data-ischeckboxselected-proofreader');
          if (isCheckboxSelected === 'true') {
            checkboxManualTrigger.current = true;
            checkbox?.click();
            checkbox?.removeAttribute('checked');
          }
        }
      }
    }
  };

  const calimAPIData = useSelector((state) => state?.CheckForceUnclaim?.user?.data?.success);

  useEffect(() => {
    // Skip the first render
    if (isMounted?.current) {
      if (calimAPIData === true) {
        setShowAlert(true); // Show alert if calimAPIData is false
      } else {
        setShowAlert(false); // Optionally hide alert when calimAPIData is not false
      }
    } else {
      isMounted.current = true; // Mark the component as mounted after the first render
    }
  }, [calimAPIData]); // Dependency array will watch calimAPIData for changes

  const handleDownloadAndViewDocument = async (documentDetails) => {
    try {
      const response = await fetch(documentDetails?.pathName);
      const blob = await response.blob();

      // Create a temporary link to download the file
      const link = document?.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = documentDetails?.fileName;
      document?.body?.appendChild(link);
      link?.click();

      // Clean up
      document?.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);
    } catch (error) {}
  };

  const selectStyles = {
    control: (base) => ({
      ...base,
      height: '26px',
      minWidth: '100px',
      border: '1px solid #e6e6e6',
      borderRadius: '4px',
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999, // Ensure the dropdown is above the modal
    }),
  };

  // Effect to check for duplicate speaker names when the user types
  useEffect(() => {
    const isDuplicate = allSpeakersRef?.current?.some(
      (speaker) => speaker.trim().toLowerCase() === speakerName.current.trim().toLowerCase(),
    );

    if (isDuplicate) {
      setErrorSpeakerNamePopup('Speaker name already exists.');
    }
  }, [speakerName.current, allSpeakersRef]);

  useEffect(() => {
    if (restoreButton && vendorNextTranscriptDetailSuccess && !vendorTranscriptLoading) {
      dispatch(getAllSpeakersRequest(id));
      setRestorebutton(false);
    }
  }, [vendorTranscriptLoading, restoreButton]);

  let src = editorDetailsData?.MediaFile;

  // Load and fully preload video
  useEffect(() => {
    const preloadVideo = async () => {
      if (!src) return;

      try {
        if (src.endsWith('.m3u8') && Hls.isSupported()) {
          // HLS Video Handling
          if (!videoRef.current) return;
          const hls = new Hls();
          hls.loadSource(src);
          hls.attachMedia(videoRef.current);
        } else {
          // Fetch and preload video as Blob for full loading
          const response = await fetch(src);
          const blob = await response.blob();
          const url = URL.createObjectURL(blob);
          setVideoSrc(url);
        }
      } catch (error) {}
    };

    preloadVideo();
  }, [src]);

  // Update buffered progress
  const handleProgress = () => {
    const video = videoRef.current;
    if (video?.buffered.length > 0) {
      const bufferedEnd = video.buffered.end(video.buffered.length - 1);
      setBuffered((bufferedEnd / video.duration) * 100);
    }
  };

  // Handle manual seeking
  const handleSeeking = () => setIsSeeking(true);
  const handleSeeked = () => setIsSeeking(false);

  // Handle pause (rewind only if not seeking)
  const handlePause = () => {
    if (!isSeeking) {
      videoRef.current.currentTime -= parseInt(selectedValueRewindPushTime?.current);
      document.querySelectorAll('span.highlight')?.forEach((span) => {
        span.classList.remove('highlight');
      });
    }
  };

  // Keyboard shortcut handling
  const handleKeyDown = (e) => {
    const audioPlayerCtrl = document?.getElementById(`audiofile_${id}`);
    const video = videoRef?.current;
    if (!video) return;

    if (e?.shiftKey && e?.key === 'Tab') {
      e.preventDefault();
      if (audioPlayerCtrl) {
        video.currentTime -= parseInt(selectedValueRewindPushTime.current);
        document?.querySelectorAll('span.highlight')?.forEach((span) => {
          span?.classList?.remove('highlight');
        });
      }
    } else if (e?.key === 'F8') {
      video.currentTime += 5; // Skip Forward
    } else if (e?.key === 'Tab') {
      e.preventDefault();
      if (video?.paused) {
        video?.play();
      } else {
        video.currentTime -= parseInt(selectedValueRewindPushTime?.current);
        video.pause();
        document?.querySelectorAll('span.highlight')?.forEach((span) => {
          span?.classList?.remove('highlight');
        });
      }
    }
  };

  // Attach keyboard listener
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    container.focus();
    container.addEventListener('keydown', handleKeyDown);
    return () => {
      container.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <span className="position-relative overflow-hidden d-block">
      {/* ==== main content ==== */}
      <main className="ms-0">
        <div
          ref={containerRef}
          tabIndex={0}
          style={{
            marginTop: '85px',
            position: 'relative',
            width: '100%',
            outline: 'none',
          }}
        >
          {editorDetailsLoading || editorDetailsLoading === null ? (
            <div
              style={{
                zIndex: 1,
                display: 'flex',
                justifyContent: 'center',
                marginTop: '50vh',
              }}
            >
              <Spinner animation="border" />
            </div>
          ) : editorDetailsData === undefined ||
            editorDetailsData === null ||
            vendorNextTranscriptDetailData?.EditTranscript?.trim() === '' ? (
            <div
              style={{
                zIndex: 1,
                display: 'flex',
                justifyContent: 'center',
                marginTop: '50vh',
              }}
            >
              <h5>No data found</h5>
            </div>
          ) : (
            <>
              {setShowAlert && (
                <CustomAlert show={showAlert} setShow={setShowAlert} handleSubmitCloseModal={handleSubmitCloseModal} />
              )}
              <Container fluid>
                <Row>
                  <Col md="12">
                    <div className="transcript-detail d-flex align-items-center justify-content-between">
                      {isSaveTranscript !== true ? (
                        <span
                          className="cursor-pointer fw-medium ps-3"
                          onClick={() => {
                            if (isSaveTranscriptInProgressRef?.current === 1 || isTempSaveTranscript?.current === 1) {
                              backSaveEditTranscriptChanges();
                              transcriptSaveInprogressToaster('Please wait, your transcript is being saved...');
                            } else {
                              handleFilterClear();
                              setFullQcClick(false);
                              setQcClick(false);
                              setDueInDayClick(false);
                              setDueInHalfDayClick(false);
                              setLegalClick(false);
                              setDashboardClick(true);
                              dispatch(resetDdashboardProofreader());
                              dispatch(resetProofreaderAllFiles());
                              dispatch(resetEditorData());
                              dispatch(resetEditorDocumentData());
                              dispatch(resetVendorNextTranscript());
                              navigate(DASHBOARD_ROUTE);
                            }
                          }}
                        >
                          <WestRoundedIcon />
                        </span>
                      ) : (
                        <span className="cursor-pointer fw-medium ps-3">
                          <WestRoundedIcon />
                        </span>
                      )}
                      <div className="transcript-options-button">
                        <ul className="tags-button-wrapper">
                          <li className="tags-button-item">
                            <CustomTooltips title="Find & Replace" id="t-3" variant="primary">
                              <button
                                style={{
                                  backgroundColor: 'transparent',
                                  border: 'none',
                                }}
                                onClick={handleFindReplaceOpenModal}
                                disabled={!!vendorTranscriptLoading}
                              >
                                <i className="icon-search-icon"></i>
                              </button>
                            </CustomTooltips>
                          </li>
                          <li className="tags-button-item" onClick={handleKeyboardShortcutsOpenModal}>
                            <CustomTooltips title="Shortcuts" id="t-4" variant="primary">
                              <img
                                src={command_icon}
                                className="img-fluid"
                                alt="command-icon"
                                style={{ height: '22px', width: '22px' }}
                              />
                            </CustomTooltips>
                          </li>
                          <li className="tags-button-item" onClick={handleDocumentsOpenModal}>
                            <CustomTooltips title="Resources" id="t-5" variant="primary">
                              <img
                                src={document_icon}
                                className="img-fluid"
                                alt="document-icon"
                                style={{ height: '19px', width: '19px' }}
                              />
                            </CustomTooltips>
                          </li>
                          <li className="tags-button-item">
                            <CustomTooltips title="Transcription guidelines" id="t-6">
                              <img
                                src={bookmark_icon}
                                className="img-fluid"
                                alt="question_box-icon"
                                onClick={() => window.open(Datagain_Style_Guide, '_blank')}
                              />
                            </CustomTooltips>
                          </li>
                          <li className="tags-button-item">
                            <CustomTooltips title="More" id="t-10" variant="primary">
                              <button
                                style={{
                                  backgroundColor: 'transparent',
                                  border: 'none',
                                }}
                                onClick={handleMoreShowOpenModal}
                                disabled={!!vendorTranscriptLoading}
                              >
                                <MoreHorizOutlinedIcon />
                              </button>
                            </CustomTooltips>
                          </li>
                        </ul>
                      </div>
                      <div className="transcript-right-button pe-3">
                        {editorDetailsLoading === false && editorDetailsData && (
                          <Timer setUnclaimShow={setUnclaimShow} isAllTranscriptLoad={isAllTranscriptLoad} />
                        )}
                        <Button
                          variant="primary"
                          className="w120 me-2"
                          onClick={() => {
                            if (isSaveTranscript) {
                              transcriptSaveInprogressToaster('Please wait, your transcript is being saved...');
                            } else {
                              if (isSaveTranscriptInProgressRef?.current === 1) {
                                backSaveEditTranscriptChanges();
                              }
                              let checkForceUnclaimparams = {
                                claimId: editorDetailsData?.ClaimId,
                                userId: userInfo?.UserId,
                              };
                              dispatch(checkForceUnclaimRequest(checkForceUnclaimparams));
                              handleSubmitOpenModal();
                            }
                          }}
                          disabled={isAllTranscriptLoad === false && editorDetailsLoading === false}
                        >
                          Submit
                        </Button>
                        {/* ==== Submit proof-reader ==== */}
                        <ProofreaderSubmitModal
                          editorDetailsData={editorDetailsData}
                          vendorDetailData={vendorDetailData}
                          submitShow={submitShow}
                          handleSubmitCloseModal={handleSubmitCloseModal}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row className={open ? 'collapse-main' : ''}>
                  <span>
                    <a
                      className="transcriptSidebar-collapse cursor-pointer"
                      onClick={() => setOpen(!open)}
                      aria-controls="example-collapse-text"
                      aria-expanded={open}
                    >
                      <MenuRoundedIcon /> <span className="collapse-text">Collapses</span>
                    </a>
                  </span>
                  <Collapse in={!open} className="sidebar-expanded mt-3 ps-4">
                    <div id="transcriptSidebar">
                      <div
                        className="sidebarHeader"
                        style={{
                          borderBottom: !open ? '1px solid #ebebeb' : '',
                        }}
                      >
                        {!open && <img src={rounded_icon} className="img-fluid me-2" alt="rounded-icon" />}{' '}
                        <span className="collapse-text">Recordings</span>
                      </div>
                      <div className="recodingWrapper">
                        <div className="recordingBlock custom-scroll">
                          <div className="recoding-video-player">
                            <div className="recoding-video-player-header">
                              <span className="video-label">
                                <CustomTooltips title={editorDetailsData?.UserFileName} placement="top">
                                  {truncateString(editorDetailsData?.UserFileName, 33)}
                                </CustomTooltips>
                              </span>
                              <div className="d-flex gap-2">
                                <Dropdown as={NavItem} className="position-static">
                                  <Dropdown.Toggle as={NavLink} className="nav-user">
                                    <InfoOutlinedIcon className="fnt-16 opacity-50" />
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu className="file-toggle-box">
                                    <div className="file-info-header">
                                      <h6 className="fnt-16 fw-bold mb-0">File Information</h6>
                                    </div>
                                    <ul className="file-list-ul">
                                      {editorDetailsData?.ProjectName && (
                                        <li>
                                          Project Folder{' '}
                                          <span className="file-list-content">: {editorDetailsData?.ProjectName}</span>
                                        </li>
                                      )}
                                      {editorDetailsData?.OrderId && (
                                        <li>
                                          Order No{' '}
                                          <span className="file-list-content">: {editorDetailsData?.OrderId}</span>
                                        </li>
                                      )}
                                      {(editorDetailsData?.VerbatimTranscription || editorDetailsData?.PII) && (
                                        <li>
                                          Options{' '}
                                          <span className="file-list-content">
                                            :{' '}
                                            {[
                                              editorDetailsData?.VerbatimTranscription && 'Strict Verbatim',
                                              editorDetailsData?.PII && 'Redaction',
                                            ]
                                              ?.filter(Boolean)
                                              ?.join(', ')}
                                          </span>
                                        </li>
                                      )}
                                      {editorDetailsData?.turnAroundValue && (
                                        <li>
                                          TAT{' '}
                                          <span className="file-list-content">
                                            : {editorDetailsData?.turnAroundValue}
                                          </span>
                                        </li>
                                      )}
                                      {editorDetailsData?.TranscriptionType && (
                                        <li>
                                          Type{' '}
                                          <span className="file-list-content">
                                            : {editorDetailsData?.TranscriptionType}
                                          </span>
                                        </li>
                                      )}
                                      {editorDetailsData?.OrderDate && (
                                        <li>
                                          Order Date{' '}
                                          <span className="file-list-content">
                                            : {moment(editorDetailsData?.OrderDate).format('MM/DD/YY')}
                                          </span>
                                        </li>
                                      )}
                                      {editorDetailsData?.ForeignLanguage && (
                                        <li>
                                          Transcript Lang{' '}
                                          <span className="file-list-content">
                                            : {editorDetailsData?.ForeignLanguage}
                                          </span>
                                        </li>
                                      )}
                                      {editorDetailsData?.DueDate && (
                                        <li>
                                          Vendor Due{' '}
                                          <span className="file-list-content">
                                            :{' '}
                                            {editorDetailsData?.DueDate !== null
                                              ? moment(editorDetailsData?.DueDate).format('MM/DD/YY')
                                              : '--'}
                                          </span>
                                        </li>
                                      )}
                                      {editorDetailsData?.VendorName && (
                                        <li>
                                          Original Vendor{' '}
                                          <span className="file-list-content">: {editorDetailsData?.VendorName}</span>
                                        </li>
                                      )}
                                    </ul>
                                  </Dropdown.Menu>
                                </Dropdown>
                              </div>
                            </div>
                            {editorDetailsData?.MediaFile && (
                              <>
                                {containsExtension === true ? (
                                  <div
                                    style={{
                                      position: 'relative',
                                      width: '100%',
                                      outline: 'none',
                                    }}
                                  >
                                    <video
                                      id={`audiofile_${editorDetailsData?.Id}`}
                                      ref={videoRef}
                                      controls
                                      src={videoSrc}
                                      preload="auto"
                                      onProgress={handleProgress}
                                      onPause={handlePause}
                                      onSeeking={handleSeeking}
                                      onSeeked={handleSeeked}
                                      controlsList="nodownload"
                                      disablePictureInPicture
                                      style={{ width: '100%', padding: '0px 15px 0px 15px', height: '170px' }}
                                    />
                                    {/* ==== Buffered Bar ==== */}
                                    <div
                                      style={{
                                        position: 'absolute',
                                        bottom: '0',
                                        left: '0',
                                        height: '0',
                                        backgroundColor: '#333',
                                        width: '100%',
                                      }}
                                    >
                                      <div
                                        style={{
                                          height: '100%',
                                          backgroundColor: '#007bff',
                                          width: `${buffered}%`,
                                        }}
                                      />
                                    </div>
                                  </div>
                                ) : (
                                  <div
                                    style={{
                                      position: 'relative',
                                      width: '100%',
                                      outline: 'none',
                                    }}
                                  >
                                    <audio
                                      id={`audiofile_${editorDetailsData?.Id}`}
                                      ref={videoRef}
                                      controls
                                      src={videoSrc}
                                      preload="auto"
                                      onProgress={handleProgress}
                                      onPause={handlePause}
                                      onSeeking={handleSeeking}
                                      onSeeked={handleSeeked}
                                      controlsList="nodownload"
                                      disablePictureInPicture
                                      style={{ width: '100%', padding: '0px 15px 0px 15px' }}
                                    />
                                    {/* ==== Buffered Bar ==== */}
                                    <div
                                      style={{
                                        position: 'absolute',
                                        bottom: '0',
                                        left: '0',
                                        height: '0',
                                        backgroundColor: '#333',
                                        width: '100%',
                                      }}
                                    >
                                      <div
                                        style={{
                                          height: '100%',
                                          backgroundColor: '#007bff',
                                          width: `${buffered}%`,
                                        }}
                                      />
                                    </div>
                                  </div>
                                )}
                              </>
                            )}
                            <div className="preview-recoding-duration">
                              {editorDetailsData?.Duration && (
                                <div>
                                  <TimerOutlinedIcon className="fnt-20" /> {editorDetailsData?.Duration}
                                </div>
                              )}
                              {editorDetailsData?.MediaFile && (
                                <div id="playerButtons">
                                  <CustomTooltips title="Rewind" placement="top">
                                    <button
                                      className="mx-1 p-0"
                                      style={{
                                        border: 'none',
                                        color: '#83878a',
                                        background: 'transparent',
                                      }}
                                      id="btnRewind"
                                      onClick={handleRewind}
                                    >
                                      <Replay5RoundedIcon />
                                    </button>
                                  </CustomTooltips>
                                  <CustomTooltips title="Forward" placement="top">
                                    <button
                                      className="mx-1 p-0"
                                      style={{
                                        border: 'none',
                                        color: '#83878a',
                                        background: 'transparent',
                                      }}
                                      id="btnForward"
                                      onClick={handleForward}
                                    >
                                      <Forward5RoundedIcon />
                                    </button>
                                  </CustomTooltips>
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="notesContent">
                            <div className="notesTitle">
                              Client Notes {''}
                              <CustomTooltips
                                title="These are the client's instructions; kindly ensure they are adhered to while processing the file."
                                placement="right"
                              >
                                <InfoOutlinedIcon className="fnt-14" />
                              </CustomTooltips>
                            </div>
                            <ul className="opacity-70 notesItem clientNotesList">
                              {clientNotes.map((note, index) => (
                                <li key={index}>{note}</li>
                              ))}
                            </ul>
                          </div>
                          <div className="notesContent">
                            <div className="notesTitle">
                              Vendor Notes{''}
                              <CustomTooltips title="These notes have been provided by the vendor." placement="right">
                                <InfoOutlinedIcon className="fnt-14" />
                              </CustomTooltips>
                            </div>
                            <textarea
                              rows="3"
                              className="opacity-70 notesItem"
                              style={{
                                height: '100%',
                                width: '100%',
                              }}
                              value={editorDetailsData?.VendorNote || ''}
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Collapse>
                  <div className="centerContainer pe-4">
                    <span className="topFixedOverlay">
                      {!editorDetailsLoading && !vendorTranscriptLoading && (
                        <>
                          <div
                            className="centerTitle d-flex align-items-center pLeft-10"
                            style={{
                              justifyContent: editorDetailsData?.UserFileName ? 'space-between' : 'end',
                            }}
                          >
                            {editorDetailsData?.UserFileName && (
                              <div className="d-flex align-items-center pLeft-10">
                                <span className="truncate-75">
                                  <CustomTooltips title={editorDetailsData?.UserFileName} placement="top">
                                    {truncateString(editorDetailsData?.UserFileName, 35)}
                                  </CustomTooltips>
                                </span>
                                <div className="d-flex align-items-center ms-3 gap-2">
                                  {isSaveTranscript ? (
                                    <span className="autosave-text">
                                      <CachedOutlinedIcon /> saving...
                                    </span>
                                  ) : (
                                    <span className="autosave-text">
                                      <img src={saveCloud} className="me-1" alt="last-save"></img>
                                      Last Saved <span className="sTiming">{lastSavedTime.current}</span>
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}
                            <Dropdown
                              as={NavItem}
                              show={dropdownOpenComment}
                              onToggle={handleToggleDropdownComment} // Pass correct state
                            >
                              {vendorProofreaderCommentData?.ProofReaderComments?.length > 0 ? (
                                <Dropdown.Toggle
                                  as={NavLink}
                                  className="nav-user"
                                  onClick={
                                    () => setDropdownOpenComment((prevState) => !prevState) // Toggle on click
                                  }
                                >
                                  <img src={chat_icon} className="img-fluid opacity-50" alt="command-icon" />
                                </Dropdown.Toggle>
                              ) : null}

                              <Dropdown.Menu className="file-toggle-box">
                                {vendorProofreaderCommentData?.ProofReaderComments?.map((data, index) => (
                                  <div className="comment-dropdown-body" key={index}>
                                    <div className="d-flex">
                                      <Avatar
                                        alt="image"
                                        src={data?.ProfilePhoto ? `${IMAGE_URL}/${data?.ProfilePhoto}` : null}
                                        className="comment-profile-avatar me-3"
                                      />
                                      <div>
                                        <h5 className="d-flex justify-content-between">
                                          {data?.ProofReaderName}
                                          {!data?.isResolved ? (
                                            <CheckCircleIcon
                                              style={{
                                                color: hoveredIndex === index ? 'green' : 'currentColor',
                                                cursor: 'pointer',
                                                transform: 'translate(60px, 0px)',
                                              }}
                                              onClick={() => {
                                                handleResolved(data?.Id);
                                                handleCloseDropdownComment();
                                              }}
                                              onMouseEnter={() => setHoveredIndex(index)}
                                              onMouseLeave={() => setHoveredIndex(null)}
                                            />
                                          ) : (
                                            <HighlightOffIcon
                                              style={{
                                                color: 'gray',
                                                cursor: 'pointer',
                                                transform: 'translate(60px, 0px)',
                                              }}
                                              onClick={handleCloseDropdownComment}
                                            />
                                          )}
                                        </h5>
                                        <div className="comment-dropdown-text">{formatDate(data?.CreatedOn)}</div>
                                      </div>
                                    </div>
                                    <div className="comment-dropdown-text mt-3">{data?.Comment}</div>
                                  </div>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                          <div
                            className="d-flex align-items-center justify-content-between gap-3 my-3"
                            style={{ paddingLeft: '20px' }}
                          >
                            <span className="d-flex align-items-center">
                              {editorDetailsData?.PII === true && (
                                <CustomTooltips title="Remove sensitive or private information" placement="top">
                                  <div className="sub-btn me-3">Redaction</div>
                                </CustomTooltips>
                              )}
                              {editorDetailsData?.VerbatimTranscription === true && (
                                <CustomTooltips title="Every single utterance, noise and word spoken" placement="top">
                                  <div className="sub-btn me-3">Strict Verbatim</div>
                                </CustomTooltips>
                              )}
                              {(editorDetailsData?.AudioLanguage || editorDetailsData?.ForeignLanguage) && (
                                <div className="d-flex align-items-center gap-2 me-3">
                                  <div className="action-icon-btn">
                                    <img src={translate_icon} className="img-fluid" alt="translate-icon" />
                                  </div>
                                  <span className="fnt-14">
                                    {editorDetailsData?.AudioLanguage}
                                    {editorDetailsData?.AudioLanguage && editorDetailsData?.ForeignLanguage && ' - '}
                                    {editorDetailsData?.ForeignLanguage}
                                  </span>
                                </div>
                              )}
                              {editorDetailsData && (
                                <div className="d-flex align-items-center gap-2">
                                  <div className="action-icon-btn">
                                    <img src={headphone_icon} className="img-fluid" alt="headphone-icon" />
                                  </div>
                                  <span className="fnt-14">
                                    {editorDetailsData?.Transcription ? 'Transcription' : 'Translation'}
                                  </span>
                                </div>
                              )}
                              <div className="d-flex align-items-center ms-3 fnt-14">
                                <img src={half_timer_icon} alt="half-timer" />
                                <span className="mx-2">In Progress</span>
                                <span>
                                  {editorDetailsLoading || !!vendorTranscriptLoading
                                    ? 0
                                    : completedPercentageRef?.current !== null &&
                                        !isNaN(completedPercentageRef?.current)
                                      ? completedPercentageRef?.current
                                      : 0}
                                  %
                                </span>
                              </div>
                            </span>
                          </div>
                        </>
                      )}
                    </span>
                    {!!vendorTranscriptLoading ? (
                      <div
                        style={{
                          zIndex: 1,
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '35vh',
                        }}
                      >
                        <div className="three-bounce selected">
                          <div className="one"></div>
                          <div className="two"></div>
                          <div className="three"></div>
                        </div>
                      </div>
                    ) : (
                      <div className="pLeft-10">
                        <div className="editorView-inner custom-scroll">
                          <ul className="editorView-body">
                            <>
                              <div id="QuillTranscript" className="QuillTranscript">
                                <div id="transcriptblk" className="dvTsBlock pLeft-10">
                                  <input type="hidden" id="JsonTranscriptCheck" value="1" />
                                  <div
                                    className={`${
                                      jKS647HasClass.current?.includes('jks647')
                                        ? jKS647HasClass.current
                                        : `jks647 ${jKS647HasClass.current}`
                                    }`}
                                  >
                                    {content &&
                                      content?.map((paragraphGroup, parentIndex) => (
                                        <div
                                          className=""
                                          ref={(el) => {
                                            !!el && (contentRef.current[parentIndex] = el);
                                          }}
                                          key={`parentFileParagraph${parentIndex}`}
                                          dangerouslySetInnerHTML={{
                                            __html: paragraphGroup?.fileData,
                                          }}
                                          contentEditable={true}
                                          suppressContentEditableWarning={true}
                                          onClick={(e) => {
                                            handleOpenEditor(e);
                                          }}
                                          onInput={(e) => {
                                            handleInputInEditor(e);
                                          }}
                                          onKeyDown={(e) => {
                                            const allowKeys =
                                              e.key === 'ArrowLeft' ||
                                              e.keyCode === 37 ||
                                              e.key === 'ArrowUp' ||
                                              e.keyCode === 38 ||
                                              e.key === 'ArrowRight' ||
                                              e.keyCode === 39 ||
                                              e.key === 'ArrowDown' ||
                                              e.keyCode === 40 ||
                                              e.key === 'Control' ||
                                              e.keyCode === 17 ||
                                              e.key === 'Shift' ||
                                              e.keyCode === 16;
                                            if (!e.repeat || allowKeys) {
                                              handleKeyDownInEditor(e);
                                            } else {
                                              e.preventDefault();
                                              setIsContinueKeyPressModalVisible(true);
                                            }
                                          }}
                                        ></div>
                                      ))}
                                  </div>
                                </div>
                              </div>
                              {nextTranscriptDataLoading && (
                                <div className="load-next-transcript">
                                  <div className="three-bounce selected">
                                    <div className="one"></div>
                                    <div className="two"></div>
                                    <div className="three"></div>
                                  </div>
                                </div>
                              )}
                            </>
                          </ul>
                        </div>
                      </div>
                    )}
                  </div>
                </Row>
              </Container>
            </>
          )}
        </div>
      </main>
      {/* ==== More modal option ==== */}
      <Modal
        show={moreShow}
        onHide={handleMoreShowCloseModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="custom-modal"
      >
        <div>
          <div className="preview-dropdown-header">
            More
            <HighlightOffRoundedIcon
              onClick={handleMoreShowCloseModal}
              className="cursor-pointer opacity-50"
              style={{ height: '28px', width: '28px' }}
            />
          </div>
          <div className="preview-dropdown-body">
            <div className="d-flex justify-content-between align-items-center pb-3">
              <span className="fnt-17 fw-medium">Restore Original Transcript</span>{' '}
              <Button
                variant="primary"
                className="w120"
                onClick={() => {
                  handleMoreShowCloseModal();
                  setRestoreModalVisible(true);
                }}
                disabled={loadingDocument || !!vendorTranscriptLoading || nextTranscriptDataLoading}
              >
                Restore
              </Button>
            </div>
            <div className="bb-1 mb-3 py-3">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="fnt-17 fw-medium">Rewind on Pause</span>
                <Select
                  value={rewindPushTimeOptions.find((option) => option.value === selectedValueRewindPushTimeState)}
                  onChange={(selectedOption) => handleChangeForwardTime(selectedOption.value)}
                  options={rewindPushTimeOptions}
                  isSearchable
                  isDisabled={loadingDocument || !!vendorTranscriptLoading || nextTranscriptDataLoading}
                  styles={selectStyles}
                  classNamePrefix="custom-select"
                  menuPortalTarget={document.body} // Render dropdown outside the modal
                />
              </div>
              <p className="mb-0 opacity-50">Automatically Rewind few seconds when the video is paused</p>
            </div>
            <div className="bb-1 mb-3 py-3">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="fnt-17 fw-medium">Font Size</span>
                <Select
                  value={fontSizeOptions.find((option) => option.value === fontSize) || fontSizeOptions[0]} // Ensure a fallback value
                  onChange={(selectedOption) => handleFontSizeChange(selectedOption.value)} // Handle changes
                  options={fontSizeOptions}
                  isDisabled={loadingDocument || !!vendorTranscriptLoading || nextTranscriptDataLoading} // Disable based on conditions
                  isSearchable={false}
                  styles={selectStyles}
                  classNamePrefix="custom-select-font-size"
                  menuPortalTarget={document.body} // Render dropdown outside the modal
                />
              </div>
              <p className="mb-0 opacity-50">Set the Transcript font Size according your need</p>
            </div>
          </div>
        </div>
      </Modal>
      {/* ==== Restore Confirm Modal ==== */}
      <Modal
        show={restoreModalVisible} // Use the renamed state variable
        onHide={() => setRestoreModalVisible(false)} // Update state on modal close
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="preview-dropdown-body my-4">
          <div className="text-center fs-5 fw-semibold">Are You Sure?</div>
          <div className="text-center mt-3">You want to restore this file?</div>
          <div className="text-center mt-3">
            <Button variant="outline-danger" onClick={() => setRestoreModalVisible(false)}>
              Cancel
            </Button>
            <button
              className="confirm-modal-submit"
              onClick={() => {
                if (id === null) {
                  navigate(DASHBOARD_ROUTE);
                } else {
                  let params = {
                    audioFileId: id,
                    userId: userInfo?.UserId,
                    isClickOnClaim: false,
                    isRestore: true,
                  };
                  setRestorebutton(true);
                  dispatch(resetAllSpeakrsData());
                  allSpeakersRef.current = null;
                  dispatch(vendorNextTranscriptRequest(params));
                  updateCheckBoxPercentage();
                  handleMoreShowCloseModal();
                  didSetInitialSpeakers.current = false;
                }
                setRestoreModalVisible(false);
              }}
            >
              Yes
            </button>
          </div>
        </div>
      </Modal>
      {/* ==== Restore Confirm Modal ==== */}
      <Modal show={resourceConfirmOpen} onHide={handleResourceCancel} centered>
        <div className="preview-dropdown-header">
          Aleart!
          <HighlightOffRoundedIcon
            onClick={handleMoreShowCloseModal}
            className="cursor-pointer opacity-50"
            style={{ height: '28px', width: '28px' }}
          />
        </div>
        <div className="preview-dropdown-body">
          <div className="bb-1 pb-3">
            <div>
              You are about to Restore the Original Transcript and all the changes made by the vendor and by you will be
              lost.
            </div>
            <div>You want to continue?</div>
          </div>
        </div>
        <div>
          <div className="col-12 text-center pt-5 pb-4">
            <Button onClick={handleResourceCancel} className="me-2">
              Back
            </Button>
            <Button onClick={handleResourceConfirm}>Confirm</Button>
          </div>
        </div>
      </Modal>
      {/* ==== Find and Replace modal ==== */}
      <Modal
        show={findReplaceShow}
        onHide={handleFindReplaceCloseModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="custom-modal"
      >
        <div>
          <div className="preview-dropdown-header">
            Find and Replace
            <HighlightOffRoundedIcon
              onClick={handleFindReplaceCloseModal}
              className="cursor-pointer opacity-50"
              style={{ height: '28px', width: '28px' }}
            />
          </div>
          <div className="preview-dropdown-body">
            <Row>
              <Col md="12">
                <Form>
                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Find</Form.Label>
                    {isCommonErrors ? (
                      <Form.Select
                        aria-label="Default select example"
                        value={commonErrorsOptionRef?.current}
                        onChange={(e) => {
                          handleChangeCommonErrors(e);
                        }}
                      >
                        <option value="2">Space Space ( )</option>
                        <option value="3">Space and Fullstop ( .)</option>
                        <option value="1">Comma space comma (, ,)</option>
                        <option value="4">Comma comma (,,)</option>
                      </Form.Select>
                    ) : (
                      <Form.Control
                        autoComplete="off"
                        type="text"
                        placeholder="Enter text to find"
                        value={findText}
                        disabled={isReplaceTextDisabledRef?.current}
                        onChange={(e) => {
                          if (e.target.value === '') {
                            findTextArrayRef.current = [];
                            removingUnidentifySpan();
                          }
                          setFindText(e.target.value);
                        }}
                        onKeyDown={(e) => {
                          if (e.keyCode === 13 || e.key === 'Enter') {
                            e.preventDefault();
                          }
                        }}
                      />
                    )}
                  </Form.Group>
                </Form>
              </Col>
              <Col>
                <Form>
                  {['checkbox']?.map((type) => (
                    <div key={`default-${type}`} className="mb-3">
                      <Form.Check
                        checked={isCaseSensitive}
                        type={type}
                        label="Case - Sensitive"
                        name="group1"
                        id={`inline-${type}-1`}
                        onChange={(e) => {
                          const existingHighlightedDescs = document?.querySelectorAll('.highlightedDesc');
                          existingHighlightedDescs?.forEach((element) => {
                            element?.remove();
                          });
                          setIsCaseSensitive(e.target.checked);
                          isCaseSensitiveRef.current = e.target.checked;
                          setIsCommonErrors(false);
                          if (findText && !isFillerWords) {
                            isReplaceTextDisabledRef.current = false;
                            findAndHighlightText(findText);
                          } else {
                            if (isFillerWords) {
                              isReplaceTextDisabledRef.current = true;
                              findFillerWordsInTranscript();
                            }
                          }
                        }}
                      />
                    </div>
                  ))}
                </Form>
              </Col>
              <Col>
                <Form>
                  {['checkbox']?.map((type) => (
                    <div key={`default-${type}`} className="mb-3">
                      <Form.Check
                        checked={isMatchFullWord}
                        type={type}
                        label="Match Full Word"
                        name="group1"
                        id={`inline-${type}-2`}
                        onChange={(e) => {
                          const existingHighlightedDescs = document?.querySelectorAll('.highlightedDesc');
                          existingHighlightedDescs?.forEach((element) => {
                            element?.remove();
                          });
                          setIsMatchFullWord(e.target.checked);
                          isMatchFullWordRef.current = e.target.checked;
                          isReplaceTextDisabledRef.current = false;
                          setIsFillerWords(false);
                          setIsCommonErrors(false);
                          removingUnidentifySpan();
                          const debounceTimer = setTimeout(() => {
                            if (findText) {
                              findAndHighlightText(findText);
                            }
                          }, 300); // 300ms debounce

                          return () => clearTimeout(debounceTimer); // Cleanup the debounce timer
                        }}
                      />
                    </div>
                  ))}
                </Form>
              </Col>
              <Col>
                <Form>
                  {['checkbox']?.map((type) => (
                    <div key={`default-${type}`} className="mb-3">
                      <Form.Check
                        checked={isFillerWords}
                        type={type}
                        label="Filler Words"
                        name="group1"
                        id={`inline-${type}-3`}
                        onChange={(e) => {
                          setIsFillerWords(e.target.checked);
                          handleFillerWordsChange(e);
                        }}
                      />
                    </div>
                  ))}
                </Form>
              </Col>
              <Col md="12" className="my-3">
                <Form>
                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Replace</Form.Label>
                    <Form.Control
                      autoComplete="off"
                      type="text"
                      placeholder="Enter text to replace"
                      value={replaceText} // Bind the Replace input
                      onChange={(e) => {
                        const existingHighlightedDescs = document?.querySelectorAll('.highlightedDesc');
                        existingHighlightedDescs?.forEach((element) => {
                          element?.remove();
                        });
                        setReplaceText(e.target.value);
                        if (e.target.value === '') {
                          setReplacedTextArray([]);
                        }
                      }}
                      disabled={isReplaceTextDisabledRef?.current}
                      onKeyDown={(e) => {
                        if (e.keyCode === 13 || e.key === 'Enter') {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Form.Group>
                </Form>
              </Col>
              <Col md="6" className="mb-4">
                <Form.Label>Original</Form.Label>
                <div className="findreplacebox custom-scroll">
                  <ul className="replaceText orignalUL">
                    {findTextArrayRef?.current?.length > 0 ? (
                      findTextArrayRef?.current?.map((text, index) => (
                        <li
                          key={index}
                          className={`replaceTextItem ${activeIndex === index ? 'active shortDescription' : ''}`}
                          onClick={() => {
                            handleClickReplace(index);
                          }}
                        >
                          <span className="replaceTextLink" dangerouslySetInnerHTML={{ __html: text }} />
                        </li>
                      ))
                    ) : (
                      <div className="replaceTextLink find-replace-no-data">No matches found</div>
                    )}
                  </ul>
                </div>
              </Col>
              <Col md="6" className="mb-4">
                <Form.Label>Result</Form.Label>
                <div className="findreplacebox custom-scroll">
                  <ul className="replaceText resultUL">
                    {replacedTextArray?.length > 0 ? (
                      replacedTextArray?.map((text, index) => (
                        <li
                          key={index}
                          className={`replaceTextItem ${activeIndex === index ? 'active shortDescription' : ''}`}
                        >
                          <span className="replaceTextLink" dangerouslySetInnerHTML={{ __html: text }} />
                        </li>
                      ))
                    ) : (
                      <div className="replaceTextLink find-replace-no-data">No matches found</div>
                    )}
                  </ul>
                </div>
              </Col>
              <Col xs="12" className="d-flex justify-content-between mt-2">
                <Button
                  variant="primary"
                  onClick={(e) => {
                    e.preventDefault();
                    replaceSingleTextInTranscript();
                  }}
                  disabled={
                    singleReplaceSpanIndexRef?.current !== null && !!replacedTextArray && replacedTextArray?.length > 0
                      ? false
                      : true
                  }
                >
                  Replace
                </Button>
                <Button
                  variant="primary"
                  onClick={(e) => {
                    e.preventDefault();
                    replaceAllTextInTranscript();
                  }}
                  disabled={!!replacedTextArray && replacedTextArray?.length > 0 ? false : true}
                >
                  Replace All
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </Modal>
      {/* ==== Keyboard Shortcuts option ==== */}
      <Modal
        show={keyboardShortcutsShow}
        onHide={handleKeyboardShortcutsCloseModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="custom-modal"
      >
        <div>
          <div className="preview-dropdown-header">
            Keyboard Shortcuts
            <HighlightOffRoundedIcon
              onClick={handleKeyboardShortcutsCloseModal}
              className="cursor-pointer opacity-50"
              style={{ height: '28px', width: '28px' }}
            />
          </div>
          <div className="preview-dropdown-body">
            <ul className="shortcut-key-ul pt-2">
              <li className="shortcut-key-list">
                Play/Pause{' '}
                <div>
                  {' '}
                  <span className="shortcut-badge">Tab</span>
                </div>
              </li>
              <li className="shortcut-key-list">
                Skip Forward{' '}
                <div>
                  {' '}
                  <span className="shortcut-badge me-2">F8</span>
                </div>
              </li>
              <li className="shortcut-key-list">
                Rewind{' '}
                <div>
                  <span className="shortcut-badge me-2">Shift</span> +{' '}
                  <span className="shortcut-badge ms-2 w-60">Tab</span>
                </div>
              </li>
              <li className="shortcut-key-list">
                Paste Text{' '}
                <div>
                  <span className="shortcut-badge me-2">Ctrl</span> +{' '}
                  <span className="shortcut-badge ms-2 w-60">V</span>
                </div>
              </li>
              <li className="shortcut-key-list">
                Undo{' '}
                <div>
                  <span className="shortcut-badge me-2">Ctrl</span> +{' '}
                  <span className="shortcut-badge ms-2 w-60">Z</span>
                </div>
              </li>
              <li className="shortcut-key-list">
                Redo{' '}
                <div>
                  <span className="shortcut-badge me-2">Ctrl</span> +{' '}
                  <span className="shortcut-badge ms-2 w-60">Y</span>
                </div>
              </li>
              <li className="shortcut-key-list">
                Save{' '}
                <div>
                  <span className="shortcut-badge me-2">Ctrl</span> +{' '}
                  <span className="shortcut-badge ms-2 w-60">S</span>
                </div>
              </li>
              <li className="shortcut-key-list">
                Copy{' '}
                <div>
                  <span className="shortcut-badge me-2">Ctrl</span> +{' '}
                  <span className="shortcut-badge ms-2 w-60">C</span>
                </div>
              </li>
              <li className="shortcut-key-list">
                Cut{' '}
                <div>
                  <span className="shortcut-badge me-2">Ctrl</span> +{' '}
                  <span className="shortcut-badge ms-2 w-60">X</span>
                </div>
              </li>
              <li className="shortcut-key-list">
                Find and Replace{' '}
                <div>
                  <span className="shortcut-badge me-2">Ctrl</span> +{' '}
                  <span className="shortcut-badge ms-2 w-60">R</span>
                </div>
              </li>
              <li className="shortcut-key-list">
                Mark paragraph as completed{' '}
                <div>
                  <span className="shortcut-badge me-2">Ctrl</span> +{' '}
                  <span className="shortcut-badge ms-2 w-60">M</span>
                </div>
              </li>
              <li className="shortcut-key-list">
                Select next speaker{' '}
                <div>
                  <span className="shortcut-badge me-2">Ctrl</span> +{' '}
                  <span className="shortcut-badge ms-2 w-60">Enter</span>
                </div>
              </li>
              <li className="shortcut-key-list">
                Open speaker selector{' '}
                <div>
                  <span className="shortcut-badge me-2">Ctrl</span> + <span className="shortcut-badge me-2">Shift</span>{' '}
                  + <span className="shortcut-badge ms-2 w-60">Enter</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </Modal>
      {/* ==== Documents option modal==== */}
      <Modal
        show={documentsShow}
        onHide={handleDocumentsCloseModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="custom-modal"
      >
        <div>
          <div className="preview-dropdown-header">
            Resources
            <HighlightOffRoundedIcon
              onClick={handleDocumentsCloseModal}
              className="cursor-pointer opacity-50"
              style={{ height: '28px', width: '28px' }}
            />
          </div>
          <div className="preview-dropdown-body">
            {loadingDocument ? (
              <div className="text-center my-5">
                <Spinner animation="border" />
              </div>
            ) : (
              <>
                {docmentData?.FileGuideDocuments?.length === 0 && docmentData?.ProjectGuideDocuments?.length === 0 && (
                  <div className="text-center my-2">
                    <img src={no_data_img} alt="no_data_img" />
                    <div className="my-4 fw-medium fs-5">No Documents Available to Download</div>
                    <Button variant="primary" onClick={handleDocumentsCloseModal}>
                      Done
                    </Button>
                  </div>
                )}
                {docmentData?.FileGuideDocuments === undefined && docmentData?.ProjectGuideDocuments === undefined && (
                  <div className="text-center my-2">
                    <img src={no_data_img} alt="no_data_img" />
                    <div className="my-4 fw-medium fs-5">No Documents Available to Download</div>
                    <Button variant="primary" onClick={handleDocumentsCloseModal}>
                      Done
                    </Button>
                  </div>
                )}
                {docmentData?.FileGuideDocuments?.length !== 0 &&
                  docmentData?.FileGuideDocuments !== null &&
                  docmentData?.FileGuideDocuments !== undefined && (
                    <div className="bb-1 mb-3 py-3">
                      <div className="fnt-18 fw-medium">File Guides</div>
                      <ul className="mb-2 mt-3 list-number">
                        {docmentData?.FileGuideDocuments?.map((data, index) => (
                          <li className="row mb-2" key={index}>
                            <div className="col-10">
                              <div className="fnt-16 fw-medium opacity-70">
                                {index + 1}. {data?.DocumentName}
                              </div>
                            </div>
                            <div className="col-2 d-flex justify-content-end">
                              <div
                                className="fileDownloadicon"
                                onClick={() => {
                                  handleDownloadAndViewDocument({
                                    pathName: data?.FilePath,
                                    fileName: data?.DocumentName?.trim(),
                                  });
                                }}
                              >
                                <FileDownloadOutlinedIcon />
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                {docmentData?.ProjectGuideDocuments?.length !== 0 &&
                  docmentData?.ProjectGuideDocuments !== null &&
                  docmentData?.ProjectGuideDocuments !== undefined && (
                    <div className="mb-3 py-3">
                      <div className="fnt-18 fw-medium">Project Guides</div>
                      <ul className="mb-2 mt-3 list-number">
                        {docmentData?.ProjectGuideDocuments?.map((data, index) => (
                          <li className="row mb-2" key={index}>
                            <div className="col-10">
                              <div className="fnt-16 fw-medium opacity-70">
                                {index + 1}. {data?.DocumentName}
                              </div>
                            </div>
                            <div className="col-2 d-flex justify-content-end">
                              <div
                                className="fileDownloadicon"
                                onClick={() => {
                                  handleDownloadAndViewDocument({
                                    pathName: data?.FilePath,
                                    fileName: data?.DocumentName?.trim(),
                                  });
                                }}
                              >
                                <FileDownloadOutlinedIcon />
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
              </>
            )}
          </div>
        </div>
      </Modal>
      {/* ==== Unclaim modal ==== */}
      <Modal
        show={unclaimShow}
        onHide={unclaimHideModal}
        aria-labelledby="contained-modal-title-vcenter"
        size="md"
        centered
        dialogClassName="custom-modal"
      >
        <div>
          <div
            style={{
              padding: '20px 20px 0 20px',
              textAlign: 'end',
            }}
          >
            <HighlightOffRoundedIcon
              onClick={unclaimHideModal}
              className="cursor-pointer opacity-50"
              style={{ height: '28px', width: '28px' }}
            />
          </div>
          <div className="preview-dropdown-body">
            <h2 className="text-center">Are You Sure?</h2>
            <p className="opacity-70 fnt-20 fw-medium text-center">Are you sure you want to Unclaim this File?</p>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmitProofreaderClaim}
              validateOnBlur={false}
              validateOnChange={false}
            >
              {({ values, errors, touched }) => (
                <FormikForm>
                  <div className="preview-dropdown-body">
                    <Field
                      as="textarea"
                      name="unclaimReasonText"
                      placeholder="Please provide the reason for unclaiming"
                      className="form-control"
                      style={{ height: '100px' }}
                      autoComplete="off"
                    />
                    {errors.unclaimReasonText && touched.unclaimReasonText && (
                      <div className="text-danger mt-1">{errors.unclaimReasonText}</div>
                    )}
                    <div
                      className="mt-3"
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Button
                        className="w160"
                        variant="outline-danger"
                        onClick={unclaimHideModal}
                        style={{
                          height: '45.49px',
                          borderRadius: '6px',
                          padding: '11px 28px',
                          fontSize: '14px',
                          fontWeight: 600,
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="primary"
                        className="w160"
                        disabled={values?.unclaimReasonText === ''}
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </FormikForm>
              )}
            </Formik>
          </div>
        </div>
      </Modal>
      {/* ==== Aleart Modal ==== */}
      <Modal
        show={warningShow}
        onHide={handleWarningCloseModal}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        dialogClassName="custom-modal"
      >
        <div className="preview-dropdown-body">
          <Row>
            <Col md="12" className="text-center mt-4">
              <img src={alert_icon} alt="alert_icon" style={{ height: '220px', width: '300px' }} />
            </Col>
            <Col md="12" className="text-center mt-4">
              This vendor is at Level 1. Ensure you review the entire transcript before submitting it to the client.
            </Col>
            <Col md="12" className="text-center mt-4 mb-3">
              <Button variant="primary" onClick={handleWarningCloseModal}>
                Okay
              </Button>
            </Col>
          </Row>
        </div>
      </Modal>
      {/* ==== Dropdown Menu Component ==== */}
      <Dropdown
        as={NavItem}
        show={dropdownOpen}
        onToggle={() => {
          handleToggleSpeakerDropdown();
          setErrorSpeakerNamePopup('');
          inputRef.current = null;
          const spekerLabel = document?.getElementById('txtSpeakerLabel_speaker');
          if (spekerLabel) {
            document.getElementById('txtSpeakerLabel_speaker').value = '';
          }
        }}
        style={{
          position: 'absolute',
          top: dropdownPosition.top,
          left: dropdownPosition.left,
          zIndex: !!dropdownPosition.zIndex ? 10 : 0,
        }}
        ref={dropdownRef}
      >
        <Dropdown.Toggle as={NavLink} className="nav-user"></Dropdown.Toggle>
        <Dropdown.Menu className="file-toggle-box">
          <div className="speaktoedit-toggle-box">
            <div className="speaktoedit-header">
              <h6 className="fnt-16 font-weight-bold mb-0">Speakers</h6>
              <div style={{ display: 'flex' }}>
                <div className="form-check speak-checkbox clcbx mr-3">
                  <input
                    disabled={!isAllTranscriptLoad}
                    className="form-check-input"
                    type="checkbox"
                    value=""
                    name="cl2"
                    id="cl2_speaker"
                  />
                  <label className="form-check-label" htmlFor="cl2_speaker" style={{ fontSize: '13px' }}>
                    Apply to all
                  </label>
                </div>
                <div id="closedSpeakerModel">
                  <HighlightOffRoundedIcon
                    id="closedSpeakerModel"
                    className="cursor-pointer opacity-50"
                    style={{ height: '28px', width: '28px', marginLeft: '5px' }}
                    onClick={() => {
                      setDropdownOpen(false);
                      dropdownOpenRef.current = false;
                      setErrorSpeakerNamePopup('');
                      inputRef.current = null;
                      document.getElementById('txtSpeakerLabel_speaker').value = '';
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="speaktoedit-body">
              <input
                ref={inputRef}
                className="form-control speaktoedit-control mt-0"
                type="text"
                placeholder="Speaker Name"
                id="txtSpeakerLabel_speaker"
                autoComplete="off"
                onFocus={() => {
                  if (errorSpeakerNamePopup?.length !== 0) {
                    handleSpeakerInputFocus();
                  }
                }}
                onBlur={() => {
                  if (errorSpeakerNamePopup?.length !== 0) {
                    handleSpeakerInputBlur();
                  }
                }}
                onKeyDown={(event) => {
                  setSpeakerNameCreate(true);
                  if ((event.key === 'Enter' || event.code === 'Enter') && errorSpeakerNamePopup?.length !== 0) {
                    if (document?.getElementById('txtSpeakerLabel_speaker')?.value?.trim() !== '') {
                      applySpeakerLabelChanges();
                    }
                  }
                }}
                onChange={(event) => {
                  if (document?.getElementById('txtSpeakerLabel_speaker')?.value?.trim() === '') {
                    setErrorSpeakerNamePopup(event.target.value?.trim());
                  } else {
                    setErrorSpeakerNamePopup(event.target.value);
                  }
                  speakerName.current = event.target.value.trim();
                }}
              />
              {errorSpeakerNamePopup === '' && speakerNameCreate && (
                <div style={{ color: 'red', marginTop: '8px' }}>Speaker Name is required.</div>
              )}
              {errorSpeakerNamePopup === 'Speaker name already exists.' && speakerNameCreate && (
                <div style={{ color: 'red', marginTop: '8px' }}>Speaker name already exists.</div>
              )}
              <div className="speaktoedit-speak-main">
                <h6 className="fnt-16 font-weight-bold mb-2">Other Speakers</h6>
                <ul
                  className="speaktoedit-wrap allSpeakers custom-scroll"
                  style={{ overflow: 'auto', maxHeight: '112px' }}
                >
                  {allSpeakersRef?.current &&
                    allSpeakersRef?.current?.map((speaker, i) => {
                      const spkCount = Math?.floor(1000 + Math.random() * 9000);
                      const clscolor = i % 2 === 0 ? 'colorSP1' : 'colorSP2';

                      return (
                        <li
                          style={{ cursor: 'pointer' }}
                          key={spkCount}
                          className="speaktoedit-list spklbl d-flex align-items-center"
                          data-attr={spkCount}
                          onClick={(e) => {
                            const inputField = document?.getElementById('txtSpeakerLabel_speaker');
                            if (inputField) {
                              inputField.value = speaker;
                            }
                            applySpeakerLabelChanges();
                          }}
                        >
                          <div className={`avatar-icon-text ${clscolor}`}>{speaker?.substr(0, 1)?.toUpperCase()}</div>
                          <div className="fnt-14 font-weight-bold">{speaker}</div>
                        </li>
                      );
                    })}
                </ul>
              </div>
            </div>
            <div className="speaktoedit-footer" style={{ justifyContent: 'end' }}>
              {errorSpeakerNamePopup?.length === 0 || errorSpeakerNamePopup === 'Speaker name already exists.' ? (
                <button disabled className="btn btn-primary fnt-14 py-1 font-weight-bold">
                  Create
                </button>
              ) : (
                <a
                  className="btn btn-primary fnt-14 py-1 font-weight-bold cursor-pointer"
                  id="createSpeakerLabel"
                  onClick={() => {
                    if (errorSpeakerNamePopup?.length !== 0) {
                      applySpeakerLabelChanges();
                    }
                  }}
                >
                  Create
                </a>
              )}
            </div>
          </div>
        </Dropdown.Menu>
      </Dropdown>
      <Modal
        show={vendorSubmitConfirmModal}
        onHide={() => setVendorSubmitConfirmModal(false)}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div className="preview-dropdown-body my-4">
          <div className="text-center fs-5 fw-semibold">Are You Sure?</div>
          <div className="text-center mt-3">You want to submit this file?</div>
          {vendorProofreaderCommentData?.ProofReaderComments[0]?.isResolved === false && (
            <>
              {vendorProofreaderCommentData?.ProofReaderComments?.map((data, index) => (
                <div key={index} className="mt-3">
                  <div className="fw-medium">Comment By Proofreader :</div>
                  <div>"{data?.Comment}"</div>
                </div>
              ))}
              <div className="d-flex align-items-center mt-3">
                <Form.Check
                  type="checkbox"
                  checked={confiemResolved}
                  onChange={() => setConfiemResolved((prev) => !prev)}
                />{' '}
                <span className="ms-2">I confirm that this comment is resolved.</span>
              </div>
            </>
          )}
          <div className="fw-medium mt-3">Note to Proofreader :</div>
          <div>
            <textarea
              rows="3"
              className="opacity-70 notesItem"
              value={VendorNotesData}
              onChange={(e) => setVendorNotesData(e.target.value)}
              style={{
                height: '100%',
                width: '100%',
              }}
            />
          </div>
          <div className="text-center mt-3">
            <Button variant="outline-danger" onClick={() => setVendorSubmitConfirmModal(false)}>
              Cancel
            </Button>
            {vendorProofreaderCommentData?.ProofReaderComments[0]?.isResolved === false ? (
              <button
                className="confirm-modal-submit"
                onClick={() => {
                  if (id === null) {
                    navigate(DASHBOARD_ROUTE);
                  } else {
                    let params = {
                      audioFileId: id,
                      userId: userInfo?.UserId,
                      note: VendorNotesData,
                      SubmittedOn: formatDateWithMilliseconds(),
                    };
                    if (editorDetailsData) {
                      dispatch(VendorRoleEditorSubmitRequest(params));
                    }
                    setVendorSubmitConfirmModal(false);
                    setConfiemResolved(false);
                  }
                }}
                disabled={confiemResolved === false}
              >
                Yes
              </button>
            ) : (
              <button
                className="confirm-modal-submit"
                onClick={() => {
                  if (id === null) {
                    navigate(DASHBOARD_ROUTE);
                  } else {
                    let params = {
                      audioFileId: id,
                      userId: userInfo?.UserId,
                      note: VendorNotesData,
                      SubmittedOn: formatDateWithMilliseconds(),
                    };
                    if (editorDetailsData) {
                      dispatch(VendorRoleEditorSubmitRequest(params));
                    }
                    setVendorSubmitConfirmModal(false);
                    setConfiemResolved(false);
                  }
                }}
              >
                Yes
              </button>
            )}
          </div>
        </div>
      </Modal>
      <Modal
        show={isUnsavedChangesModalVisible}
        onHide={() => setIsUnsavedChangesModalVisible(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>Unsaved Changes</Modal.Title>
        </Modal.Header>
        <Modal.Body>You have unsaved changes. Would you like to save before leaving the page?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDiscardAndLeave}>
            Discard and Leave
          </Button>
          <Button variant="primary" onClick={handleSaveAndStay}>
            Save and Stay
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={isContinueKeyPressModalVisible}
        onHide={() => setIsContinueKeyPressModalVisible(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>Alert !</Modal.Title>
        </Modal.Header>
        <Modal.Body>You cannot continue hold down any key on the keyboard.</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setIsContinueKeyPressModalVisible(false)}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </span>
  );
};

export default EditorPage;
